function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (m, E) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == "object" && typeof module != "undefined" ? E(exports, require("react"), require("react-jss"), require("@mantine/hooks"), require("react-dom")) : typeof define == "function" && define.amd ? define(["exports", "react", "react-jss", "@mantine/hooks", "react-dom"], E) : (m = typeof globalThis != "undefined" ? globalThis : m || self, E(m["@mantine/core"] = {}, m.React, m.reactJss, m["@mantine/hooks"], m.ReactDOM));
})(this, function (m, E, Le, V, qt) {
  "use strict";

  function Ut(e) {
    return e && _typeof(e) == "object" && "default" in e ? e.default : e;
  }

  var l = Ut(E),
      ht = Ut(qt);

  function L(e) {
    var r = Le.createUseStyles(e);
    return function (o) {
      var a = _typeof(o) == "object" && o !== null ? Object.keys(o).filter(function (i) {
        return i !== "theme";
      }).map(function (i) {
        return o[i];
      }) : [];
      _typeof(o) == "object" && "theme" in o && a.push(o.theme.colorScheme);
      var n = E.useMemo(function () {
        return o;
      }, a);
      return r(n);
    };
  }

  function w(_ref) {
    var e = _ref.theme,
        r = _ref.color,
        t = _ref.shade;
    var o = e.colors[e.primaryColor];
    return r in e.colors ? e.colors[r][t] : o[t];
  }

  function ae(e) {
    return {
      "&:focus": {
        outline: "none",
        boxShadow: "0 0 0 2px ".concat(e.colorScheme === "dark" ? e.colors.dark[9] : e.white, ", 0 0 0 4px ").concat(e.colors[e.primaryColor][e.colorScheme === "dark" ? 7 : 5])
      },
      "&:focus:not(:focus-visible)": {
        boxShadow: "none"
      }
    };
  }

  function Q(e) {
    return {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      fontFamily: e.fontFamily || "sans-serif"
    };
  }

  function _(_ref2) {
    var e = _ref2.size,
        r = _ref2.sizes,
        _ref2$defaultSize = _ref2.defaultSize,
        t = _ref2$defaultSize === void 0 ? "md" : _ref2$defaultSize;
    return typeof e == "number" ? e : r[e] || e || r[t];
  }

  function re(e, r) {
    if (!e || typeof r != "number" || r > 1 || r < 0) return "";
    var t = e.replace("#", "");
    if (t.length !== 6) return "";
    var o = parseInt(t, 16),
        a = o >> 16 & 255,
        n = o >> 8 & 255,
        i = o & 255;
    return "rgba(".concat(a, ", ").concat(n, ", ").concat(i, ", ").concat(r, ")");
  }

  var Gt = {
    dark: ["#d5d7e0", "#acaebf", "#8c8fa3", "#666980", "#4d4f66", "#34354a", "#2b2c3d", "#1d1e30", "#0c0d21", "#01010a"],
    gray: ["#f8f9fa", "#f1f3f5", "#e9ecef", "#dee2e6", "#ced4da", "#adb5bd", "#868e96", "#495057", "#343a40", "#212529"],
    red: ["#fff5f5", "#ffe3e3", "#ffc9c9", "#ffa8a8", "#ff8787", "#ff6b6b", "#fa5252", "#f03e3e", "#e03131", "#c92a2a"],
    pink: ["#fff0f6", "#ffdeeb", "#fcc2d7", "#faa2c1", "#f783ac", "#f06595", "#e64980", "#d6336c", "#c2255c", "#a61e4d"],
    grape: ["#f8f0fc", "#f3d9fa", "#eebefa", "#e599f7", "#da77f2", "#cc5de8", "#be4bdb", "#ae3ec9", "#9c36b5", "#862e9c"],
    violet: ["#f3f0ff", "#e5dbff", "#d0bfff", "#b197fc", "#9775fa", "#845ef7", "#7950f2", "#7048e8", "#6741d9", "#5f3dc4"],
    indigo: ["#edf2ff", "#dbe4ff", "#bac8ff", "#91a7ff", "#748ffc", "#5c7cfa", "#4c6ef5", "#4263eb", "#3b5bdb", "#364fc7"],
    blue: ["#e7f5ff", "#d0ebff", "#a5d8ff", "#74c0fc", "#4dabf7", "#339af0", "#228be6", "#1c7ed6", "#1971c2", "#1864ab"],
    cyan: ["#e3fafc", "#c5f6fa", "#99e9f2", "#66d9e8", "#3bc9db", "#22b8cf", "#15aabf", "#1098ad", "#0c8599", "#0b7285"],
    teal: ["#e6fcf5", "#c3fae8", "#96f2d7", "#63e6be", "#38d9a9", "#20c997", "#12b886", "#0ca678", "#099268", "#087f5b"],
    green: ["#ebfbee", "#d3f9d8", "#b2f2bb", "#8ce99a", "#69db7c", "#51cf66", "#40c057", "#37b24d", "#2f9e44", "#2b8a3e"],
    lime: ["#f4fce3", "#e9fac8", "#d8f5a2", "#c0eb75", "#a9e34b", "#94d82d", "#82c91e", "#74b816", "#66a80f", "#5c940d"],
    yellow: ["#fff9db", "#fff3bf", "#ffec99", "#ffe066", "#ffd43b", "#fcc419", "#fab005", "#f59f00", "#f08c00", "#e67700"],
    orange: ["#fff4e6", "#ffe8cc", "#ffd8a8", "#ffc078", "#ffa94d", "#ff922b", "#fd7e14", "#f76707", "#e8590c", "#d9480f"]
  },
      jc = Object.keys(Gt),
      Rc = ["xs", "sm", "md", "lg", "xl"],
      He = {
    colorScheme: "light",
    white: "#fff",
    black: "#000",
    transitionTimingFunction: "cubic-bezier(.51,.3,0,1.21)",
    colors: Gt,
    lineHeight: 1.4,
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontFamilyMonospace: "Menlo, Monaco, Lucida Console, monospace",
    primaryColor: "blue",
    shadows: {
      xs: "0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1)",
      sm: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 10px 15px -5px, rgba(0, 0, 0, 0.04) 0px 7px 7px -5px",
      md: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
      lg: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 28px 23px -7px, rgba(0, 0, 0, 0.04) 0px 12px 12px -7px",
      xl: "0 1px 3px rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0px 36px 28px -7px, rgba(0, 0, 0, 0.04) 0px 17px 17px -7px"
    },
    fontSizes: {
      xs: 12,
      sm: 14,
      md: 16,
      lg: 18,
      xl: 20
    },
    radius: {
      xs: 2,
      sm: 4,
      md: 8,
      lg: 16,
      xl: 32
    },
    spacing: {
      xs: 10,
      sm: 12,
      md: 16,
      lg: 20,
      xl: 24
    },
    headings: {
      fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
      fontWeight: 700,
      sizes: {
        h1: {
          fontSize: 34,
          lineHeight: 1.3
        },
        h2: {
          fontSize: 26,
          lineHeight: 1.35
        },
        h3: {
          fontSize: 22,
          lineHeight: 1.4
        },
        h4: {
          fontSize: 18,
          lineHeight: 1.45
        },
        h5: {
          fontSize: 16,
          lineHeight: 1.5
        },
        h6: {
          fontSize: 14,
          lineHeight: 1.5
        }
      }
    }
  };

  var Tc = Object.defineProperty,
      zc = Object.defineProperties,
      Dc = Object.getOwnPropertyDescriptors,
      Kt = Object.getOwnPropertySymbols,
      Mc = Object.prototype.hasOwnProperty,
      Ac = Object.prototype.propertyIsEnumerable,
      Xt = function Xt(e, r, t) {
    return r in e ? Tc(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      fe = function fe(e, r) {
    for (var t in r || (r = {})) {
      Mc.call(r, t) && Xt(e, t, r[t]);
    }

    if (Kt) {
      var _iterator = _createForOfIteratorHelper(Kt(r)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          Ac.call(r, t) && Xt(e, t, r[t]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return e;
  },
      Jt = function Jt(e, r) {
    return zc(e, Dc(r));
  };

  function wt(e, r) {
    return r ? Object.keys(e).reduce(function (t, o) {
      if (o === "headings" && r.headings) {
        var a = r.headings.sizes ? Object.keys(e.headings.sizes).reduce(function (n, i) {
          return n[i] = fe(fe({}, e.headings.sizes[i]), r.headings.sizes[i]), n;
        }, {}) : e.headings.sizes;
        return Jt(fe({}, t), {
          headings: Jt(fe(fe({}, e.headings), r.headings), {
            sizes: a
          })
        });
      }

      return t[o] = _typeof(r[o]) == "object" ? fe(fe({}, e[o]), r[o]) : r[o] || e[o], t;
    }, {}) : e;
  }

  var Lc = E.createContext(He),
      Qt = Le.createTheming(Lc),
      Hc = Qt.ThemeProvider,
      Vc = Qt.useTheme;

  var Bc = Object.defineProperty,
      eo = Object.getOwnPropertySymbols,
      Fc = Object.prototype.hasOwnProperty,
      Wc = Object.prototype.propertyIsEnumerable,
      ro = function ro(e, r, t) {
    return r in e ? Bc(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Zc = function Zc(e, r) {
    for (var t in r || (r = {})) {
      Fc.call(r, t) && ro(e, t, r[t]);
    }

    if (eo) {
      var _iterator2 = _createForOfIteratorHelper(eo(r)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var t = _step2.value;
          Wc.call(r, t) && ro(e, t, r[t]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    return e;
  };

  function to(_ref3) {
    var e = _ref3.children,
        r = _ref3.theme;
    return l.createElement(Hc, {
      theme: wt(Zc({
        __mantine_theme: !0
      }, He), r)
    }, e);
  }

  to.displayName = "@mantine/Provider";

  var Yc = Object.defineProperty,
      oo = Object.getOwnPropertySymbols,
      qc = Object.prototype.hasOwnProperty,
      Uc = Object.prototype.propertyIsEnumerable,
      ao = function ao(e, r, t) {
    return r in e ? Yc(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      no = function no(e, r) {
    for (var t in r || (r = {})) {
      qc.call(r, t) && ao(e, t, r[t]);
    }

    if (oo) {
      var _iterator3 = _createForOfIteratorHelper(oo(r)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var t = _step3.value;
          Uc.call(r, t) && ao(e, t, r[t]);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    return e;
  };

  function j(e) {
    var r = no({}, Vc());
    var t = null;
    return r.__mantine_theme ? t = wt(r, e) : t = wt(no({
      __mantine_theme: !0
    }, He), e), delete t.__mantine_theme, t;
  }

  function io(e) {
    var r,
        t,
        o = "";
    if (typeof e == "string" || typeof e == "number") o += e;else if (_typeof(e) == "object") if (Array.isArray(e)) for (r = 0; r < e.length; r++) {
      e[r] && (t = io(e[r])) && (o && (o += " "), o += t);
    } else for (r in e) {
      e[r] && (o && (o += " "), o += r);
    }
    return o;
  }

  function P() {
    for (var e = 0, r, t, o = ""; e < arguments.length;) {
      (r = arguments[e++]) && (t = io(r)) && (o && (o += " "), o += t);
    }

    return o;
  }

  var Gc = Object.defineProperty,
      Kc = Object.defineProperties,
      Xc = Object.getOwnPropertyDescriptors,
      lo = Object.getOwnPropertySymbols,
      Jc = Object.prototype.hasOwnProperty,
      Qc = Object.prototype.propertyIsEnumerable,
      so = function so(e, r, t) {
    return r in e ? Gc(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      co = function co(e, r) {
    for (var t in r || (r = {})) {
      Jc.call(r, t) && so(e, t, r[t]);
    }

    if (lo) {
      var _iterator4 = _createForOfIteratorHelper(lo(r)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var t = _step4.value;
          Qc.call(r, t) && so(e, t, r[t]);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    return e;
  },
      ed = function ed(e, r) {
    return Kc(e, Xc(r));
  };

  var Ee = {
    xs: 18,
    sm: 22,
    md: 28,
    lg: 34,
    xl: 44
  };

  var rd = L({
    filled: function filled(_ref4) {
      var e = _ref4.theme,
          r = _ref4.color;
      return {
        backgroundColor: re(w({
          theme: e,
          color: r,
          shade: 7
        }), e.colorScheme === "dark" ? .65 : 1),
        color: e.white,
        "&:not(:disabled):hover": {
          backgroundColor: re(w({
            theme: e,
            color: r,
            shade: 8
          }), e.colorScheme === "dark" ? .95 : 1)
        },
        "&:disabled": {
          backgroundColor: w({
            theme: e,
            color: "gray",
            shade: e.colorScheme === "dark" ? 8 : 1
          })
        }
      };
    },
    light: function light(_ref5) {
      var e = _ref5.theme,
          r = _ref5.color;
      return {
        backgroundColor: re(w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 9 : 0
        }), e.colorScheme === "dark" ? .3 : 1),
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 3 : 9
        }),
        "&:not(:disabled):hover": {
          backgroundColor: re(w({
            theme: e,
            color: r,
            shade: e.colorScheme === "dark" ? 8 : 1
          }), e.colorScheme === "dark" ? .65 : 1)
        },
        "&:disabled": {
          backgroundColor: w({
            theme: e,
            color: "gray",
            shade: e.colorScheme === "dark" ? 8 : 1
          })
        }
      };
    },
    hover: function hover(_ref6) {
      var e = _ref6.theme,
          r = _ref6.color;
      return {
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 5 : 7
        }),
        backgroundColor: "transparent",
        "&:not(:disabled):hover": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[8] : w({
            theme: e,
            color: r,
            shade: 0
          })
        }
      };
    },
    transparent: function transparent(_ref7) {
      var e = _ref7.theme,
          r = _ref7.color;
      return {
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 5 : 7
        }),
        backgroundColor: "transparent"
      };
    },
    actionIcon: function actionIcon(_ref8) {
      var e = _ref8.radius,
          r = _ref8.theme,
          t = _ref8.size;
      return ed(co(co({}, ae(r)), Q(r)), {
        appearance: "none",
        WebkitAppearance: "none",
        WebkitTapHighlightColor: "transparent",
        border: "1px solid transparent",
        boxSizing: "border-box",
        height: _({
          size: t,
          sizes: Ee
        }),
        minHeight: _({
          size: t,
          sizes: Ee
        }),
        width: _({
          size: t,
          sizes: Ee
        }),
        minWidth: _({
          size: t,
          sizes: Ee
        }),
        borderRadius: _({
          size: e,
          sizes: r.radius
        }),
        padding: 0,
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "color 100ms ease, background-color 100ms ease",
        "&:not(:disabled):active": {
          transform: "translateY(1px)"
        },
        "&:disabled": {
          color: r.colors.gray[r.colorScheme === "dark" ? 6 : 4],
          cursor: "not-allowed"
        }
      });
    },
    outline: function outline(_ref9) {
      var e = _ref9.theme,
          r = _ref9.color;
      return {
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 4 : 8
        }),
        backgroundColor: "transparent",
        border: "1px solid ".concat(re(w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 3 : 4
        }), e.colorScheme === "dark" ? .45 : 1)),
        "&:not(:disabled):hover": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[8] : w({
            theme: e,
            color: r,
            shade: 0
          })
        },
        "&:disabled": {
          borderColor: e.colors.gray[e.colorScheme === "dark" ? 7 : 3]
        }
      };
    }
  }),
      td = Object.defineProperty,
      od = Object.defineProperties,
      ad = Object.getOwnPropertyDescriptors,
      Ve = Object.getOwnPropertySymbols,
      fo = Object.prototype.hasOwnProperty,
      po = Object.prototype.propertyIsEnumerable,
      uo = function uo(e, r, t) {
    return r in e ? td(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      nd = function nd(e, r) {
    for (var t in r || (r = {})) {
      fo.call(r, t) && uo(e, t, r[t]);
    }

    if (Ve) {
      var _iterator5 = _createForOfIteratorHelper(Ve(r)),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var t = _step5.value;
          po.call(r, t) && uo(e, t, r[t]);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }

    return e;
  },
      id = function id(e, r) {
    return od(e, ad(r));
  },
      ld = function ld(e, r) {
    var t = {};

    for (var o in e) {
      fo.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Ve) {
      var _iterator6 = _createForOfIteratorHelper(Ve(e)),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var o = _step6.value;
          r.indexOf(o) < 0 && po.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }

    return t;
  };

  var sd = Ee;

  function pe(e) {
    var r = e,
        t = r.className,
        _r$color = r.color,
        o = _r$color === void 0 ? "gray" : _r$color,
        a = r.children,
        _r$radius = r.radius,
        n = _r$radius === void 0 ? "sm" : _r$radius,
        _r$size = r.size,
        i = _r$size === void 0 ? "md" : _r$size,
        _r$variant = r.variant,
        s = _r$variant === void 0 ? "hover" : _r$variant,
        c = r.themeOverride,
        d = r.elementRef,
        _r$component = r.component,
        f = _r$component === void 0 ? "button" : _r$component,
        p = ld(r, ["className", "color", "children", "radius", "size", "variant", "themeOverride", "elementRef", "component"]);
    var u = rd({
      size: i,
      radius: n,
      color: o,
      theme: j(c)
    });
    return l.createElement(f, id(nd({}, p), {
      className: P(u.actionIcon, u[s], t),
      type: "button",
      ref: d
    }), a);
  }

  pe.displayName = "@mantine/core/ActionIcon";

  var cd = Object.defineProperty,
      dd = Object.defineProperties,
      fd = Object.getOwnPropertyDescriptors,
      vo = Object.getOwnPropertySymbols,
      pd = Object.prototype.hasOwnProperty,
      ud = Object.prototype.propertyIsEnumerable,
      mo = function mo(e, r, t) {
    return r in e ? cd(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      go = function go(e, r) {
    for (var t in r || (r = {})) {
      pd.call(r, t) && mo(e, t, r[t]);
    }

    if (vo) {
      var _iterator7 = _createForOfIteratorHelper(vo(r)),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var t = _step7.value;
          ud.call(r, t) && mo(e, t, r[t]);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }

    return e;
  },
      vd = function vd(e, r) {
    return dd(e, fd(r));
  },
      md = L({
    text: function text(_ref10) {
      var e = _ref10.theme,
          r = _ref10.color,
          t = _ref10.variant,
          o = _ref10.size;
      return vd(go(go({}, Q(e)), ae(e)), {
        color: r in e.colors ? e.colors[r][e.colorScheme === "dark" ? 4 : 6] : t === "link" ? e.colors[e.primaryColor][e.colorScheme === "dark" ? 4 : 6] : e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        fontSize: e.fontSizes[o],
        lineHeight: e.lineHeight,
        textDecoration: "none",
        WebkitTapHighlightColor: "transparent",
        "&:hover": {
          textDecoration: t === "link" ? "underline" : "none"
        }
      });
    }
  }),
      gd = Object.defineProperty,
      Be = Object.getOwnPropertySymbols,
      _o = Object.prototype.hasOwnProperty,
      yo = Object.prototype.propertyIsEnumerable,
      bo = function bo(e, r, t) {
    return r in e ? gd(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Pt = function Pt(e, r) {
    for (var t in r || (r = {})) {
      _o.call(r, t) && bo(e, t, r[t]);
    }

    if (Be) {
      var _iterator8 = _createForOfIteratorHelper(Be(r)),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var t = _step8.value;
          yo.call(r, t) && bo(e, t, r[t]);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }

    return e;
  },
      Oo = function Oo(e, r) {
    var t = {};

    for (var o in e) {
      _o.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Be) {
      var _iterator9 = _createForOfIteratorHelper(Be(e)),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var o = _step9.value;
          r.indexOf(o) < 0 && yo.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }

    return t;
  };

  function ne(e) {
    var r = e,
        t = r.className,
        _r$component2 = r.component,
        o = _r$component2 === void 0 ? "div" : _r$component2,
        a = r.children,
        _r$size2 = r.size,
        n = _r$size2 === void 0 ? "md" : _r$size2,
        i = r.weight,
        s = r.transform,
        c = r.style,
        d = r.color,
        f = r.align,
        _r$variant2 = r.variant,
        p = _r$variant2 === void 0 ? "text" : _r$variant2,
        u = r.themeOverride,
        g = r.elementRef,
        y = Oo(r, ["className", "component", "children", "size", "weight", "transform", "style", "color", "align", "variant", "themeOverride", "elementRef"]);
    var b = md({
      variant: p,
      color: d,
      size: n,
      theme: j(u)
    });
    return l.createElement(o, Pt({
      className: P(b.text, t),
      style: Pt({
        fontWeight: i,
        textTransform: s,
        textAlign: f
      }, c),
      ref: g
    }, y), a);
  }

  ne.displayName = "@mantine/core/Text";

  function ho(e) {
    var r = e,
        _r$component3 = r.component,
        t = _r$component3 === void 0 ? "a" : _r$component3,
        o = Oo(r, ["component"]);
    return l.createElement(ne, Pt({
      component: t,
      variant: "link"
    }, o));
  }

  ho.displayName = "@mantine/core/Anchor";

  var _d = L({
    paper: function paper(_ref11) {
      var e = _ref11.theme,
          r = _ref11.radius,
          t = _ref11.shadow,
          o = _ref11.padding;
      return {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
        boxSizing: "border-box",
        borderRadius: _({
          size: r,
          sizes: e.radius
        }),
        boxShadow: e.shadows[t] || t || "none",
        padding: _({
          size: o,
          sizes: e.spacing
        })
      };
    }
  }),
      yd = Object.defineProperty,
      Fe = Object.getOwnPropertySymbols,
      wo = Object.prototype.hasOwnProperty,
      Po = Object.prototype.propertyIsEnumerable,
      $o = function $o(e, r, t) {
    return r in e ? yd(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      bd = function bd(e, r) {
    for (var t in r || (r = {})) {
      wo.call(r, t) && $o(e, t, r[t]);
    }

    if (Fe) {
      var _iterator10 = _createForOfIteratorHelper(Fe(r)),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var t = _step10.value;
          Po.call(r, t) && $o(e, t, r[t]);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }

    return e;
  },
      Od = function Od(e, r) {
    var t = {};

    for (var o in e) {
      wo.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Fe) {
      var _iterator11 = _createForOfIteratorHelper(Fe(e)),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var o = _step11.value;
          r.indexOf(o) < 0 && Po.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }

    return t;
  };

  function ce(e) {
    var r = e,
        t = r.className,
        o = r.children,
        _r$padding = r.padding,
        a = _r$padding === void 0 ? 0 : _r$padding,
        _r$radius2 = r.radius,
        n = _r$radius2 === void 0 ? "sm" : _r$radius2,
        i = r.shadow,
        s = r.themeOverride,
        c = r.elementRef,
        d = Od(r, ["className", "children", "padding", "radius", "shadow", "themeOverride", "elementRef"]);

    var f = _d({
      radius: n,
      shadow: i,
      padding: a,
      theme: j(s)
    });

    return l.createElement("div", bd({
      className: P(f.paper, t),
      ref: c
    }, d), o);
  }

  ce.displayName = "@mantine/core/Paper";

  var hd = Object.defineProperty,
      wd = Object.defineProperties,
      Pd = Object.getOwnPropertyDescriptors,
      So = Object.getOwnPropertySymbols,
      $d = Object.prototype.hasOwnProperty,
      Sd = Object.prototype.propertyIsEnumerable,
      Eo = function Eo(e, r, t) {
    return r in e ? hd(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Ed = function Ed(e, r) {
    for (var t in r || (r = {})) {
      $d.call(r, t) && Eo(e, t, r[t]);
    }

    if (So) {
      var _iterator12 = _createForOfIteratorHelper(So(r)),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var t = _step12.value;
          Sd.call(r, t) && Eo(e, t, r[t]);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }

    return e;
  },
      xd = function xd(e, r) {
    return wd(e, Pd(r));
  };

  var $t = 4;

  var Cd = L({
    alert: function alert(_ref12) {
      var e = _ref12.color,
          r = _ref12.theme;
      return {
        position: "relative",
        padding: [r.spacing.xs, r.spacing.md],
        paddingLeft: r.spacing.md + r.spacing.xs / 2 + $t,
        backgroundColor: r.colorScheme === "dark" ? r.colors.dark[6] : r.white,
        border: "1px solid ".concat(r.colorScheme === "dark" ? r.colors.dark[6] : r.colors.gray[2]),
        "&::before": {
          content: '""',
          display: "block",
          position: "absolute",
          top: r.spacing.xs,
          bottom: r.spacing.xs,
          left: r.spacing.xs,
          width: $t,
          borderRadius: $t,
          backgroundColor: w({
            theme: r,
            color: e,
            shade: r.colorScheme === "dark" ? 4 : 6
          })
        }
      };
    },
    title: function title(_ref13) {
      var e = _ref13.color,
          r = _ref13.theme;
      return {
        boxSizing: "border-box",
        color: w({
          theme: r,
          color: e,
          shade: r.colorScheme === "dark" ? 4 : 6
        }),
        margin: 0,
        marginBottom: r.spacing.xs / 2,
        textOverflow: "ellipsis",
        overflow: "hidden"
      };
    },
    body: function body(_ref14) {
      var e = _ref14.theme;
      return xd(Ed({}, Q(e)), {
        lineHeight: e.lineHeight,
        borderBottomLeftRadius: e.radius.sm,
        borderBottomRightRadius: e.radius.sm,
        textOverflow: "ellipsis",
        overflow: "hidden",
        fontSize: e.fontSizes.sm,
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        "&:only-child": {
          borderTopRightRadius: e.radius.sm,
          borderTopLeftRadius: e.radius.sm
        }
      });
    }
  }),
      Id = Object.defineProperty,
      We = Object.getOwnPropertySymbols,
      xo = Object.prototype.hasOwnProperty,
      Co = Object.prototype.propertyIsEnumerable,
      Io = function Io(e, r, t) {
    return r in e ? Id(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Nd = function Nd(e, r) {
    for (var t in r || (r = {})) {
      xo.call(r, t) && Io(e, t, r[t]);
    }

    if (We) {
      var _iterator13 = _createForOfIteratorHelper(We(r)),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var t = _step13.value;
          Co.call(r, t) && Io(e, t, r[t]);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }

    return e;
  },
      kd = function kd(e, r) {
    var t = {};

    for (var o in e) {
      xo.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && We) {
      var _iterator14 = _createForOfIteratorHelper(We(e)),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var o = _step14.value;
          r.indexOf(o) < 0 && Co.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }

    return t;
  };

  function No(e) {
    var r = e,
        t = r.className,
        o = r.title,
        a = r.children,
        n = r.themeOverride,
        i = r.color,
        _r$shadow = r.shadow,
        s = _r$shadow === void 0 ? "sm" : _r$shadow,
        c = kd(r, ["className", "title", "children", "themeOverride", "color", "shadow"]);
    var d = Cd({
      color: i,
      theme: j(n)
    });
    return l.createElement(ce, Nd({
      shadow: s,
      className: P(d.alert, t),
      themeOverride: n
    }, c), o && l.createElement(ne, {
      themeOverride: n,
      "data-mantine-alert-title": !0,
      weight: 700,
      className: d.title
    }, o), l.createElement("div", {
      "data-mantine-alert-body": !0,
      className: d.body
    }, a));
  }

  No.displayName = "@mantine/core/Alert";

  var jd = Object.defineProperty,
      Rd = Object.defineProperties,
      Td = Object.getOwnPropertyDescriptors,
      ko = Object.getOwnPropertySymbols,
      zd = Object.prototype.hasOwnProperty,
      Dd = Object.prototype.propertyIsEnumerable,
      jo = function jo(e, r, t) {
    return r in e ? jd(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Md = function Md(e, r) {
    for (var t in r || (r = {})) {
      zd.call(r, t) && jo(e, t, r[t]);
    }

    if (ko) {
      var _iterator15 = _createForOfIteratorHelper(ko(r)),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var t = _step15.value;
          Dd.call(r, t) && jo(e, t, r[t]);
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }

    return e;
  },
      Ad = function Ad(e, r) {
    return Rd(e, Td(r));
  };

  function Ld(e) {
    return l.createElement("svg", Ad(Md({}, e), {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }), l.createElement("path", {
      d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }));
  }

  var Hd = Object.defineProperty,
      Vd = Object.defineProperties,
      Bd = Object.getOwnPropertyDescriptors,
      Ro = Object.getOwnPropertySymbols,
      Fd = Object.prototype.hasOwnProperty,
      Wd = Object.prototype.propertyIsEnumerable,
      To = function To(e, r, t) {
    return r in e ? Hd(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Zd = function Zd(e, r) {
    for (var t in r || (r = {})) {
      Fd.call(r, t) && To(e, t, r[t]);
    }

    if (Ro) {
      var _iterator16 = _createForOfIteratorHelper(Ro(r)),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var t = _step16.value;
          Wd.call(r, t) && To(e, t, r[t]);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
    }

    return e;
  },
      Yd = function Yd(e, r) {
    return Vd(e, Bd(r));
  };

  var Ze = {
    xs: 16,
    sm: 26,
    md: 38,
    lg: 56,
    xl: 84
  };

  var qd = L({
    avatar: function avatar(_ref15) {
      var e = _ref15.size,
          r = _ref15.radius,
          t = _ref15.theme;
      return {
        boxSizing: "border-box",
        position: "relative",
        userSelect: "none",
        overflow: "hidden",
        width: _({
          size: e,
          sizes: Ze
        }),
        height: _({
          size: e,
          sizes: Ze
        }),
        borderRadius: r ? _({
          size: r,
          sizes: t.radius
        }) : e
      };
    },
    image: {
      objectFit: "cover",
      width: "100%",
      height: "100%"
    },
    placeholder: function placeholder(_ref16) {
      var e = _ref16.theme,
          r = _ref16.size,
          t = _ref16.color;
      return Yd(Zd({}, Q(e)), {
        fontSize: _({
          size: r,
          sizes: Ze
        }) / 2.5,
        color: w({
          theme: e,
          color: t,
          shade: e.colorScheme === "dark" ? 0 : 6
        }),
        fontWeight: 700,
        backgroundColor: re(w({
          theme: e,
          color: t,
          shade: e.colorScheme === "dark" ? 8 : 1
        }), e.colorScheme === "dark" ? .5 : 1),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        userSelect: "none"
      });
    },
    placeholderIcon: function placeholderIcon(_ref17) {
      var e = _ref17.theme,
          r = _ref17.color;
      return {
        width: "70%",
        height: "70%",
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 0 : 6
        })
      };
    }
  }),
      Ud = Object.defineProperty,
      Gd = Object.defineProperties,
      Kd = Object.getOwnPropertyDescriptors,
      Ye = Object.getOwnPropertySymbols,
      zo = Object.prototype.hasOwnProperty,
      Do = Object.prototype.propertyIsEnumerable,
      Mo = function Mo(e, r, t) {
    return r in e ? Ud(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Xd = function Xd(e, r) {
    for (var t in r || (r = {})) {
      zo.call(r, t) && Mo(e, t, r[t]);
    }

    if (Ye) {
      var _iterator17 = _createForOfIteratorHelper(Ye(r)),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var t = _step17.value;
          Do.call(r, t) && Mo(e, t, r[t]);
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }

    return e;
  },
      Jd = function Jd(e, r) {
    return Gd(e, Kd(r));
  },
      Qd = function Qd(e, r) {
    var t = {};

    for (var o in e) {
      zo.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Ye) {
      var _iterator18 = _createForOfIteratorHelper(Ye(e)),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var o = _step18.value;
          r.indexOf(o) < 0 && Do.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
    }

    return t;
  };

  var ef = Ze;

  function Ao(e) {
    var r = e,
        t = r.className,
        _r$size3 = r.size,
        o = _r$size3 === void 0 ? "md" : _r$size3,
        a = r.src,
        n = r.alt,
        _r$radius3 = r.radius,
        i = _r$radius3 === void 0 ? "sm" : _r$radius3,
        s = r.children,
        _r$color2 = r.color,
        c = _r$color2 === void 0 ? "gray" : _r$color2,
        d = r.themeOverride,
        f = Qd(r, ["className", "size", "src", "alt", "radius", "children", "color", "themeOverride"]);

    var p = j(d),
        u = qd({
      color: c,
      radius: i,
      size: o,
      theme: p
    }),
        _E$useState = E.useState(!a),
        _E$useState2 = _slicedToArray(_E$useState, 2),
        g = _E$useState2[0],
        y = _E$useState2[1];

    return E.useEffect(function () {
      y(!a);
    }, [a]), l.createElement("div", Jd(Xd({}, f), {
      className: P(u.avatar, t)
    }), g ? l.createElement("div", {
      "data-mantine-placeholder": !0,
      className: u.placeholder,
      title: n
    }, s || l.createElement(Ld, {
      className: u.placeholderIcon
    })) : l.createElement("img", {
      className: u.image,
      src: a,
      alt: n,
      onError: function onError() {
        return y(!0);
      }
    }));
  }

  Ao.displayName = "@mantine/core/Avatar";

  var rf = Object.defineProperty,
      tf = Object.defineProperties,
      of = Object.getOwnPropertyDescriptors,
      Lo = Object.getOwnPropertySymbols,
      af = Object.prototype.hasOwnProperty,
      nf = Object.prototype.propertyIsEnumerable,
      Ho = function Ho(e, r, t) {
    return r in e ? rf(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Vo = function Vo(e, r) {
    for (var t in r || (r = {})) {
      af.call(r, t) && Ho(e, t, r[t]);
    }

    if (Lo) {
      var _iterator19 = _createForOfIteratorHelper(Lo(r)),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var t = _step19.value;
          nf.call(r, t) && Ho(e, t, r[t]);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }

    return e;
  },
      lf = function lf(e, r) {
    return tf(e, of(r));
  };

  var xe = {
    xs: {
      fontSize: 9,
      height: 16
    },
    sm: {
      fontSize: 10,
      height: 18
    },
    md: {
      fontSize: 11,
      height: 20
    },
    lg: {
      fontSize: 13,
      height: 26
    },
    xl: {
      fontSize: 16,
      height: 32
    }
  },
      sf = {
    xs: 4,
    sm: 4,
    md: 6,
    lg: 8,
    xl: 10
  },
      cf = Object.keys(xe).reduce(function (e, r) {
    return e[r] = xe[r].height, e;
  }, {});

  var df = L({
    leftSection: function leftSection(_ref18) {
      var e = _ref18.theme;
      return {
        marginRight: e.spacing.xs / 2
      };
    },
    rightSection: function rightSection(_ref19) {
      var e = _ref19.theme;
      return {
        marginLeft: e.spacing.xs / 2
      };
    },
    inner: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    badge: function badge(_ref20) {
      var e = _ref20.theme,
          r = _ref20.size,
          t = _ref20.fullWidth,
          o = _ref20.radius;

      var _ref21 = r in xe ? xe[r] : xe.md,
          a = _ref21.fontSize,
          n = _ref21.height;

      return lf(Vo(Vo({}, ae(e)), Q(e)), {
        fontSize: a,
        height: n,
        WebkitTapHighlightColor: "transparent",
        lineHeight: "".concat(n - 2, "px"),
        border: "1px solid transparent",
        textDecoration: "none",
        padding: [0, _({
          size: r,
          sizes: e.spacing
        }) / 1.5],
        boxSizing: "border-box",
        display: t ? "flex" : "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: t ? "100%" : "auto",
        textTransform: "uppercase",
        borderRadius: _({
          size: o,
          sizes: e.radius
        }),
        fontWeight: 700,
        letterSpacing: .25,
        cursor: "default",
        textOverflow: "ellipsis",
        overflow: "hidden"
      });
    },
    light: function light(_ref22) {
      var e = _ref22.theme,
          r = _ref22.color;
      return {
        backgroundColor: re(w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 9 : 0
        }), e.colorScheme === "dark" ? .3 : 1),
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 3 : 9
        })
      };
    },
    filled: function filled(_ref23) {
      var e = _ref23.theme,
          r = _ref23.color;
      return {
        backgroundColor: re(w({
          theme: e,
          color: r,
          shade: 7
        }), e.colorScheme === "dark" ? .65 : 1),
        color: e.white,
        textShadow: e.colorScheme === "dark" ? "none" : "1px 1px 1px rgba(0, 0, 0, .3)"
      };
    },
    outline: function outline(_ref24) {
      var e = _ref24.theme,
          r = _ref24.color;
      return {
        backgroundColor: "transparent",
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 3 : 8
        }),
        borderColor: re(w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 3 : 8
        }), .55)
      };
    },
    dot: function dot(_ref25) {
      var e = _ref25.theme,
          r = _ref25.color,
          t = _ref25.size;

      var o = _({
        size: t,
        sizes: sf
      });

      return {
        backgroundColor: "transparent",
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[7],
        borderColor: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[3],
        paddingLeft: _({
          size: t,
          sizes: e.spacing
        }) / 1.5 - o / 2,
        "&::before": {
          content: '""',
          display: "block",
          width: o,
          height: o,
          borderRadius: o,
          backgroundColor: w({
            theme: e,
            color: r,
            shade: e.colorScheme === "dark" ? 4 : 6
          }),
          marginRight: o
        }
      };
    }
  }),
      ff = Object.defineProperty,
      pf = Object.defineProperties,
      uf = Object.getOwnPropertyDescriptors,
      qe = Object.getOwnPropertySymbols,
      Bo = Object.prototype.hasOwnProperty,
      Fo = Object.prototype.propertyIsEnumerable,
      Wo = function Wo(e, r, t) {
    return r in e ? ff(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      vf = function vf(e, r) {
    for (var t in r || (r = {})) {
      Bo.call(r, t) && Wo(e, t, r[t]);
    }

    if (qe) {
      var _iterator20 = _createForOfIteratorHelper(qe(r)),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var t = _step20.value;
          Fo.call(r, t) && Wo(e, t, r[t]);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
    }

    return e;
  },
      mf = function mf(e, r) {
    return pf(e, uf(r));
  },
      gf = function gf(e, r) {
    var t = {};

    for (var o in e) {
      Bo.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && qe) {
      var _iterator21 = _createForOfIteratorHelper(qe(e)),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var o = _step21.value;
          r.indexOf(o) < 0 && Fo.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }

    return t;
  };

  var _f = cf;

  function Zo(e) {
    var r = e,
        _r$component4 = r.component,
        t = _r$component4 === void 0 ? "div" : _r$component4,
        o = r.className,
        a = r.color,
        _r$variant3 = r.variant,
        n = _r$variant3 === void 0 ? "light" : _r$variant3,
        i = r.fullWidth,
        s = r.children,
        c = r.themeOverride,
        _r$size4 = r.size,
        d = _r$size4 === void 0 ? "md" : _r$size4,
        f = r.leftSection,
        p = r.rightSection,
        _r$radius4 = r.radius,
        u = _r$radius4 === void 0 ? "xl" : _r$radius4,
        g = gf(r, ["component", "className", "color", "variant", "fullWidth", "children", "themeOverride", "size", "leftSection", "rightSection", "radius"]);
    var y = df({
      size: d,
      fullWidth: i,
      color: a,
      radius: u,
      theme: j(c)
    });
    return l.createElement(t, mf(vf({}, g), {
      className: P(y.badge, y[n], o)
    }), f && l.createElement("span", {
      "data-mantine-badge-left": !0,
      className: y.leftSection
    }, f), l.createElement("span", {
      className: y.inner
    }, s), p && l.createElement("span", {
      "data-mantine-badge-right": !0,
      className: y.rightSection
    }, p));
  }

  Zo.displayName = "@mantine/core/Badge";

  var yf = Object.defineProperty,
      Yo = Object.getOwnPropertySymbols,
      bf = Object.prototype.hasOwnProperty,
      Of = Object.prototype.propertyIsEnumerable,
      qo = function qo(e, r, t) {
    return r in e ? yf(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      hf = function hf(e, r) {
    for (var t in r || (r = {})) {
      bf.call(r, t) && qo(e, t, r[t]);
    }

    if (Yo) {
      var _iterator22 = _createForOfIteratorHelper(Yo(r)),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var t = _step22.value;
          Of.call(r, t) && qo(e, t, r[t]);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
    }

    return e;
  };

  function wf(e) {
    return l.createElement("svg", hf({
      width: "20",
      height: "20",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), l.createElement("path", {
      d: "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }));
  }

  var Pf = Object.defineProperty,
      $f = Object.defineProperties,
      Sf = Object.getOwnPropertyDescriptors,
      Uo = Object.getOwnPropertySymbols,
      Ef = Object.prototype.hasOwnProperty,
      xf = Object.prototype.propertyIsEnumerable,
      Go = function Go(e, r, t) {
    return r in e ? Pf(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Cf = function Cf(e, r) {
    for (var t in r || (r = {})) {
      Ef.call(r, t) && Go(e, t, r[t]);
    }

    if (Uo) {
      var _iterator23 = _createForOfIteratorHelper(Uo(r)),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var t = _step23.value;
          xf.call(r, t) && Go(e, t, r[t]);
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }

    return e;
  },
      If = function If(e, r) {
    return $f(e, Sf(r));
  },
      Nf = L({
    blockquote: function blockquote(_ref26) {
      var e = _ref26.theme,
          r = _ref26.color;
      return If(Cf({}, Q(e)), {
        fontSize: e.fontSizes.lg,
        lineHeight: e.lineHeight,
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0],
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        margin: 0,
        borderTopRightRadius: e.radius.sm,
        borderBottomRightRadius: e.radius.sm,
        borderLeft: "3px solid ".concat(w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 4 : 6
        })),
        padding: [e.spacing.md, e.spacing.lg]
      });
    },
    inner: {
      display: "flex"
    },
    body: {
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    icon: function icon(_ref27) {
      var e = _ref27.theme,
          r = _ref27.color;
      return {
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 4 : 6
        }),
        marginRight: e.spacing.md,
        marginTop: 2,
        width: 22
      };
    },
    cite: function cite(_ref28) {
      var e = _ref28.theme;
      return {
        display: "block",
        fontSize: e.fontSizes.sm,
        marginTop: e.spacing.xs,
        color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6],
        overflow: "hidden",
        textOverflow: "ellipsis"
      };
    }
  }),
      kf = Object.defineProperty,
      Ue = Object.getOwnPropertySymbols,
      Ko = Object.prototype.hasOwnProperty,
      Xo = Object.prototype.propertyIsEnumerable,
      Jo = function Jo(e, r, t) {
    return r in e ? kf(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      jf = function jf(e, r) {
    for (var t in r || (r = {})) {
      Ko.call(r, t) && Jo(e, t, r[t]);
    }

    if (Ue) {
      var _iterator24 = _createForOfIteratorHelper(Ue(r)),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var t = _step24.value;
          Xo.call(r, t) && Jo(e, t, r[t]);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
    }

    return e;
  },
      Rf = function Rf(e, r) {
    var t = {};

    for (var o in e) {
      Ko.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Ue) {
      var _iterator25 = _createForOfIteratorHelper(Ue(e)),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var o = _step25.value;
          r.indexOf(o) < 0 && Xo.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }

    return t;
  };

  var Tf = l.createElement(wf, null);

  function Qo(e) {
    var r = e,
        t = r.className,
        o = r.color,
        _r$icon = r.icon,
        a = _r$icon === void 0 ? Tf : _r$icon,
        n = r.cite,
        i = r.children,
        s = r.themeOverride,
        c = Rf(r, ["className", "color", "icon", "cite", "children", "themeOverride"]);
    var d = Nf({
      color: o,
      theme: j(s)
    });
    return l.createElement("blockquote", jf({
      className: P(d.blockquote, t)
    }, c), l.createElement("div", {
      className: d.inner
    }, a && l.createElement("div", {
      "data-mantine-icon": !0,
      className: d.icon
    }, a), l.createElement("div", {
      className: d.body
    }, i, n && l.createElement("cite", {
      className: d.cite
    }, n))));
  }

  Qo.displayName = "@mantine/core/Blockquote";

  var zf = L({
    breadcrumbs: {
      display: "flex"
    },
    breadcrumb: {
      lineHeight: 1,
      whiteSpace: "nowrap",
      WebkitTapHighlightColor: "transparent"
    },
    separator: function separator(_ref29) {
      var e = _ref29.theme;
      return {
        marginLeft: e.spacing.xs,
        marginRight: e.spacing.xs,
        color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[7],
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
    }
  }),
      Df = Object.defineProperty,
      Ge = Object.getOwnPropertySymbols,
      ea = Object.prototype.hasOwnProperty,
      ra = Object.prototype.propertyIsEnumerable,
      ta = function ta(e, r, t) {
    return r in e ? Df(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Mf = function Mf(e, r) {
    for (var t in r || (r = {})) {
      ea.call(r, t) && ta(e, t, r[t]);
    }

    if (Ge) {
      var _iterator26 = _createForOfIteratorHelper(Ge(r)),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var t = _step26.value;
          ra.call(r, t) && ta(e, t, r[t]);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
    }

    return e;
  },
      Af = function Af(e, r) {
    var t = {};

    for (var o in e) {
      ea.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Ge) {
      var _iterator27 = _createForOfIteratorHelper(Ge(e)),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var o = _step27.value;
          r.indexOf(o) < 0 && ra.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    }

    return t;
  };

  function oa(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = r.children,
        _r$separator = r.separator,
        n = _r$separator === void 0 ? "/" : _r$separator,
        i = Af(r, ["className", "themeOverride", "children", "separator"]);
    var s = zf({
      theme: j(o)
    }),
        c = l.Children.toArray(a).reduce(function (d, f, p, u) {
      return d.push(l.cloneElement(f, {
        className: s.breadcrumb,
        key: p,
        "data-mantine-breadcrumb": !0
      })), p !== u.length - 1 && d.push(l.createElement(ne, {
        size: "sm",
        "data-mantine-separator": !0,
        className: s.separator,
        key: "separator-".concat(p),
        themeOverride: o
      }, n)), d;
    }, []);
    return l.createElement("div", Mf({
      className: P(s.breadcrumbs, t)
    }, i), c);
  }

  oa.displayName = "@mantine/core/Breadcrumbs";

  var Lf = Object.defineProperty,
      Hf = Object.defineProperties,
      Vf = Object.getOwnPropertyDescriptors,
      aa = Object.getOwnPropertySymbols,
      Bf = Object.prototype.hasOwnProperty,
      Ff = Object.prototype.propertyIsEnumerable,
      na = function na(e, r, t) {
    return r in e ? Lf(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Wf = function Wf(e, r) {
    for (var t in r || (r = {})) {
      Bf.call(r, t) && na(e, t, r[t]);
    }

    if (aa) {
      var _iterator28 = _createForOfIteratorHelper(aa(r)),
          _step28;

      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var t = _step28.value;
          Ff.call(r, t) && na(e, t, r[t]);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
    }

    return e;
  },
      Zf = function Zf(e, r) {
    return Hf(e, Vf(r));
  };

  var Ke = {
    xs: 12,
    sm: 18,
    md: 24,
    lg: 34,
    xl: 42
  };

  var Yf = L({
    opened: {},
    wrapper: function wrapper(_ref30) {
      var e = _ref30.size,
          r = _ref30.theme;
      return Zf(Wf({}, ae(r)), {
        WebkitTapHighlightColor: "transparent",
        borderRadius: r.radius.sm,
        width: _({
          size: e,
          sizes: Ke
        }) + r.spacing.xs,
        height: _({
          size: e,
          sizes: Ke
        }) + r.spacing.xs,
        padding: r.spacing.xs / 2,
        backgroundColor: "transparent",
        border: 0,
        cursor: "pointer"
      });
    },
    burger: function burger(_ref31) {
      var e = _ref31.size,
          r = _ref31.theme,
          t = _ref31.color,
          o = _ref31.reduceMotion;

      var a = _({
        size: e,
        sizes: Ke
      });

      return {
        position: "relative",
        userSelect: "none",
        boxSizing: "border-box",
        "&, &:before, &:after": {
          display: "block",
          width: a,
          height: Math.ceil(a / 12),
          backgroundColor: w({
            theme: r,
            color: t,
            shade: r.colorScheme === "dark" ? 4 : 7
          }),
          outline: "1px solid transparent",
          transitionProperty: "background-color, transform",
          transitionDuration: o ? "0ms" : "300ms"
        },
        "&:before, &:after": {
          position: "absolute",
          content: '""',
          left: 0
        },
        "&:before": {
          top: a / 3 * -1
        },
        "&:after": {
          top: a / 3
        },
        "&$opened": {
          backgroundColor: "transparent !important",
          "&:before": {
            transform: "translateY(".concat(a / 3, "px) rotate(45deg)")
          },
          "&:after": {
            transform: "translateY(-".concat(a / 3, "px) rotate(-45deg)")
          }
        }
      };
    }
  }),
      qf = Object.defineProperty,
      Xe = Object.getOwnPropertySymbols,
      ia = Object.prototype.hasOwnProperty,
      la = Object.prototype.propertyIsEnumerable,
      sa = function sa(e, r, t) {
    return r in e ? qf(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Uf = function Uf(e, r) {
    for (var t in r || (r = {})) {
      ia.call(r, t) && sa(e, t, r[t]);
    }

    if (Xe) {
      var _iterator29 = _createForOfIteratorHelper(Xe(r)),
          _step29;

      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var t = _step29.value;
          la.call(r, t) && sa(e, t, r[t]);
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }

    return e;
  },
      Gf = function Gf(e, r) {
    var t = {};

    for (var o in e) {
      ia.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Xe) {
      var _iterator30 = _createForOfIteratorHelper(Xe(e)),
          _step30;

      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var o = _step30.value;
          r.indexOf(o) < 0 && la.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    }

    return t;
  };

  var Kf = Ke;

  function ca(e) {
    var r = e,
        t = r.className,
        o = r.opened,
        _r$color3 = r.color,
        a = _r$color3 === void 0 ? "gray" : _r$color3,
        _r$size5 = r.size,
        n = _r$size5 === void 0 ? "md" : _r$size5,
        i = r.themeOverride,
        s = r.elementRef,
        c = Gf(r, ["className", "opened", "color", "size", "themeOverride", "elementRef"]);
    var d = Yf({
      color: a,
      size: n,
      theme: j(i),
      reduceMotion: V.useReducedMotion()
    });
    return l.createElement("button", Uf({
      type: "button",
      className: P(d.wrapper, t),
      ref: s
    }, c), l.createElement("div", {
      className: P(d.burger, _defineProperty({}, d.opened, o))
    }));
  }

  ca.displayName = "@mantine/core/Burger";

  var Xf = Object.defineProperty,
      Jf = Object.defineProperties,
      Qf = Object.getOwnPropertyDescriptors,
      da = Object.getOwnPropertySymbols,
      ep = Object.prototype.hasOwnProperty,
      rp = Object.prototype.propertyIsEnumerable,
      fa = function fa(e, r, t) {
    return r in e ? Xf(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Je = function Je(e, r) {
    for (var t in r || (r = {})) {
      ep.call(r, t) && fa(e, t, r[t]);
    }

    if (da) {
      var _iterator31 = _createForOfIteratorHelper(da(r)),
          _step31;

      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var t = _step31.value;
          rp.call(r, t) && fa(e, t, r[t]);
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
    }

    return e;
  },
      tp = function tp(e, r) {
    return Jf(e, Qf(r));
  };

  var Ce = {
    xs: {
      fontSize: 10,
      height: 22,
      padding: [0, 11]
    },
    sm: {
      fontSize: 12,
      height: 26,
      padding: [0, 13]
    },
    md: {
      fontSize: 15,
      height: 32,
      padding: [0, 15]
    },
    lg: {
      fontSize: 18,
      height: 36,
      padding: [0, 18]
    },
    xl: {
      fontSize: 22,
      height: 44,
      padding: [0, 22]
    }
  },
      op = Object.keys(Ce).reduce(function (e, r) {
    return e[r] = Ce[r].height, e;
  }, {}),
      ap = function ap(e) {
    return {
      display: e ? "block" : "inline-block",
      width: e ? "100%" : "auto"
    };
  };

  var np = L({
    icon: {
      display: "flex",
      alignItems: "center"
    },
    leftIcon: {
      marginRight: 10
    },
    rightIcon: {
      marginLeft: 10
    },
    inner: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      overflow: "visible"
    },
    label: {
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    shared: function shared(e) {
      return tp(Je(Je(Je(Je({}, Ce[e.size]), Q(e.theme)), ae(e.theme)), ap(e.fullWidth)), {
        WebkitTapHighlightColor: "transparent",
        userSelect: "none",
        boxSizing: "border-box",
        textDecoration: "none",
        cursor: "pointer",
        appearance: "none",
        WebkitAppearance: "none"
      });
    },
    outline: function outline(_ref32) {
      var e = _ref32.color,
          r = _ref32.radius,
          t = _ref32.theme;
      return {
        backgroundColor: "transparent",
        borderRadius: _({
          size: r,
          sizes: t.radius
        }),
        fontWeight: 600,
        color: w({
          theme: t,
          color: e,
          shade: t.colorScheme === "dark" ? 4 : 8
        }),
        border: "1px solid ".concat(re(w({
          theme: t,
          color: e,
          shade: t.colorScheme === "dark" ? 5 : 9
        }), t.colorScheme === "dark" ? .65 : .45)),
        "&:not(:disabled):active": {
          transform: "translateY(1px)"
        },
        "&:disabled": {
          borderColor: "transparent",
          backgroundColor: t.colorScheme === "dark" ? t.colors.dark[4] : t.colors.gray[2],
          color: t.colorScheme === "dark" ? t.colors.dark[6] : t.colors.gray[5],
          cursor: "not-allowed"
        }
      };
    },
    light: function light(_ref33) {
      var e = _ref33.color,
          r = _ref33.size,
          t = _ref33.radius,
          o = _ref33.theme;
      return {
        borderRadius: _({
          size: t,
          sizes: o.radius
        }),
        fontWeight: 600,
        border: "1px solid transparent",
        backgroundColor: re(w({
          theme: o,
          color: e,
          shade: o.colorScheme === "dark" ? 8 : 5
        }), o.colorScheme === "dark" ? .3 : .1),
        color: w({
          theme: o,
          color: e,
          shade: o.colorScheme === "dark" ? 2 : 7
        }),
        "& $inner": {
          height: Ce[r].height - 2
        },
        "&:not(:disabled):active": {
          transform: "translateY(1px)"
        },
        "&:disabled": {
          borderColor: "transparent",
          backgroundColor: o.colorScheme === "dark" ? o.colors.dark[4] : o.colors.gray[2],
          color: o.colorScheme === "dark" ? o.colors.dark[6] : o.colors.gray[5],
          textShadow: "none",
          cursor: "not-allowed"
        }
      };
    },
    filled: function filled(_ref34) {
      var e = _ref34.color,
          r = _ref34.size,
          t = _ref34.radius,
          o = _ref34.theme;
      return {
        border: "1px solid transparent",
        borderRadius: _({
          size: t,
          sizes: o.radius
        }),
        fontWeight: 600,
        backgroundColor: re(w({
          theme: o,
          color: e,
          shade: 6
        }), o.colorScheme === "dark" ? .65 : 1),
        textShadow: "1px 1px 1px rgba(0, 0, 0, .3)",
        color: o.white,
        "& $inner": {
          height: Ce[r].height - 2
        },
        "&:not(:disabled):active": {
          transform: "translateY(1px)"
        },
        "&:disabled": {
          borderColor: "transparent",
          backgroundColor: o.colorScheme === "dark" ? o.colors.dark[4] : o.colors.gray[2],
          color: o.colorScheme === "dark" ? o.colors.dark[6] : o.colors.gray[5],
          textShadow: "none",
          cursor: "not-allowed"
        }
      };
    },
    link: function link(_ref35) {
      var e = _ref35.color,
          r = _ref35.radius,
          t = _ref35.theme;
      return {
        padding: 0,
        borderRadius: _({
          size: r,
          sizes: t.radius
        }),
        backgroundColor: "transparent",
        border: 0,
        display: "inline-block",
        color: w({
          theme: t,
          color: e,
          shade: t.colorScheme === "dark" ? 4 : 6
        }),
        cursor: "pointer",
        lineHeight: t.lineHeight,
        "&:hover": {
          textDecoration: "underline"
        },
        "&:disabled": {
          color: t.colors.gray[5],
          cursor: "not-allowed",
          "&:hover": {
            textDecoration: "none"
          }
        }
      };
    }
  }),
      ip = Object.defineProperty,
      lp = Object.defineProperties,
      sp = Object.getOwnPropertyDescriptors,
      Qe = Object.getOwnPropertySymbols,
      pa = Object.prototype.hasOwnProperty,
      ua = Object.prototype.propertyIsEnumerable,
      va = function va(e, r, t) {
    return r in e ? ip(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      cp = function cp(e, r) {
    for (var t in r || (r = {})) {
      pa.call(r, t) && va(e, t, r[t]);
    }

    if (Qe) {
      var _iterator32 = _createForOfIteratorHelper(Qe(r)),
          _step32;

      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var t = _step32.value;
          ua.call(r, t) && va(e, t, r[t]);
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
    }

    return e;
  },
      dp = function dp(e, r) {
    return lp(e, sp(r));
  },
      fp = function fp(e, r) {
    var t = {};

    for (var o in e) {
      pa.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Qe) {
      var _iterator33 = _createForOfIteratorHelper(Qe(e)),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var o = _step33.value;
          r.indexOf(o) < 0 && ua.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
    }

    return t;
  };

  var pp = op;

  function St(e) {
    var r = e,
        t = r.className,
        _r$size6 = r.size,
        o = _r$size6 === void 0 ? "md" : _r$size6,
        a = r.color,
        _r$type = r.type,
        n = _r$type === void 0 ? "button" : _r$type,
        _r$disabled = r.disabled,
        i = _r$disabled === void 0 ? !1 : _r$disabled,
        s = r.children,
        c = r.leftIcon,
        d = r.rightIcon,
        _r$fullWidth = r.fullWidth,
        f = _r$fullWidth === void 0 ? !1 : _r$fullWidth,
        _r$variant4 = r.variant,
        p = _r$variant4 === void 0 ? "filled" : _r$variant4,
        _r$radius5 = r.radius,
        u = _r$radius5 === void 0 ? "sm" : _r$radius5,
        _r$component5 = r.component,
        g = _r$component5 === void 0 ? "button" : _r$component5,
        y = r.elementRef,
        b = r.themeOverride,
        _r$uppercase = r.uppercase,
        S = _r$uppercase === void 0 ? !1 : _r$uppercase,
        I = fp(r, ["className", "size", "color", "type", "disabled", "children", "leftIcon", "rightIcon", "fullWidth", "variant", "radius", "component", "elementRef", "themeOverride", "uppercase"]);
    var N = np({
      radius: u,
      color: a,
      size: o,
      fullWidth: f,
      theme: j(b)
    });
    return l.createElement(g, dp(cp({}, I), {
      className: P(N.shared, N[p], t),
      type: n,
      disabled: i,
      ref: y,
      onTouchStart: function onTouchStart() {}
    }), l.createElement("div", {
      className: N.inner
    }, c && l.createElement("span", {
      "data-mantine-left-icon": !0,
      className: P(N.icon, N.leftIcon)
    }, c), l.createElement("span", {
      className: N.label,
      "data-mantine-label": !0,
      style: {
        textTransform: S ? "uppercase" : void 0
      }
    }, s), d && l.createElement("span", {
      "data-mantine-right-icon": !0,
      className: P(N.icon, N.rightIcon)
    }, d)));
  }

  St.displayName = "@mantine/core/Button";

  var up = L({
    card: function card(_ref36) {
      var e = _ref36.theme,
          r = _ref36.radius,
          t = _ref36.padding;

      var o = _({
        size: t,
        sizes: e.spacing
      }),
          a = _({
        size: r,
        sizes: e.radius
      });

      return {
        position: "relative",
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
        "& [data-mantine-image]": {
          width: "calc(100% + ".concat(o * 2, "px) !important"),
          marginLeft: -o,
          marginRight: -o,
          "&:first-child": {
            borderTopRightRadius: a,
            borderTopLeftRadius: a,
            marginBottom: o,
            marginTop: -o
          },
          "&:last-child": {
            borderBottomRightRadius: a,
            borderBottomLeftRadius: a,
            marginTop: o,
            marginBottom: -o
          },
          "&:first-child:last-child": {
            marginTop: -o,
            marginBottom: -o
          }
        },
        "& [data-mantine-hr]": {
          borderTopColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[2],
          marginLeft: -o,
          marginRight: -o,
          marginBottom: o / 2,
          marginTop: o / 2
        }
      };
    }
  }),
      vp = L({
    grid: function grid(_ref37) {
      var e = _ref37.theme,
          r = _ref37.gutter,
          t = _ref37.cardsPerRow,
          o = _ref37.grow;

      var a = _({
        size: r,
        sizes: e.spacing
      }),
          n = function n(i) {
        return "".concat(o ? 1 : 0, " 0 calc(").concat(100 / i, "% - ").concat(a, "px)");
      };

      return {
        display: "flex",
        flexWrap: "wrap",
        margin: -a / 2,
        "& [data-mantine-card]": {
          margin: a / 2,
          flex: n(t)
        }
      };
    }
  }),
      mp = Object.defineProperty,
      er = Object.getOwnPropertySymbols,
      ma = Object.prototype.hasOwnProperty,
      ga = Object.prototype.propertyIsEnumerable,
      _a = function _a(e, r, t) {
    return r in e ? mp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      gp = function gp(e, r) {
    for (var t in r || (r = {})) {
      ma.call(r, t) && _a(e, t, r[t]);
    }

    if (er) {
      var _iterator34 = _createForOfIteratorHelper(er(r)),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var t = _step34.value;
          ga.call(r, t) && _a(e, t, r[t]);
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    }

    return e;
  },
      _p = function _p(e, r) {
    var t = {};

    for (var o in e) {
      ma.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && er) {
      var _iterator35 = _createForOfIteratorHelper(er(e)),
          _step35;

      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var o = _step35.value;
          r.indexOf(o) < 0 && ga.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
    }

    return t;
  };

  function ya(e) {
    var r = e,
        _r$gutter = r.gutter,
        t = _r$gutter === void 0 ? "md" : _r$gutter,
        _r$cardsPerRow = r.cardsPerRow,
        o = _r$cardsPerRow === void 0 ? 1 : _r$cardsPerRow,
        _r$grow = r.grow,
        a = _r$grow === void 0 ? !1 : _r$grow,
        n = r.children,
        i = r.className,
        s = r.themeOverride,
        c = _p(r, ["gutter", "cardsPerRow", "grow", "children", "className", "themeOverride"]);

    var d = vp({
      cardsPerRow: o,
      gutter: t,
      grow: a,
      theme: j(s)
    });
    return l.createElement("div", gp({
      className: P(d.grid, i)
    }, c), n);
  }

  ya.displayName = "@mantine/core/CardsGrid";

  var yp = Object.defineProperty,
      rr = Object.getOwnPropertySymbols,
      ba = Object.prototype.hasOwnProperty,
      Oa = Object.prototype.propertyIsEnumerable,
      ha = function ha(e, r, t) {
    return r in e ? yp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      bp = function bp(e, r) {
    for (var t in r || (r = {})) {
      ba.call(r, t) && ha(e, t, r[t]);
    }

    if (rr) {
      var _iterator36 = _createForOfIteratorHelper(rr(r)),
          _step36;

      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var t = _step36.value;
          Oa.call(r, t) && ha(e, t, r[t]);
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
    }

    return e;
  },
      Op = function Op(e, r) {
    var t = {};

    for (var o in e) {
      ba.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && rr) {
      var _iterator37 = _createForOfIteratorHelper(rr(e)),
          _step37;

      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var o = _step37.value;
          r.indexOf(o) < 0 && Oa.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
    }

    return t;
  };

  function wa(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        _r$padding2 = r.padding,
        a = _r$padding2 === void 0 ? "md" : _r$padding2,
        _r$radius6 = r.radius,
        n = _r$radius6 === void 0 ? "sm" : _r$radius6,
        i = Op(r, ["className", "themeOverride", "padding", "radius"]);
    var s = up({
      radius: n,
      padding: a,
      theme: j(o)
    });
    return l.createElement(ce, bp({
      "data-mantine-card": !0,
      className: P(s.card, t),
      radius: n,
      padding: a
    }, i));
  }

  wa.displayName = "@mantine/core/Card";

  var hp = Object.defineProperty,
      tr = Object.getOwnPropertySymbols,
      Pa = Object.prototype.hasOwnProperty,
      $a = Object.prototype.propertyIsEnumerable,
      Sa = function Sa(e, r, t) {
    return r in e ? hp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Ea = function Ea(e, r) {
    for (var t in r || (r = {})) {
      Pa.call(r, t) && Sa(e, t, r[t]);
    }

    if (tr) {
      var _iterator38 = _createForOfIteratorHelper(tr(r)),
          _step38;

      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var t = _step38.value;
          $a.call(r, t) && Sa(e, t, r[t]);
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
    }

    return e;
  },
      wp = function wp(e, r) {
    var t = {};

    for (var o in e) {
      Pa.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && tr) {
      var _iterator39 = _createForOfIteratorHelper(tr(e)),
          _step39;

      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
          var o = _step39.value;
          r.indexOf(o) < 0 && $a.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }
    }

    return t;
  };

  function xa(e) {
    var r = e,
        t = r.style,
        o = wp(r, ["style"]);
    return l.createElement("div", Ea({
      style: Ea({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }, t)
    }, o));
  }

  xa.displayName = "@mantine/core/Center";

  var Pp = Object.defineProperty,
      or = Object.getOwnPropertySymbols,
      Ca = Object.prototype.hasOwnProperty,
      Ia = Object.prototype.propertyIsEnumerable,
      Na = function Na(e, r, t) {
    return r in e ? Pp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      $p = function $p(e, r) {
    for (var t in r || (r = {})) {
      Ca.call(r, t) && Na(e, t, r[t]);
    }

    if (or) {
      var _iterator40 = _createForOfIteratorHelper(or(r)),
          _step40;

      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var t = _step40.value;
          Ia.call(r, t) && Na(e, t, r[t]);
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
    }

    return e;
  },
      Sp = function Sp(e, r) {
    var t = {};

    for (var o in e) {
      Ca.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && or) {
      var _iterator41 = _createForOfIteratorHelper(or(e)),
          _step41;

      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var o = _step41.value;
          r.indexOf(o) < 0 && Ia.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
    }

    return t;
  };

  function Ep(e) {
    var r = e,
        t = r.indeterminate,
        o = Sp(r, ["indeterminate"]);
    return l.createElement("svg", $p({
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, o), l.createElement("path", {
      d: t ? "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z" : "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }));
  }

  var xp = Object.defineProperty,
      Cp = Object.defineProperties,
      Ip = Object.getOwnPropertyDescriptors,
      ka = Object.getOwnPropertySymbols,
      Np = Object.prototype.hasOwnProperty,
      kp = Object.prototype.propertyIsEnumerable,
      ja = function ja(e, r, t) {
    return r in e ? xp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Ra = function Ra(e, r) {
    for (var t in r || (r = {})) {
      Np.call(r, t) && ja(e, t, r[t]);
    }

    if (ka) {
      var _iterator42 = _createForOfIteratorHelper(ka(r)),
          _step42;

      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var t = _step42.value;
          kp.call(r, t) && ja(e, t, r[t]);
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }
    }

    return e;
  },
      Ta = function Ta(e, r) {
    return Cp(e, Ip(r));
  };

  var ge = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 26,
    xl: 36
  };

  var jp = L({
    wrapper: {
      display: "flex",
      alignItems: "center"
    },
    checkboxWrapper: function checkboxWrapper(_ref38) {
      var e = _ref38.size;
      return {
        position: "relative",
        width: _({
          size: e,
          sizes: ge
        }),
        height: _({
          size: e,
          sizes: ge
        })
      };
    },
    label: function label(_ref39) {
      var e = _ref39.theme,
          r = _ref39.size;
      return Ta(Ra({}, Q(e)), {
        WebkitTapHighlightColor: "transparent",
        paddingLeft: e.spacing.sm,
        fontSize: _({
          size: r,
          sizes: e.fontSizes
        }),
        lineHeight: "".concat(_({
          size: r,
          sizes: ge
        }), "px"),
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black
      });
    },
    checkbox: function checkbox(_ref40) {
      var e = _ref40.size,
          r = _ref40.theme,
          t = _ref40.color;
      return Ta(Ra({}, ae(r)), {
        appearance: "none",
        backgroundColor: r.colorScheme === "dark" ? r.colors.dark[4] : r.colors.gray[0],
        border: "1px solid ".concat(r.colorScheme === "dark" ? r.colors.dark[4] : r.colors.gray[4]),
        width: _({
          size: e,
          sizes: ge
        }),
        height: _({
          size: e,
          sizes: ge
        }),
        borderRadius: r.radius.sm,
        padding: 0,
        outline: 0,
        display: "block",
        margin: 0,
        "&:checked": {
          backgroundColor: w({
            theme: r,
            color: t,
            shade: r.colorScheme === "dark" ? 4 : 6
          }),
          borderColor: w({
            theme: r,
            color: t,
            shade: r.colorScheme === "dark" ? 4 : 6
          }),
          color: r.white,
          "& + $icon": {
            color: r.colorScheme === "dark" ? r.colors.dark[9] : r.white,
            display: "block"
          }
        },
        "&:disabled": {
          backgroundColor: r.colorScheme === "dark" ? r.colors.dark[4] : r.colors.gray[2],
          borderColor: r.colorScheme === "dark" ? r.colors.dark[6] : r.colors.gray[3],
          cursor: "not-allowed",
          "& + $icon": {
            color: r.colorScheme === "dark" ? r.colors.dark[6] : r.colors.gray[5]
          }
        }
      });
    },
    icon: {
      display: "none",
      pointerEvents: "none",
      width: "80%",
      height: "80%",
      position: "absolute",
      zIndex: 1,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto"
    }
  }),
      Rp = Object.defineProperty,
      ar = Object.getOwnPropertySymbols,
      za = Object.prototype.hasOwnProperty,
      Da = Object.prototype.propertyIsEnumerable,
      Ma = function Ma(e, r, t) {
    return r in e ? Rp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Aa = function Aa(e, r) {
    for (var t in r || (r = {})) {
      za.call(r, t) && Ma(e, t, r[t]);
    }

    if (ar) {
      var _iterator43 = _createForOfIteratorHelper(ar(r)),
          _step43;

      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var t = _step43.value;
          Da.call(r, t) && Ma(e, t, r[t]);
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }
    }

    return e;
  },
      Tp = function Tp(e, r) {
    var t = {};

    for (var o in e) {
      za.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && ar) {
      var _iterator44 = _createForOfIteratorHelper(ar(e)),
          _step44;

      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var o = _step44.value;
          r.indexOf(o) < 0 && Da.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
    }

    return t;
  };

  var zp = ge;

  function La(e) {
    var r = e,
        t = r.className,
        o = r.checked,
        a = r.onChange,
        n = r.color,
        i = r.themeOverride,
        s = r.label,
        c = r.disabled,
        d = r.indeterminate,
        f = r.id,
        p = r.size,
        u = r.wrapperProps,
        g = r.style,
        y = r.inputStyle,
        b = r.inputClassName,
        S = r.elementRef,
        I = r.children,
        N = Tp(r, ["className", "checked", "onChange", "color", "themeOverride", "label", "disabled", "indeterminate", "id", "size", "wrapperProps", "style", "inputStyle", "inputClassName", "elementRef", "children"]);
    var k = V.useId(f),
        x = jp({
      size: p,
      color: n,
      theme: j(i)
    });
    return l.createElement("div", Aa({
      className: P(x.wrapper, t),
      style: g
    }, u), l.createElement("div", {
      className: x.checkboxWrapper
    }, l.createElement("input", Aa({
      id: k,
      ref: S,
      type: "checkbox",
      className: P(x.checkbox, b),
      checked: d || o,
      onChange: a,
      disabled: c,
      style: y
    }, N)), l.createElement(Ep, {
      indeterminate: d,
      className: x.icon
    })), s && l.createElement("label", {
      className: x.label,
      htmlFor: k
    }, s));
  }

  La.displayName = "@mantine/core/Checkbox";

  var Dp = Object.defineProperty,
      Mp = Object.defineProperties,
      Ap = Object.getOwnPropertyDescriptors,
      Ha = Object.getOwnPropertySymbols,
      Lp = Object.prototype.hasOwnProperty,
      Hp = Object.prototype.propertyIsEnumerable,
      Va = function Va(e, r, t) {
    return r in e ? Dp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Vp = function Vp(e, r) {
    for (var t in r || (r = {})) {
      Lp.call(r, t) && Va(e, t, r[t]);
    }

    if (Ha) {
      var _iterator45 = _createForOfIteratorHelper(Ha(r)),
          _step45;

      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var t = _step45.value;
          Hp.call(r, t) && Va(e, t, r[t]);
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
    }

    return e;
  },
      Bp = function Bp(e, r) {
    return Mp(e, Ap(r));
  },
      Fp = L({
    code: function code(_ref41) {
      var e = _ref41.theme,
          r = _ref41.color;
      return Bp(Vp({}, Q(e)), {
        lineHeight: e.lineHeight,
        padding: [1, e.spacing.xs / 2],
        borderRadius: e.radius.sm,
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 1 : 9
        }),
        backgroundColor: re(w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 9 : 0
        }), e.colorScheme === "dark" ? .45 : 1),
        fontFamily: e.fontFamilyMonospace,
        fontSize: e.fontSizes.xs,
        border: "1px solid ".concat(e.colorScheme === "dark" ? "transparent" : w({
          theme: e,
          color: r,
          shade: 2
        }))
      });
    },
    pre: function pre(_ref42) {
      var e = _ref42.theme;
      return {
        padding: e.spacing.xs,
        margin: 0,
        overflowX: "auto"
      };
    }
  }),
      Wp = Object.defineProperty,
      nr = Object.getOwnPropertySymbols,
      Ba = Object.prototype.hasOwnProperty,
      Fa = Object.prototype.propertyIsEnumerable,
      Wa = function Wa(e, r, t) {
    return r in e ? Wp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Za = function Za(e, r) {
    for (var t in r || (r = {})) {
      Ba.call(r, t) && Wa(e, t, r[t]);
    }

    if (nr) {
      var _iterator46 = _createForOfIteratorHelper(nr(r)),
          _step46;

      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var t = _step46.value;
          Fa.call(r, t) && Wa(e, t, r[t]);
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
    }

    return e;
  },
      Zp = function Zp(e, r) {
    var t = {};

    for (var o in e) {
      Ba.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && nr) {
      var _iterator47 = _createForOfIteratorHelper(nr(e)),
          _step47;

      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var o = _step47.value;
          r.indexOf(o) < 0 && Fa.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
    }

    return t;
  };

  function Ya(e) {
    var r = e,
        t = r.children,
        o = r.themeOverride,
        _r$block = r.block,
        a = _r$block === void 0 ? !1 : _r$block,
        n = r.className,
        i = r.color,
        s = Zp(r, ["children", "themeOverride", "block", "className", "color"]);
    var c = j(o),
        d = i || (c.colorScheme === "dark" ? "dark" : "gray"),
        f = Fp({
      color: d,
      theme: j(o)
    });
    return a ? l.createElement("pre", Za({
      className: P(f.code, f.pre, n)
    }, s), t) : l.createElement("code", Za({
      className: P(f.code, n)
    }, s), t);
  }

  Ya.displayName = "@mantine/core/Code";

  var Yp = Object.defineProperty,
      qp = Object.defineProperties,
      Up = Object.getOwnPropertyDescriptors,
      qa = Object.getOwnPropertySymbols,
      Gp = Object.prototype.hasOwnProperty,
      Kp = Object.prototype.propertyIsEnumerable,
      Ua = function Ua(e, r, t) {
    return r in e ? Yp(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Xp = function Xp(e, r) {
    for (var t in r || (r = {})) {
      Gp.call(r, t) && Ua(e, t, r[t]);
    }

    if (qa) {
      var _iterator48 = _createForOfIteratorHelper(qa(r)),
          _step48;

      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var t = _step48.value;
          Kp.call(r, t) && Ua(e, t, r[t]);
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
    }

    return e;
  },
      Jp = function Jp(e, r) {
    return qp(e, Up(r));
  },
      Qp = L({
    colorSwatch: function colorSwatch(_ref43) {
      var e = _ref43.theme,
          r = _ref43.radius;
      return Jp(Xp({}, ae(e)), {
        border: 0,
        borderRadius: _({
          size: r,
          sizes: e.radius
        }),
        appearance: "none",
        WebkitAppearance: "none",
        padding: 0,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center"
      });
    }
  }),
      eu = Object.defineProperty,
      ir = Object.getOwnPropertySymbols,
      Ga = Object.prototype.hasOwnProperty,
      Ka = Object.prototype.propertyIsEnumerable,
      Xa = function Xa(e, r, t) {
    return r in e ? eu(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Ja = function Ja(e, r) {
    for (var t in r || (r = {})) {
      Ga.call(r, t) && Xa(e, t, r[t]);
    }

    if (ir) {
      var _iterator49 = _createForOfIteratorHelper(ir(r)),
          _step49;

      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var t = _step49.value;
          Ka.call(r, t) && Xa(e, t, r[t]);
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
    }

    return e;
  },
      ru = function ru(e, r) {
    var t = {};

    for (var o in e) {
      Ga.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && ir) {
      var _iterator50 = _createForOfIteratorHelper(ir(e)),
          _step50;

      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var o = _step50.value;
          r.indexOf(o) < 0 && Ka.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
    }

    return t;
  };

  function Qa(e) {
    var r = e,
        _r$component6 = r.component,
        t = _r$component6 === void 0 ? "div" : _r$component6,
        o = r.color,
        _r$size7 = r.size,
        a = _r$size7 === void 0 ? 25 : _r$size7,
        n = r.style,
        _r$radius7 = r.radius,
        i = _r$radius7 === void 0 ? 25 : _r$radius7,
        s = r.className,
        c = r.themeOverride,
        d = ru(r, ["component", "color", "size", "style", "radius", "className", "themeOverride"]);
    var f = Qp({
      radius: i,
      theme: j(c)
    });
    return l.createElement(t, Ja({
      className: P(f.colorSwatch, s),
      style: Ja({
        width: a,
        height: a,
        backgroundColor: o
      }, n)
    }, d));
  }

  Qa.displayName = "@mantine/core/ColorSwatch";
  var en = {
    xs: 570,
    sm: 770,
    md: 970,
    lg: 1170,
    xl: 1370
  };

  var tu = L({
    container: function container(_ref44) {
      var e = _ref44.fluid,
          r = _ref44.size,
          t = _ref44.padding,
          o = _ref44.theme;
      return {
        maxWidth: e ? "100%" : _({
          size: r,
          sizes: en
        }),
        marginLeft: "auto",
        marginRight: "auto",
        paddingLeft: _({
          size: t,
          sizes: o.spacing
        }),
        paddingRight: _({
          size: t,
          sizes: o.spacing
        })
      };
    }
  }),
      ou = Object.defineProperty,
      lr = Object.getOwnPropertySymbols,
      rn = Object.prototype.hasOwnProperty,
      tn = Object.prototype.propertyIsEnumerable,
      on = function on(e, r, t) {
    return r in e ? ou(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      au = function au(e, r) {
    for (var t in r || (r = {})) {
      rn.call(r, t) && on(e, t, r[t]);
    }

    if (lr) {
      var _iterator51 = _createForOfIteratorHelper(lr(r)),
          _step51;

      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var t = _step51.value;
          tn.call(r, t) && on(e, t, r[t]);
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
    }

    return e;
  },
      nu = function nu(e, r) {
    var t = {};

    for (var o in e) {
      rn.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && lr) {
      var _iterator52 = _createForOfIteratorHelper(lr(e)),
          _step52;

      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var o = _step52.value;
          r.indexOf(o) < 0 && tn.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
    }

    return t;
  };

  var iu = en;

  function an(e) {
    var r = e,
        t = r.className,
        _r$padding3 = r.padding,
        o = _r$padding3 === void 0 ? "md" : _r$padding3,
        a = r.fluid,
        n = r.size,
        i = r.themeOverride,
        s = nu(r, ["className", "padding", "fluid", "size", "themeOverride"]);
    var c = tu({
      padding: o,
      fluid: a,
      size: n,
      theme: j(i)
    });
    return l.createElement("div", au({
      className: P(c.container, t)
    }, s));
  }

  an.displayName = "@mantine/core/Container";

  var lu = Object.defineProperty,
      sr = Object.getOwnPropertySymbols,
      nn = Object.prototype.hasOwnProperty,
      ln = Object.prototype.propertyIsEnumerable,
      sn = function sn(e, r, t) {
    return r in e ? lu(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      cn = function cn(e, r) {
    for (var t in r || (r = {})) {
      nn.call(r, t) && sn(e, t, r[t]);
    }

    if (sr) {
      var _iterator53 = _createForOfIteratorHelper(sr(r)),
          _step53;

      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var t = _step53.value;
          ln.call(r, t) && sn(e, t, r[t]);
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    }

    return e;
  },
      su = function su(e, r) {
    var t = {};

    for (var o in e) {
      nn.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && sr) {
      var _iterator54 = _createForOfIteratorHelper(sr(e)),
          _step54;

      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var o = _step54.value;
          r.indexOf(o) < 0 && ln.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
    }

    return t;
  };

  function Ie(e) {
    var r = e,
        _r$opacity = r.opacity,
        t = _r$opacity === void 0 ? .6 : _r$opacity,
        _r$color4 = r.color,
        o = _r$color4 === void 0 ? "#fff" : _r$color4,
        _r$zIndex = r.zIndex,
        a = _r$zIndex === void 0 ? 1e3 : _r$zIndex,
        n = r.style,
        _r$component7 = r.component,
        i = _r$component7 === void 0 ? "div" : _r$component7,
        s = su(r, ["opacity", "color", "zIndex", "style", "component"]);
    return l.createElement(i, cn({
      style: cn({
        opacity: t,
        backgroundColor: o,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: a
      }, n)
    }, s));
  }

  Ie.displayName = "@mantine/core/Overlay";

  function cr(_ref45) {
    var e = _ref45.children,
        _ref45$zIndex = _ref45.zIndex,
        r = _ref45$zIndex === void 0 ? 1 : _ref45$zIndex,
        t = _ref45.target,
        o = _ref45.className;

    var _E$useState3 = E.useState(!1),
        _E$useState4 = _slicedToArray(_E$useState3, 2),
        a = _E$useState4[0],
        n = _E$useState4[1],
        i = E.useRef();

    return V.useIsomorphicEffect(function () {
      return n(!0), i.current = t || document.createElement("div"), t || document.body.appendChild(i.current), function () {
        !t && document.body.removeChild(i.current);
      };
    }, [t]), a ? qt.createPortal(l.createElement("div", {
      className: o,
      style: {
        position: "relative",
        zIndex: r
      },
      "data-mantine-portal": !0
    }, e), i.current) : null;
  }

  cr.displayName = "@mantine/core/Portal";

  function Et() {
    return Et = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var o in t) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }, Et.apply(this, arguments);
  }

  function dn(e, r) {
    if (e == null) return {};
    var t = {},
        o = Object.keys(e),
        a,
        n;

    for (n = 0; n < o.length; n++) {
      a = o[n], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
    }

    return t;
  }

  function xt(e, r) {
    return xt = Object.setPrototypeOf || function (o, a) {
      return o.__proto__ = a, o;
    }, xt(e, r);
  }

  function cu(e, r) {
    e.prototype = Object.create(r.prototype), e.prototype.constructor = e, xt(e, r);
  }

  var Ct = {
    exports: {}
  },
      dr = {
    exports: {}
  },
      K = {};
  /** @license React v16.13.1
  * react-is.production.min.js
  *
  * Copyright (c) Facebook, Inc. and its affiliates.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */

  var te = typeof Symbol == "function" && Symbol.for,
      It = te ? Symbol.for("react.element") : 60103,
      Nt = te ? Symbol.for("react.portal") : 60106,
      fr = te ? Symbol.for("react.fragment") : 60107,
      pr = te ? Symbol.for("react.strict_mode") : 60108,
      ur = te ? Symbol.for("react.profiler") : 60114,
      vr = te ? Symbol.for("react.provider") : 60109,
      mr = te ? Symbol.for("react.context") : 60110,
      kt = te ? Symbol.for("react.async_mode") : 60111,
      gr = te ? Symbol.for("react.concurrent_mode") : 60111,
      _r = te ? Symbol.for("react.forward_ref") : 60112,
      yr = te ? Symbol.for("react.suspense") : 60113,
      du = te ? Symbol.for("react.suspense_list") : 60120,
      br = te ? Symbol.for("react.memo") : 60115,
      Or = te ? Symbol.for("react.lazy") : 60116,
      fu = te ? Symbol.for("react.block") : 60121,
      pu = te ? Symbol.for("react.fundamental") : 60117,
      uu = te ? Symbol.for("react.responder") : 60118,
      vu = te ? Symbol.for("react.scope") : 60119;

  function ie(e) {
    if (_typeof(e) == "object" && e !== null) {
      var r = e.$$typeof;

      switch (r) {
        case It:
          switch (e = e.type, e) {
            case kt:
            case gr:
            case fr:
            case ur:
            case pr:
            case yr:
              return e;

            default:
              switch (e = e && e.$$typeof, e) {
                case mr:
                case _r:
                case Or:
                case br:
                case vr:
                  return e;

                default:
                  return r;
              }

          }

        case Nt:
          return r;
      }
    }
  }

  function fn(e) {
    return ie(e) === gr;
  }

  K.AsyncMode = kt, K.ConcurrentMode = gr, K.ContextConsumer = mr, K.ContextProvider = vr, K.Element = It, K.ForwardRef = _r, K.Fragment = fr, K.Lazy = Or, K.Memo = br, K.Portal = Nt, K.Profiler = ur, K.StrictMode = pr, K.Suspense = yr, K.isAsyncMode = function (e) {
    return fn(e) || ie(e) === kt;
  }, K.isConcurrentMode = fn, K.isContextConsumer = function (e) {
    return ie(e) === mr;
  }, K.isContextProvider = function (e) {
    return ie(e) === vr;
  }, K.isElement = function (e) {
    return _typeof(e) == "object" && e !== null && e.$$typeof === It;
  }, K.isForwardRef = function (e) {
    return ie(e) === _r;
  }, K.isFragment = function (e) {
    return ie(e) === fr;
  }, K.isLazy = function (e) {
    return ie(e) === Or;
  }, K.isMemo = function (e) {
    return ie(e) === br;
  }, K.isPortal = function (e) {
    return ie(e) === Nt;
  }, K.isProfiler = function (e) {
    return ie(e) === ur;
  }, K.isStrictMode = function (e) {
    return ie(e) === pr;
  }, K.isSuspense = function (e) {
    return ie(e) === yr;
  }, K.isValidElementType = function (e) {
    return typeof e == "string" || typeof e == "function" || e === fr || e === gr || e === ur || e === pr || e === yr || e === du || _typeof(e) == "object" && e !== null && (e.$$typeof === Or || e.$$typeof === br || e.$$typeof === vr || e.$$typeof === mr || e.$$typeof === _r || e.$$typeof === pu || e.$$typeof === uu || e.$$typeof === vu || e.$$typeof === fu);
  }, K.typeOf = ie;
  var X = {};
  /** @license React v16.13.1
  * react-is.development.js
  *
  * Copyright (c) Facebook, Inc. and its affiliates.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */

  process.env.NODE_ENV !== "production" && function () {
    var e = typeof Symbol == "function" && Symbol.for,
        r = e ? Symbol.for("react.element") : 60103,
        t = e ? Symbol.for("react.portal") : 60106,
        o = e ? Symbol.for("react.fragment") : 60107,
        a = e ? Symbol.for("react.strict_mode") : 60108,
        n = e ? Symbol.for("react.profiler") : 60114,
        i = e ? Symbol.for("react.provider") : 60109,
        s = e ? Symbol.for("react.context") : 60110,
        c = e ? Symbol.for("react.async_mode") : 60111,
        d = e ? Symbol.for("react.concurrent_mode") : 60111,
        f = e ? Symbol.for("react.forward_ref") : 60112,
        p = e ? Symbol.for("react.suspense") : 60113,
        u = e ? Symbol.for("react.suspense_list") : 60120,
        g = e ? Symbol.for("react.memo") : 60115,
        y = e ? Symbol.for("react.lazy") : 60116,
        b = e ? Symbol.for("react.block") : 60121,
        S = e ? Symbol.for("react.fundamental") : 60117,
        I = e ? Symbol.for("react.responder") : 60118,
        N = e ? Symbol.for("react.scope") : 60119;

    function k(T) {
      return typeof T == "string" || typeof T == "function" || T === o || T === d || T === n || T === a || T === p || T === u || _typeof(T) == "object" && T !== null && (T.$$typeof === y || T.$$typeof === g || T.$$typeof === i || T.$$typeof === s || T.$$typeof === f || T.$$typeof === S || T.$$typeof === I || T.$$typeof === N || T.$$typeof === b);
    }

    function x(T) {
      if (_typeof(T) == "object" && T !== null) {
        var Yt = T.$$typeof;

        switch (Yt) {
          case r:
            var Ot = T.type;

            switch (Ot) {
              case c:
              case d:
              case o:
              case n:
              case a:
              case p:
                return Ot;

              default:
                var kc = Ot && Ot.$$typeof;

                switch (kc) {
                  case s:
                  case f:
                  case y:
                  case g:
                  case i:
                    return kc;

                  default:
                    return Yt;
                }

            }

          case t:
            return Yt;
        }
      }
    }

    var A = c,
        q = d,
        z = s,
        R = i,
        B = r,
        F = f,
        J = o,
        v = y,
        O = g,
        h = t,
        C = n,
        $ = a,
        H = p,
        M = !1;

    function D(T) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Y(T) || x(T) === c;
    }

    function Y(T) {
      return x(T) === d;
    }

    function U(T) {
      return x(T) === s;
    }

    function G(T) {
      return x(T) === i;
    }

    function oe(T) {
      return _typeof(T) == "object" && T !== null && T.$$typeof === r;
    }

    function Z(T) {
      return x(T) === f;
    }

    function ee(T) {
      return x(T) === o;
    }

    function bt(T) {
      return x(T) === y;
    }

    function jb(T) {
      return x(T) === g;
    }

    function Rb(T) {
      return x(T) === t;
    }

    function Tb(T) {
      return x(T) === n;
    }

    function zb(T) {
      return x(T) === a;
    }

    function Db(T) {
      return x(T) === p;
    }

    X.AsyncMode = A, X.ConcurrentMode = q, X.ContextConsumer = z, X.ContextProvider = R, X.Element = B, X.ForwardRef = F, X.Fragment = J, X.Lazy = v, X.Memo = O, X.Portal = h, X.Profiler = C, X.StrictMode = $, X.Suspense = H, X.isAsyncMode = D, X.isConcurrentMode = Y, X.isContextConsumer = U, X.isContextProvider = G, X.isElement = oe, X.isForwardRef = Z, X.isFragment = ee, X.isLazy = bt, X.isMemo = jb, X.isPortal = Rb, X.isProfiler = Tb, X.isStrictMode = zb, X.isSuspense = Db, X.isValidElementType = k, X.typeOf = x;
  }(), process.env.NODE_ENV === "production" ? dr.exports = K : dr.exports = X;
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var pn = Object.getOwnPropertySymbols,
      mu = Object.prototype.hasOwnProperty,
      gu = Object.prototype.propertyIsEnumerable;

  function _u(e) {
    if (e == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  function yu() {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;

      for (var r = {}, t = 0; t < 10; t++) {
        r["_" + String.fromCharCode(t)] = t;
      }

      var o = Object.getOwnPropertyNames(r).map(function (n) {
        return r[n];
      });
      if (o.join("") !== "0123456789") return !1;
      var a = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (n) {
        a[n] = n;
      }), Object.keys(Object.assign({}, a)).join("") === "abcdefghijklmnopqrst";
    } catch (n) {
      return !1;
    }
  }

  var bu = yu() ? Object.assign : function (e, r) {
    for (var t, o = _u(e), a, n = 1; n < arguments.length; n++) {
      t = Object(arguments[n]);

      for (var i in t) {
        mu.call(t, i) && (o[i] = t[i]);
      }

      if (pn) {
        a = pn(t);

        for (var s = 0; s < a.length; s++) {
          gu.call(t, a[s]) && (o[a[s]] = t[a[s]]);
        }
      }
    }

    return o;
  },
      Ou = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
      jt = Ou,
      Rt = function Rt() {};

  if (process.env.NODE_ENV !== "production") {
    var hu = jt,
        Tt = {},
        wu = Function.call.bind(Object.prototype.hasOwnProperty);

    Rt = function Rt(e) {
      var r = "Warning: " + e;
      typeof console != "undefined" && console.error(r);

      try {
        throw new Error(r);
      } catch (t) {}
    };
  }

  function un(e, r, t, o, a) {
    if (process.env.NODE_ENV !== "production") {
      for (var n in e) {
        if (wu(e, n)) {
          var i;

          try {
            if (typeof e[n] != "function") {
              var s = Error((o || "React class") + ": " + t + " type `" + n + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _typeof(e[n]) + "`.");
              throw s.name = "Invariant Violation", s;
            }

            i = e[n](r, n, o, t, null, hu);
          } catch (d) {
            i = d;
          }

          if (i && !(i instanceof Error) && Rt((o || "React class") + ": type specification of " + t + " `" + n + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + _typeof(i) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in Tt)) {
            Tt[i.message] = !0;
            var c = a ? a() : "";
            Rt("Failed " + t + " type: " + i.message + (c != null ? c : ""));
          }
        }
      }
    }
  }

  un.resetWarningCache = function () {
    process.env.NODE_ENV !== "production" && (Tt = {});
  };

  var Pu = un,
      $u = dr.exports,
      Su = bu,
      _e = jt,
      vn = Pu,
      Eu = Function.call.bind(Object.prototype.hasOwnProperty),
      ye = function ye() {};

  process.env.NODE_ENV !== "production" && (ye = function ye(e) {
    var r = "Warning: " + e;
    typeof console != "undefined" && console.error(r);

    try {
      throw new Error(r);
    } catch (t) {}
  });

  function hr() {
    return null;
  }

  var xu = function xu(e, r) {
    var t = typeof Symbol == "function" && Symbol.iterator,
        o = "@@iterator";

    function a(v) {
      var O = v && (t && v[t] || v[o]);
      if (typeof O == "function") return O;
    }

    var n = "<<anonymous>>",
        i = {
      array: f("array"),
      bool: f("boolean"),
      func: f("function"),
      number: f("number"),
      object: f("object"),
      string: f("string"),
      symbol: f("symbol"),
      any: p(),
      arrayOf: u,
      element: g(),
      elementType: y(),
      instanceOf: b,
      node: k(),
      objectOf: I,
      oneOf: S,
      oneOfType: N,
      shape: x,
      exact: A
    };

    function s(v, O) {
      return v === O ? v !== 0 || 1 / v == 1 / O : v !== v && O !== O;
    }

    function c(v) {
      this.message = v, this.stack = "";
    }

    c.prototype = Error.prototype;

    function d(v) {
      if (process.env.NODE_ENV !== "production") var O = {},
          h = 0;

      function C(H, M, D, Y, U, G, oe) {
        if (Y = Y || n, G = G || D, oe !== _e) {
          if (r) {
            var Z = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw Z.name = "Invariant Violation", Z;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var ee = Y + ":" + D;
            !O[ee] && h < 3 && (ye("You are manually calling a React.PropTypes validation function for the `" + G + "` prop on `" + Y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), O[ee] = !0, h++);
          }
        }

        return M[D] == null ? H ? M[D] === null ? new c("The " + U + " `" + G + "` is marked as required " + ("in `" + Y + "`, but its value is `null`.")) : new c("The " + U + " `" + G + "` is marked as required in " + ("`" + Y + "`, but its value is `undefined`.")) : null : v(M, D, Y, U, G);
      }

      var $ = C.bind(null, !1);
      return $.isRequired = C.bind(null, !0), $;
    }

    function f(v) {
      function O(h, C, $, H, M, D) {
        var Y = h[C],
            U = R(Y);

        if (U !== v) {
          var G = B(Y);
          return new c("Invalid " + H + " `" + M + "` of type " + ("`" + G + "` supplied to `" + $ + "`, expected ") + ("`" + v + "`."));
        }

        return null;
      }

      return d(O);
    }

    function p() {
      return d(hr);
    }

    function u(v) {
      function O(h, C, $, H, M) {
        if (typeof v != "function") return new c("Property `" + M + "` of component `" + $ + "` has invalid PropType notation inside arrayOf.");
        var D = h[C];

        if (!Array.isArray(D)) {
          var Y = R(D);
          return new c("Invalid " + H + " `" + M + "` of type " + ("`" + Y + "` supplied to `" + $ + "`, expected an array."));
        }

        for (var U = 0; U < D.length; U++) {
          var G = v(D, U, $, H, M + "[" + U + "]", _e);
          if (G instanceof Error) return G;
        }

        return null;
      }

      return d(O);
    }

    function g() {
      function v(O, h, C, $, H) {
        var M = O[h];

        if (!e(M)) {
          var D = R(M);
          return new c("Invalid " + $ + " `" + H + "` of type " + ("`" + D + "` supplied to `" + C + "`, expected a single ReactElement."));
        }

        return null;
      }

      return d(v);
    }

    function y() {
      function v(O, h, C, $, H) {
        var M = O[h];

        if (!$u.isValidElementType(M)) {
          var D = R(M);
          return new c("Invalid " + $ + " `" + H + "` of type " + ("`" + D + "` supplied to `" + C + "`, expected a single ReactElement type."));
        }

        return null;
      }

      return d(v);
    }

    function b(v) {
      function O(h, C, $, H, M) {
        if (!(h[C] instanceof v)) {
          var D = v.name || n,
              Y = J(h[C]);
          return new c("Invalid " + H + " `" + M + "` of type " + ("`" + Y + "` supplied to `" + $ + "`, expected ") + ("instance of `" + D + "`."));
        }

        return null;
      }

      return d(O);
    }

    function S(v) {
      if (!Array.isArray(v)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? ye("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : ye("Invalid argument supplied to oneOf, expected an array.")), hr;

      function O(h, C, $, H, M) {
        for (var D = h[C], Y = 0; Y < v.length; Y++) {
          if (s(D, v[Y])) return null;
        }

        var U = JSON.stringify(v, function (oe, Z) {
          var ee = B(Z);
          return ee === "symbol" ? String(Z) : Z;
        });
        return new c("Invalid " + H + " `" + M + "` of value `" + String(D) + "` " + ("supplied to `" + $ + "`, expected one of " + U + "."));
      }

      return d(O);
    }

    function I(v) {
      function O(h, C, $, H, M) {
        if (typeof v != "function") return new c("Property `" + M + "` of component `" + $ + "` has invalid PropType notation inside objectOf.");
        var D = h[C],
            Y = R(D);
        if (Y !== "object") return new c("Invalid " + H + " `" + M + "` of type " + ("`" + Y + "` supplied to `" + $ + "`, expected an object."));

        for (var U in D) {
          if (Eu(D, U)) {
            var G = v(D, U, $, H, M + "." + U, _e);
            if (G instanceof Error) return G;
          }
        }

        return null;
      }

      return d(O);
    }

    function N(v) {
      if (!Array.isArray(v)) return process.env.NODE_ENV !== "production" && ye("Invalid argument supplied to oneOfType, expected an instance of array."), hr;

      for (var O = 0; O < v.length; O++) {
        var h = v[O];
        if (typeof h != "function") return ye("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(h) + " at index " + O + "."), hr;
      }

      function C($, H, M, D, Y) {
        for (var U = 0; U < v.length; U++) {
          var G = v[U];
          if (G($, H, M, D, Y, _e) == null) return null;
        }

        return new c("Invalid " + D + " `" + Y + "` supplied to " + ("`" + M + "`."));
      }

      return d(C);
    }

    function k() {
      function v(O, h, C, $, H) {
        return q(O[h]) ? null : new c("Invalid " + $ + " `" + H + "` supplied to " + ("`" + C + "`, expected a ReactNode."));
      }

      return d(v);
    }

    function x(v) {
      function O(h, C, $, H, M) {
        var D = h[C],
            Y = R(D);
        if (Y !== "object") return new c("Invalid " + H + " `" + M + "` of type `" + Y + "` " + ("supplied to `" + $ + "`, expected `object`."));

        for (var U in v) {
          var G = v[U];

          if (!!G) {
            var oe = G(D, U, $, H, M + "." + U, _e);
            if (oe) return oe;
          }
        }

        return null;
      }

      return d(O);
    }

    function A(v) {
      function O(h, C, $, H, M) {
        var D = h[C],
            Y = R(D);
        if (Y !== "object") return new c("Invalid " + H + " `" + M + "` of type `" + Y + "` " + ("supplied to `" + $ + "`, expected `object`."));
        var U = Su({}, h[C], v);

        for (var G in U) {
          var oe = v[G];
          if (!oe) return new c("Invalid " + H + " `" + M + "` key `" + G + "` supplied to `" + $ + "`.\nBad object: " + JSON.stringify(h[C], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(v), null, "  "));
          var Z = oe(D, G, $, H, M + "." + G, _e);
          if (Z) return Z;
        }

        return null;
      }

      return d(O);
    }

    function q(v) {
      switch (_typeof(v)) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !v;

        case "object":
          if (Array.isArray(v)) return v.every(q);
          if (v === null || e(v)) return !0;
          var O = a(v);

          if (O) {
            var h = O.call(v),
                C;

            if (O !== v.entries) {
              for (; !(C = h.next()).done;) {
                if (!q(C.value)) return !1;
              }
            } else for (; !(C = h.next()).done;) {
              var $ = C.value;
              if ($ && !q($[1])) return !1;
            }
          } else return !1;

          return !0;

        default:
          return !1;
      }
    }

    function z(v, O) {
      return v === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
    }

    function R(v) {
      var O = _typeof(v);

      return Array.isArray(v) ? "array" : v instanceof RegExp ? "object" : z(O, v) ? "symbol" : O;
    }

    function B(v) {
      if (typeof v == "undefined" || v === null) return "" + v;
      var O = R(v);

      if (O === "object") {
        if (v instanceof Date) return "date";
        if (v instanceof RegExp) return "regexp";
      }

      return O;
    }

    function F(v) {
      var O = B(v);

      switch (O) {
        case "array":
        case "object":
          return "an " + O;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;

        default:
          return O;
      }
    }

    function J(v) {
      return !v.constructor || !v.constructor.name ? n : v.constructor.name;
    }

    return i.checkPropTypes = vn, i.resetWarningCache = vn.resetWarningCache, i.PropTypes = i, i;
  },
      Cu = jt;

  function mn() {}

  function gn() {}

  gn.resetWarningCache = mn;

  var Iu = function Iu() {
    function e(o, a, n, i, s, c) {
      if (c !== Cu) {
        var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw d.name = "Invariant Violation", d;
      }
    }

    e.isRequired = e;

    function r() {
      return e;
    }

    var t = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: r,
      element: e,
      elementType: e,
      instanceOf: r,
      node: e,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: gn,
      resetWarningCache: mn
    };
    return t.PropTypes = t, t;
  };

  if (process.env.NODE_ENV !== "production") {
    var Nu = dr.exports,
        ku = !0;
    Ct.exports = xu(Nu.isElement, ku);
  } else Ct.exports = Iu();

  var W = Ct.exports,
      _n = {
    disabled: !1
  },
      ju = process.env.NODE_ENV !== "production" ? W.oneOfType([W.number, W.shape({
    enter: W.number,
    exit: W.number,
    appear: W.number
  }).isRequired]) : null;
  process.env.NODE_ENV !== "production" && W.oneOfType([W.string, W.shape({
    enter: W.string,
    exit: W.string,
    active: W.string
  }), W.shape({
    enter: W.string,
    enterDone: W.string,
    enterActive: W.string,
    exit: W.string,
    exitDone: W.string,
    exitActive: W.string
  })]);

  var yn = l.createContext(null),
      Ne = "unmounted",
      ue = "exited",
      ve = "entering",
      be = "entered",
      zt = "exiting",
      se = function (e) {
    cu(r, e);

    function r(o, a) {
      var n;
      n = e.call(this, o, a) || this;
      var i = a,
          s = i && !i.isMounting ? o.enter : o.appear,
          c;
      return n.appearStatus = null, o.in ? s ? (c = ue, n.appearStatus = ve) : c = be : o.unmountOnExit || o.mountOnEnter ? c = Ne : c = ue, n.state = {
        status: c
      }, n.nextCallback = null, n;
    }

    r.getDerivedStateFromProps = function (a, n) {
      var i = a.in;
      return i && n.status === Ne ? {
        status: ue
      } : null;
    };

    var t = r.prototype;
    return t.componentDidMount = function () {
      this.updateStatus(!0, this.appearStatus);
    }, t.componentDidUpdate = function (a) {
      var n = null;

      if (a !== this.props) {
        var i = this.state.status;
        this.props.in ? i !== ve && i !== be && (n = ve) : (i === ve || i === be) && (n = zt);
      }

      this.updateStatus(!1, n);
    }, t.componentWillUnmount = function () {
      this.cancelNextCallback();
    }, t.getTimeouts = function () {
      var a = this.props.timeout,
          n,
          i,
          s;
      return n = i = s = a, a != null && typeof a != "number" && (n = a.exit, i = a.enter, s = a.appear !== void 0 ? a.appear : i), {
        exit: n,
        enter: i,
        appear: s
      };
    }, t.updateStatus = function (a, n) {
      a === void 0 && (a = !1), n !== null ? (this.cancelNextCallback(), n === ve ? this.performEnter(a) : this.performExit()) : this.props.unmountOnExit && this.state.status === ue && this.setState({
        status: Ne
      });
    }, t.performEnter = function (a) {
      var n = this,
          i = this.props.enter,
          s = this.context ? this.context.isMounting : a,
          c = this.props.nodeRef ? [s] : [ht.findDOMNode(this), s],
          d = c[0],
          f = c[1],
          p = this.getTimeouts(),
          u = s ? p.appear : p.enter;

      if (!a && !i || _n.disabled) {
        this.safeSetState({
          status: be
        }, function () {
          n.props.onEntered(d);
        });
        return;
      }

      this.props.onEnter(d, f), this.safeSetState({
        status: ve
      }, function () {
        n.props.onEntering(d, f), n.onTransitionEnd(u, function () {
          n.safeSetState({
            status: be
          }, function () {
            n.props.onEntered(d, f);
          });
        });
      });
    }, t.performExit = function () {
      var a = this,
          n = this.props.exit,
          i = this.getTimeouts(),
          s = this.props.nodeRef ? void 0 : ht.findDOMNode(this);

      if (!n || _n.disabled) {
        this.safeSetState({
          status: ue
        }, function () {
          a.props.onExited(s);
        });
        return;
      }

      this.props.onExit(s), this.safeSetState({
        status: zt
      }, function () {
        a.props.onExiting(s), a.onTransitionEnd(i.exit, function () {
          a.safeSetState({
            status: ue
          }, function () {
            a.props.onExited(s);
          });
        });
      });
    }, t.cancelNextCallback = function () {
      this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
    }, t.safeSetState = function (a, n) {
      n = this.setNextCallback(n), this.setState(a, n);
    }, t.setNextCallback = function (a) {
      var n = this,
          i = !0;
      return this.nextCallback = function (s) {
        i && (i = !1, n.nextCallback = null, a(s));
      }, this.nextCallback.cancel = function () {
        i = !1;
      }, this.nextCallback;
    }, t.onTransitionEnd = function (a, n) {
      this.setNextCallback(n);
      var i = this.props.nodeRef ? this.props.nodeRef.current : ht.findDOMNode(this),
          s = a == null && !this.props.addEndListener;

      if (!i || s) {
        setTimeout(this.nextCallback, 0);
        return;
      }

      if (this.props.addEndListener) {
        var c = this.props.nodeRef ? [this.nextCallback] : [i, this.nextCallback],
            d = c[0],
            f = c[1];
        this.props.addEndListener(d, f);
      }

      a != null && setTimeout(this.nextCallback, a);
    }, t.render = function () {
      var a = this.state.status;
      if (a === Ne) return null;
      var n = this.props,
          i = n.children;
      n.in, n.mountOnEnter, n.unmountOnExit, n.appear, n.enter, n.exit, n.timeout, n.addEndListener, n.onEnter, n.onEntering, n.onEntered, n.onExit, n.onExiting, n.onExited, n.nodeRef;
      var s = dn(n, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
      return l.createElement(yn.Provider, {
        value: null
      }, typeof i == "function" ? i(a, s) : l.cloneElement(l.Children.only(i), s));
    }, r;
  }(l.Component);

  se.contextType = yn, se.propTypes = process.env.NODE_ENV !== "production" ? {
    nodeRef: W.shape({
      current: typeof Element == "undefined" ? W.any : function (e, r, t, o, a, n) {
        var i = e[r];
        return W.instanceOf(i && "ownerDocument" in i ? i.ownerDocument.defaultView.Element : Element)(e, r, t, o, a, n);
      }
    }),
    children: W.oneOfType([W.func.isRequired, W.element.isRequired]).isRequired,
    in: W.bool,
    mountOnEnter: W.bool,
    unmountOnExit: W.bool,
    appear: W.bool,
    enter: W.bool,
    exit: W.bool,
    timeout: function timeout(r) {
      var t = ju;
      r.addEndListener || (t = t.isRequired);

      for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), n = 1; n < o; n++) {
        a[n - 1] = arguments[n];
      }

      return t.apply(void 0, [r].concat(a));
    },
    addEndListener: W.func,
    onEnter: W.func,
    onEntering: W.func,
    onEntered: W.func,
    onExit: W.func,
    onExiting: W.func,
    onExited: W.func
  } : {};

  function Oe() {}

  se.defaultProps = {
    in: !1,
    mountOnEnter: !1,
    unmountOnExit: !1,
    appear: !1,
    enter: !0,
    exit: !0,
    onEnter: Oe,
    onEntering: Oe,
    onEntered: Oe,
    onExit: Oe,
    onExiting: Oe,
    onExited: Oe
  }, se.UNMOUNTED = Ne, se.EXITED = ue, se.ENTERING = ve, se.ENTERED = be, se.EXITING = zt;
  var ke = {
    fade: {
      in: {
        opacity: 1
      },
      out: {
        opacity: 0
      },
      transitionProperty: "opacity"
    },
    "skew-up": {
      in: {
        opacity: 1,
        transform: "translateY(0) skew(0deg, 0deg)"
      },
      out: {
        opacity: 0,
        transform: "translateY(-20px) skew(-10deg, -5deg)"
      },
      common: {
        transformOrigin: "top"
      },
      transitionProperty: "transform, opacity"
    },
    "skew-down": {
      in: {
        opacity: 1,
        transform: "translateY(0) skew(0deg, 0deg)"
      },
      out: {
        opacity: 0,
        transform: "translateY(20px) skew(-10deg, -5deg)"
      },
      common: {
        transformOrigin: "bottom"
      },
      transitionProperty: "transform, opacity"
    },
    "rotate-left": {
      in: {
        opacity: 1,
        transform: "translateY(0) rotate(0deg)"
      },
      out: {
        opacity: 0,
        transform: "translateY(20px) rotate(-5deg)"
      },
      common: {
        transformOrigin: "bottom"
      },
      transitionProperty: "transform, opacity"
    },
    "rotate-right": {
      in: {
        opacity: 1,
        transform: "translateY(0) rotate(0deg)"
      },
      out: {
        opacity: 0,
        transform: "translateY(20px) rotate(5deg)"
      },
      common: {
        transformOrigin: "top"
      },
      transitionProperty: "transform, opacity"
    },
    "slide-down": {
      in: {
        opacity: 1,
        transform: "translateY(0)"
      },
      out: {
        opacity: 0,
        transform: "translateY(-100%)"
      },
      common: {
        transformOrigin: "top"
      },
      transitionProperty: "transform, opacity"
    },
    "slide-up": {
      in: {
        opacity: 1,
        transform: "translateY(0)"
      },
      out: {
        opacity: 0,
        transform: "translateY(100%)"
      },
      common: {
        transformOrigin: "bottom"
      },
      transitionProperty: "transform, opacity"
    },
    "slide-left": {
      in: {
        opacity: 1,
        transform: "translateX(0)"
      },
      out: {
        opacity: 0,
        transform: "translateX(100%)"
      },
      common: {
        transformOrigin: "left"
      },
      transitionProperty: "transform, opacity"
    },
    "slide-right": {
      in: {
        opacity: 1,
        transform: "translateX(0)"
      },
      out: {
        opacity: 0,
        transform: "translateX(-100%)"
      },
      common: {
        transformOrigin: "right"
      },
      transitionProperty: "transform, opacity"
    }
  };

  var Ru = Object.defineProperty,
      bn = Object.getOwnPropertySymbols,
      Tu = Object.prototype.hasOwnProperty,
      zu = Object.prototype.propertyIsEnumerable,
      On = function On(e, r, t) {
    return r in e ? Ru(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      he = function he(e, r) {
    for (var t in r || (r = {})) {
      Tu.call(r, t) && On(e, t, r[t]);
    }

    if (bn) {
      var _iterator55 = _createForOfIteratorHelper(bn(r)),
          _step55;

      try {
        for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
          var t = _step55.value;
          zu.call(r, t) && On(e, t, r[t]);
        }
      } catch (err) {
        _iterator55.e(err);
      } finally {
        _iterator55.f();
      }
    }

    return e;
  };

  var hn = {
    entering: "in",
    entered: "in",
    exiting: "out",
    exited: "out"
  };

  function wn(_ref46) {
    var e = _ref46.transition,
        r = _ref46.state,
        t = _ref46.duration,
        o = _ref46.timingFunction;
    var a = {
      transitionDuration: "".concat(t, "ms"),
      transitionTimingFunction: o
    };
    return typeof e == "string" ? e in ke ? he(he(he({
      transitionProperty: ke[e].transitionProperty
    }, a), ke[e].common), ke[e][hn[r]]) : null : he(he(he({
      transitionProperty: e.transitionProperty
    }, a), e.common), e[hn[r]]);
  }

  function wr(_ref47) {
    var e = _ref47.transitions,
        r = _ref47.mounted,
        t = _ref47.children,
        o = _ref47.themeOverride;
    var a = j(o),
        n = Math.max.apply(Math, _toConsumableArray(Object.keys(e).map(function (i) {
      return e[i].duration;
    })));
    return l.createElement(se, {
      in: r,
      timeout: n,
      unmountOnExit: !0,
      mountOnEnter: !0,
      onEnter: function onEnter(i) {
        return i.offsetHeight;
      }
    }, function (i) {
      var s = Object.keys(e).reduce(function (c, d) {
        return c[d] = wn({
          duration: e[d].duration,
          transition: e[d].transition,
          timingFunction: e[d].timingFunction || a.transitionTimingFunction,
          state: i
        }), c;
      }, {});
      return t(s);
    });
  }

  wr.displayName = "@mantine/core/GroupedTransition";
  var Du = Object.keys(ke);

  function we(_ref48) {
    var e = _ref48.transition,
        _ref48$duration = _ref48.duration,
        r = _ref48$duration === void 0 ? 250 : _ref48$duration,
        t = _ref48.mounted,
        o = _ref48.children,
        a = _ref48.themeOverride,
        n = _ref48.timingFunction,
        i = _ref48.onExit,
        s = _ref48.onEntered,
        c = _ref48.onEnter,
        d = _ref48.onExited;
    var f = j(a),
        p = V.useReducedMotion();
    return l.createElement(se, {
      in: t,
      timeout: r,
      unmountOnExit: !0,
      mountOnEnter: !0,
      onEnter: function onEnter(u) {
        u.offsetHeight, typeof c == "function" && c();
      },
      onExited: d,
      onEntered: s,
      onExit: i
    }, function (u) {
      return o(wn({
        transition: e,
        duration: p ? 0 : r,
        state: u,
        timingFunction: n || f.transitionTimingFunction
      }));
    });
  }

  we.displayName = "@mantine/core/Transition";

  var Mu = Object.defineProperty,
      Au = Object.defineProperties,
      Lu = Object.getOwnPropertyDescriptors,
      Pn = Object.getOwnPropertySymbols,
      Hu = Object.prototype.hasOwnProperty,
      Vu = Object.prototype.propertyIsEnumerable,
      $n = function $n(e, r, t) {
    return r in e ? Mu(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Bu = function Bu(e, r) {
    for (var t in r || (r = {})) {
      Hu.call(r, t) && $n(e, t, r[t]);
    }

    if (Pn) {
      var _iterator56 = _createForOfIteratorHelper(Pn(r)),
          _step56;

      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var t = _step56.value;
          Vu.call(r, t) && $n(e, t, r[t]);
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }
    }

    return e;
  },
      Fu = function Fu(e, r) {
    return Au(e, Lu(r));
  };

  var je = {
    xs: 180,
    sm: 240,
    md: 320,
    lg: 360,
    xl: 500,
    full: "100%"
  };

  function Wu(_ref49) {
    var e = _ref49.position,
        r = _ref49.size;

    switch (e) {
      case "top":
        return {
          top: 0,
          left: 0,
          right: 0,
          height: _({
            size: r,
            sizes: je
          })
        };

      case "bottom":
        return {
          bottom: 0,
          left: 0,
          right: 0,
          height: _({
            size: r,
            sizes: je
          })
        };

      case "right":
        return {
          bottom: 0,
          top: 0,
          right: 0,
          width: _({
            size: r,
            sizes: je
          })
        };

      case "left":
        return {
          bottom: 0,
          top: 0,
          left: 0,
          width: _({
            size: r,
            sizes: je
          })
        };

      default:
        return null;
    }
  }

  var Zu = L({
    noOverlay: {},
    wrapper: {
      "&:not($noOverlay)": {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    },
    drawer: function drawer(_ref50) {
      var e = _ref50.size,
          r = _ref50.position;
      return Fu(Bu({}, Wu({
        position: r,
        size: e
      })), {
        maxWidth: "100%",
        maxHeight: "100vh",
        position: "fixed",
        outline: 0
      });
    }
  }),
      Yu = Object.defineProperty,
      qu = Object.defineProperties,
      Uu = Object.getOwnPropertyDescriptors,
      Pr = Object.getOwnPropertySymbols,
      Sn = Object.prototype.hasOwnProperty,
      En = Object.prototype.propertyIsEnumerable,
      xn = function xn(e, r, t) {
    return r in e ? Yu(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Dt = function Dt(e, r) {
    for (var t in r || (r = {})) {
      Sn.call(r, t) && xn(e, t, r[t]);
    }

    if (Pr) {
      var _iterator57 = _createForOfIteratorHelper(Pr(r)),
          _step57;

      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var t = _step57.value;
          En.call(r, t) && xn(e, t, r[t]);
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
    }

    return e;
  },
      Gu = function Gu(e, r) {
    return qu(e, Uu(r));
  },
      Ku = function Ku(e, r) {
    var t = {};

    for (var o in e) {
      Sn.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Pr) {
      var _iterator58 = _createForOfIteratorHelper(Pr(e)),
          _step58;

      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var o = _step58.value;
          r.indexOf(o) < 0 && En.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
    }

    return t;
  };

  var Xu = je,
      Ju = {
    top: "slide-down",
    bottom: "slide-up",
    left: "slide-right",
    right: "slide-left"
  };

  function Qu(e) {
    var r = e,
        t = r.opened,
        o = r.onClose,
        a = r.className,
        n = r.themeOverride,
        _r$position = r.position,
        i = _r$position === void 0 ? "left" : _r$position,
        _r$size8 = r.size,
        s = _r$size8 === void 0 ? "md" : _r$size8,
        _r$noFocusTrap = r.noFocusTrap,
        c = _r$noFocusTrap === void 0 ? !1 : _r$noFocusTrap,
        _r$noScrollLock = r.noScrollLock,
        d = _r$noScrollLock === void 0 ? !1 : _r$noScrollLock,
        _r$noCloseOnClickOuts = r.noCloseOnClickOutside,
        f = _r$noCloseOnClickOuts === void 0 ? !1 : _r$noCloseOnClickOuts,
        _r$noCloseOnEscape = r.noCloseOnEscape,
        p = _r$noCloseOnEscape === void 0 ? !1 : _r$noCloseOnEscape,
        u = r.transition,
        _r$transitionDuration = r.transitionDuration,
        g = _r$transitionDuration === void 0 ? 250 : _r$transitionDuration,
        _r$transitionTimingFu = r.transitionTimingFunction,
        y = _r$transitionTimingFu === void 0 ? "ease" : _r$transitionTimingFu,
        _r$zIndex2 = r.zIndex,
        b = _r$zIndex2 === void 0 ? 1e3 : _r$zIndex2,
        S = r.overlayColor,
        I = r.overlayOpacity,
        N = r.children,
        _r$noOverlay = r.noOverlay,
        k = _r$noOverlay === void 0 ? !1 : _r$noOverlay,
        _r$shadow2 = r.shadow,
        x = _r$shadow2 === void 0 ? "md" : _r$shadow2,
        _r$padding4 = r.padding,
        A = _r$padding4 === void 0 ? 0 : _r$padding4,
        q = Ku(r, ["opened", "onClose", "className", "themeOverride", "position", "size", "noFocusTrap", "noScrollLock", "noCloseOnClickOutside", "noCloseOnEscape", "transition", "transitionDuration", "transitionTimingFunction", "zIndex", "overlayColor", "overlayOpacity", "children", "noOverlay", "shadow", "padding"]);
    var z = j(n),
        R = V.useReducedMotion() ? 1 : g,
        B = Zu({
      theme: z,
      size: s,
      position: i
    }),
        F = V.useFocusTrap(!c);
    V.useScrollLock(t && !d);

    var J = V.useClickOutside(function () {
      return t && !f && o();
    }),
        v = u || Ju[i],
        O = typeof I == "number" ? I : z.colorScheme === "dark" ? .85 : .75,
        h = function h(C) {
      c && C.code === "Escape" && !p && o();
    };

    return E.useEffect(function () {
      if (c) return window.addEventListener("keydown", h), function () {
        return window.removeEventListener("keydown", h);
      };
    }, [c]), l.createElement(wr, {
      mounted: t,
      transitions: {
        overlay: {
          duration: R / 2,
          transition: "fade",
          timingFunction: "ease"
        },
        drawer: {
          duration: R,
          transition: v,
          timingFunction: y
        }
      }
    }, function (C) {
      return l.createElement("div", Dt({
        className: P(B.wrapper, _defineProperty({}, B.noOverlay, k), a),
        role: "dialog",
        "aria-modal": !0
      }, q), l.createElement(ce, {
        className: P(B.drawer, a),
        elementRef: V.useMergedRef(F, J),
        style: Gu(Dt({}, C.drawer), {
          zIndex: b + 1
        }),
        radius: 0,
        tabIndex: -1,
        onKeyDownCapture: function onKeyDownCapture($) {
          return $.nativeEvent.code === "Escape" && !p && o();
        },
        shadow: x,
        padding: A,
        themeOverride: n
      }, N), !k && l.createElement("div", {
        style: C.overlay
      }, l.createElement(Ie, {
        opacity: O,
        zIndex: b,
        color: S || (z.colorScheme === "dark" ? z.colors.dark[9] : z.black)
      })));
    });
  }

  function Cn(e) {
    return l.createElement(cr, {
      zIndex: e.zIndex || 1e3
    }, l.createElement(Qu, Dt({}, e)));
  }

  Cn.displayName = "@mantine/core/Drawer";
  var Mt = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 5
  };

  var ev = L({
    withLabel: {
      borderTop: "0 !important"
    },
    left: {
      "&::before": {
        display: "none"
      }
    },
    right: {
      "&::after": {
        display: "none"
      }
    },
    label: function label(_ref51) {
      var e = _ref51.theme,
          r = _ref51.color,
          t = _ref51.variant;
      return {
        display: "flex",
        alignItems: "center",
        color: r === "dark" ? e.colors.dark[1] : w({
          theme: e,
          color: r,
          shade: 6
        }),
        "&::before": {
          content: '""',
          flex: 1,
          height: 1,
          borderTop: "1px ".concat(t, " ").concat(w({
            theme: e,
            color: r,
            shade: e.colorScheme === "dark" ? 3 : 4
          })),
          marginRight: e.spacing.xs
        },
        "&::after": {
          content: '""',
          flex: 1,
          borderTop: "1px ".concat(t, " ").concat(w({
            theme: e,
            color: r,
            shade: e.colorScheme === "dark" ? 3 : 4
          })),
          marginLeft: e.spacing.xs
        }
      };
    },
    horizontal: function horizontal(_ref52) {
      var e = _ref52.theme,
          r = _ref52.size,
          t = _ref52.variant,
          o = _ref52.color,
          a = _ref52.margins;
      return {
        border: 0,
        borderTopWidth: _({
          size: r,
          sizes: Mt
        }),
        borderTopColor: w({
          theme: e,
          color: o,
          shade: e.colorScheme === "dark" ? 3 : 4
        }),
        borderTopStyle: t,
        margin: 0,
        marginTop: _({
          size: a,
          sizes: e.spacing
        }),
        marginBottom: _({
          size: a,
          sizes: e.spacing
        })
      };
    },
    vertical: function vertical(_ref53) {
      var e = _ref53.theme,
          r = _ref53.size,
          t = _ref53.variant,
          o = _ref53.color,
          a = _ref53.margins;
      return {
        border: 0,
        borderLeftWidth: _({
          size: r,
          sizes: Mt
        }),
        borderLeftColor: w({
          theme: e,
          color: o,
          shade: 4
        }),
        borderLeftStyle: t,
        marginLeft: _({
          size: a,
          sizes: e.spacing
        }),
        marginRight: _({
          size: a,
          sizes: e.spacing
        })
      };
    }
  }),
      rv = Object.defineProperty,
      tv = Object.defineProperties,
      ov = Object.getOwnPropertyDescriptors,
      $r = Object.getOwnPropertySymbols,
      In = Object.prototype.hasOwnProperty,
      Nn = Object.prototype.propertyIsEnumerable,
      kn = function kn(e, r, t) {
    return r in e ? rv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      jn = function jn(e, r) {
    for (var t in r || (r = {})) {
      In.call(r, t) && kn(e, t, r[t]);
    }

    if ($r) {
      var _iterator59 = _createForOfIteratorHelper($r(r)),
          _step59;

      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var t = _step59.value;
          Nn.call(r, t) && kn(e, t, r[t]);
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
    }

    return e;
  },
      av = function av(e, r) {
    return tv(e, ov(r));
  },
      nv = function nv(e, r) {
    var t = {};

    for (var o in e) {
      In.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && $r) {
      var _iterator60 = _createForOfIteratorHelper($r(e)),
          _step60;

      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var o = _step60.value;
          r.indexOf(o) < 0 && Nn.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
    }

    return t;
  };

  var Rn = Mt;

  function Pe(e) {
    var _P3;

    var r = e,
        t = r.color,
        o = r.className,
        _r$orientation = r.orientation,
        a = _r$orientation === void 0 ? "horizontal" : _r$orientation,
        _r$size9 = r.size,
        n = _r$size9 === void 0 ? "xs" : _r$size9,
        i = r.label,
        _r$labelPosition = r.labelPosition,
        s = _r$labelPosition === void 0 ? "left" : _r$labelPosition,
        c = r.labelProps,
        d = r.themeOverride,
        _r$variant5 = r.variant,
        f = _r$variant5 === void 0 ? "solid" : _r$variant5,
        _r$margins = r.margins,
        p = _r$margins === void 0 ? 0 : _r$margins,
        u = nv(r, ["color", "className", "orientation", "size", "label", "labelPosition", "labelProps", "themeOverride", "variant", "margins"]);
    var g = j(d),
        y = t || (g.colorScheme === "dark" ? "dark" : "gray"),
        b = ev({
      color: y,
      theme: g,
      margins: p,
      size: n,
      variant: f
    });
    return l.createElement("div", jn({
      "data-mantine-hr": !0,
      className: P((_P3 = {}, _defineProperty(_P3, b.vertical, a === "vertical"), _defineProperty(_P3, b.horizontal, a === "horizontal"), _defineProperty(_P3, b.withLabel, !!i && a === "horizontal"), _P3), o)
    }, u), !!i && a === "horizontal" && l.createElement(ne, av(jn({
      "data-mantine-label": !0
    }, c), {
      color: y,
      size: (c == null ? void 0 : c.size) || "xs",
      style: {
        marginTop: 2
      },
      className: P(b.label, b[s])
    }), i));
  }

  Pe.displayName = "@mantine/core/Divider";

  var iv = Object.defineProperty,
      lv = Object.defineProperties,
      sv = Object.getOwnPropertyDescriptors,
      Sr = Object.getOwnPropertySymbols,
      Tn = Object.prototype.hasOwnProperty,
      zn = Object.prototype.propertyIsEnumerable,
      Dn = function Dn(e, r, t) {
    return r in e ? iv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Mn = function Mn(e, r) {
    for (var t in r || (r = {})) {
      Tn.call(r, t) && Dn(e, t, r[t]);
    }

    if (Sr) {
      var _iterator61 = _createForOfIteratorHelper(Sr(r)),
          _step61;

      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var t = _step61.value;
          zn.call(r, t) && Dn(e, t, r[t]);
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
    }

    return e;
  },
      cv = function cv(e, r) {
    return lv(e, sv(r));
  },
      dv = function dv(e, r) {
    var t = {};

    for (var o in e) {
      Tn.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Sr) {
      var _iterator62 = _createForOfIteratorHelper(Sr(e)),
          _step62;

      try {
        for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
          var o = _step62.value;
          r.indexOf(o) < 0 && zn.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator62.e(err);
      } finally {
        _iterator62.f();
      }
    }

    return t;
  };

  function An(e) {
    return typeof e == "number" && e > 0 && e % 1 == 0;
  }

  function Ln(e) {
    var r = e,
        t = r.themeOverride,
        o = r.children,
        a = r.span,
        n = r.gutter,
        _r$offset = r.offset,
        i = _r$offset === void 0 ? 0 : _r$offset,
        s = r.grow,
        c = r.style,
        d = r.columns,
        f = dv(r, ["themeOverride", "children", "span", "gutter", "offset", "grow", "style", "columns"]);

    var p = j(t),
        u = _({
      size: n,
      sizes: p.spacing
    });

    if (!An(a) || a > d) return null;
    var g = cv(Mn({}, c), {
      boxSizing: "border-box",
      flex: "".concat(s ? "1" : "0", " 0 calc(").concat(100 / (d / a), "% - ").concat(u, "px)"),
      margin: u / 2
    });
    return An(i) && (g.marginLeft = "calc(".concat(100 / (d / i), "% + ").concat(u / 2, "px)")), l.createElement("div", Mn({
      style: g
    }, f), o);
  }

  Ln.displayName = "@mantine/core/Col";

  var fv = Object.defineProperty,
      Er = Object.getOwnPropertySymbols,
      Hn = Object.prototype.hasOwnProperty,
      Vn = Object.prototype.propertyIsEnumerable,
      Bn = function Bn(e, r, t) {
    return r in e ? fv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Fn = function Fn(e, r) {
    for (var t in r || (r = {})) {
      Hn.call(r, t) && Bn(e, t, r[t]);
    }

    if (Er) {
      var _iterator63 = _createForOfIteratorHelper(Er(r)),
          _step63;

      try {
        for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
          var t = _step63.value;
          Vn.call(r, t) && Bn(e, t, r[t]);
        }
      } catch (err) {
        _iterator63.e(err);
      } finally {
        _iterator63.f();
      }
    }

    return e;
  },
      pv = function pv(e, r) {
    var t = {};

    for (var o in e) {
      Hn.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Er) {
      var _iterator64 = _createForOfIteratorHelper(Er(e)),
          _step64;

      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var o = _step64.value;
          r.indexOf(o) < 0 && Vn.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
    }

    return t;
  };

  function Wn(e) {
    var r = e,
        t = r.themeOverride,
        _r$gutter2 = r.gutter,
        o = _r$gutter2 === void 0 ? "md" : _r$gutter2,
        a = r.children,
        _r$grow2 = r.grow,
        n = _r$grow2 === void 0 ? !1 : _r$grow2,
        _r$justify = r.justify,
        i = _r$justify === void 0 ? "flex-start" : _r$justify,
        _r$align = r.align,
        s = _r$align === void 0 ? "stretch" : _r$align,
        c = r.style,
        _r$columns = r.columns,
        d = _r$columns === void 0 ? 12 : _r$columns,
        f = pv(r, ["themeOverride", "gutter", "children", "grow", "justify", "align", "style", "columns"]);

    var p = j(t),
        u = _({
      size: o,
      sizes: p.spacing
    }),
        g = E.Children.toArray(a).map(function (y, b) {
      return l.cloneElement(y, {
        gutter: o,
        grow: n,
        columns: d,
        key: b
      });
    });

    return l.createElement("div", Fn({
      style: Fn({
        margin: -u / 2,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: i,
        alignItems: s
      }, c)
    }, f), g);
  }

  Wn.displayName = "@mantine/core/Grid";
  var Zn = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
    apart: "space-between"
  };

  var uv = L({
    group: function group(_ref54) {
      var e = _ref54.spacing,
          r = _ref54.position,
          t = _ref54.noWrap,
          o = _ref54.direction,
          a = _ref54.theme,
          n = _ref54.grow,
          i = _ref54.align;
      return {
        display: "flex",
        flexDirection: o,
        alignItems: i || (o === "row" ? "center" : n ? "stretch" : Zn[r]),
        flexWrap: t ? "nowrap" : "wrap",
        justifyContent: o === "row" && Zn[r],
        margin: -1 * _({
          size: e,
          sizes: a.spacing
        }) / 2
      };
    },
    child: function child(_ref55) {
      var e = _ref55.grow,
          r = _ref55.spacing,
          t = _ref55.theme;
      return {
        flexGrow: e ? 1 : 0,
        margin: _({
          size: r,
          sizes: t.spacing
        }) / 2
      };
    }
  }),
      vv = Object.defineProperty,
      xr = Object.getOwnPropertySymbols,
      Yn = Object.prototype.hasOwnProperty,
      qn = Object.prototype.propertyIsEnumerable,
      Un = function Un(e, r, t) {
    return r in e ? vv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      mv = function mv(e, r) {
    for (var t in r || (r = {})) {
      Yn.call(r, t) && Un(e, t, r[t]);
    }

    if (xr) {
      var _iterator65 = _createForOfIteratorHelper(xr(r)),
          _step65;

      try {
        for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
          var t = _step65.value;
          qn.call(r, t) && Un(e, t, r[t]);
        }
      } catch (err) {
        _iterator65.e(err);
      } finally {
        _iterator65.f();
      }
    }

    return e;
  },
      gv = function gv(e, r) {
    var t = {};

    for (var o in e) {
      Yn.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && xr) {
      var _iterator66 = _createForOfIteratorHelper(xr(e)),
          _step66;

      try {
        for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
          var o = _step66.value;
          r.indexOf(o) < 0 && qn.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator66.e(err);
      } finally {
        _iterator66.f();
      }
    }

    return t;
  };

  function Cr(e) {
    var r = e,
        t = r.className,
        _r$position2 = r.position,
        o = _r$position2 === void 0 ? "left" : _r$position2,
        a = r.align,
        n = r.children,
        _r$noWrap = r.noWrap,
        i = _r$noWrap === void 0 ? !1 : _r$noWrap,
        _r$grow3 = r.grow,
        s = _r$grow3 === void 0 ? !1 : _r$grow3,
        _r$spacing = r.spacing,
        c = _r$spacing === void 0 ? "md" : _r$spacing,
        _r$direction = r.direction,
        d = _r$direction === void 0 ? "row" : _r$direction,
        f = r.themeOverride,
        p = gv(r, ["className", "position", "align", "children", "noWrap", "grow", "spacing", "direction", "themeOverride"]);
    var u = uv({
      theme: j(f),
      align: a,
      grow: s,
      noWrap: i,
      spacing: c,
      position: o,
      direction: d
    }),
        g = E.Children.toArray(n).map(function (y) {
      return l.cloneElement(y, {
        className: P(u.child, y.props.className)
      });
    });
    return l.createElement("div", mv({
      className: P(u.group, t)
    }, p), g);
  }

  Cr.displayName = "@mantine/core/Group";

  var _v = Object.defineProperty,
      Ir = Object.getOwnPropertySymbols,
      Gn = Object.prototype.hasOwnProperty,
      Kn = Object.prototype.propertyIsEnumerable,
      Xn = function Xn(e, r, t) {
    return r in e ? _v(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      yv = function yv(e, r) {
    for (var t in r || (r = {})) {
      Gn.call(r, t) && Xn(e, t, r[t]);
    }

    if (Ir) {
      var _iterator67 = _createForOfIteratorHelper(Ir(r)),
          _step67;

      try {
        for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
          var t = _step67.value;
          Kn.call(r, t) && Xn(e, t, r[t]);
        }
      } catch (err) {
        _iterator67.e(err);
      } finally {
        _iterator67.f();
      }
    }

    return e;
  },
      bv = function bv(e, r) {
    var t = {};

    for (var o in e) {
      Gn.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Ir) {
      var _iterator68 = _createForOfIteratorHelper(Ir(e)),
          _step68;

      try {
        for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
          var o = _step68.value;
          r.indexOf(o) < 0 && Kn.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator68.e(err);
      } finally {
        _iterator68.f();
      }
    }

    return t;
  };

  function Ov(e, r) {
    var t = e.trim().toLowerCase(),
        o = r.trim().toLowerCase(),
        a = r.length - o.length,
        n = r.length - a,
        i = t.indexOf(o);
    if (i === -1) return {
      start: e,
      highlighted: "",
      end: ""
    };
    var s = e.slice(0, i),
        c = e.slice(i, i + n),
        d = e.slice(i + n);
    return {
      start: s,
      highlighted: c,
      end: d
    };
  }

  function Jn(e) {
    var r = e,
        t = r.children,
        o = r.highlight,
        a = r.component,
        n = r.themeOverride,
        _r$highlightColor = r.highlightColor,
        i = _r$highlightColor === void 0 ? "yellow" : _r$highlightColor,
        s = bv(r, ["children", "highlight", "component", "themeOverride", "highlightColor"]);

    var c = j(n),
        d = re(w({
      theme: c,
      color: i,
      shade: c.colorScheme === "dark" ? 4 : 2
    }), c.colorScheme === "dark" ? .7 : 1),
        _Ov = Ov(t, o),
        f = _Ov.start,
        p = _Ov.end,
        u = _Ov.highlighted;

    return l.createElement(ne, yv({
      component: a,
      themeOverride: n
    }, s), !!f && f, !!u && l.createElement("mark", {
      style: {
        backgroundColor: d,
        color: c.colorScheme === "dark" ? c.colors.dark[9] : "inherit"
      }
    }, u), !!p && p);
  }

  Jn.displayName = "@mantine/core/Highlight";

  var hv = Object.defineProperty,
      Qn = Object.getOwnPropertySymbols,
      wv = Object.prototype.hasOwnProperty,
      Pv = Object.prototype.propertyIsEnumerable,
      ei = function ei(e, r, t) {
    return r in e ? hv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      $v = function $v(e, r) {
    for (var t in r || (r = {})) {
      wv.call(r, t) && ei(e, t, r[t]);
    }

    if (Qn) {
      var _iterator69 = _createForOfIteratorHelper(Qn(r)),
          _step69;

      try {
        for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
          var t = _step69.value;
          Pv.call(r, t) && ei(e, t, r[t]);
        }
      } catch (err) {
        _iterator69.e(err);
      } finally {
        _iterator69.f();
      }
    }

    return e;
  };

  function Sv(e) {
    return l.createElement("svg", $v({
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), l.createElement("path", {
      d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }));
  }

  var Ev = Object.defineProperty,
      xv = Object.defineProperties,
      Cv = Object.getOwnPropertyDescriptors,
      ri = Object.getOwnPropertySymbols,
      Iv = Object.prototype.hasOwnProperty,
      Nv = Object.prototype.propertyIsEnumerable,
      ti = function ti(e, r, t) {
    return r in e ? Ev(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      kv = function kv(e, r) {
    for (var t in r || (r = {})) {
      Iv.call(r, t) && ti(e, t, r[t]);
    }

    if (ri) {
      var _iterator70 = _createForOfIteratorHelper(ri(r)),
          _step70;

      try {
        for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
          var t = _step70.value;
          Nv.call(r, t) && ti(e, t, r[t]);
        }
      } catch (err) {
        _iterator70.e(err);
      } finally {
        _iterator70.f();
      }
    }

    return e;
  },
      jv = function jv(e, r) {
    return xv(e, Cv(r));
  },
      Rv = L({
    wrapper: {
      position: "relative",
      overflow: "hidden"
    },
    image: function image(_ref56) {
      var e = _ref56.theme,
          r = _ref56.radius;
      return jv(kv({}, Q(e)), {
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: _({
          size: r,
          sizes: e.radius
        }),
        border: 0
      });
    },
    placeholderIcon: function placeholderIcon(_ref57) {
      var e = _ref57.theme,
          r = _ref57.radius;
      return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6],
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[8] : e.colors.gray[0],
        position: "absolute",
        borderRadius: _({
          size: r,
          sizes: e.radius
        }),
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      };
    }
  }),
      Tv = Object.defineProperty,
      zv = Object.defineProperties,
      Dv = Object.getOwnPropertyDescriptors,
      Nr = Object.getOwnPropertySymbols,
      oi = Object.prototype.hasOwnProperty,
      ai = Object.prototype.propertyIsEnumerable,
      ni = function ni(e, r, t) {
    return r in e ? Tv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      kr = function kr(e, r) {
    for (var t in r || (r = {})) {
      oi.call(r, t) && ni(e, t, r[t]);
    }

    if (Nr) {
      var _iterator71 = _createForOfIteratorHelper(Nr(r)),
          _step71;

      try {
        for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
          var t = _step71.value;
          ai.call(r, t) && ni(e, t, r[t]);
        }
      } catch (err) {
        _iterator71.e(err);
      } finally {
        _iterator71.f();
      }
    }

    return e;
  },
      Mv = function Mv(e, r) {
    return zv(e, Dv(r));
  },
      Av = function Av(e, r) {
    var t = {};

    for (var o in e) {
      oi.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Nr) {
      var _iterator72 = _createForOfIteratorHelper(Nr(e)),
          _step72;

      try {
        for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
          var o = _step72.value;
          r.indexOf(o) < 0 && ai.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator72.e(err);
      } finally {
        _iterator72.f();
      }
    }

    return t;
  };

  function ii(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = r.alt,
        n = r.src,
        _r$fit = r.fit,
        i = _r$fit === void 0 ? "cover" : _r$fit,
        _r$width = r.width,
        s = _r$width === void 0 ? "100%" : _r$width,
        _r$height = r.height,
        c = _r$height === void 0 ? "auto" : _r$height,
        _r$radius8 = r.radius,
        d = _r$radius8 === void 0 ? 0 : _r$radius8,
        f = r.style,
        p = r.imageProps,
        _r$withPlaceholder = r.withPlaceholder,
        u = _r$withPlaceholder === void 0 ? !1 : _r$withPlaceholder,
        g = r.placeholder,
        y = r.imageRef,
        b = r.elementRef,
        S = Av(r, ["className", "themeOverride", "alt", "src", "fit", "width", "height", "radius", "style", "imageProps", "withPlaceholder", "placeholder", "imageRef", "elementRef"]);

    var I = Rv({
      radius: d,
      theme: j(o)
    }),
        _E$useState5 = E.useState(!1),
        _E$useState6 = _slicedToArray(_E$useState5, 2),
        N = _E$useState6[0],
        k = _E$useState6[1],
        _E$useState7 = E.useState(!n),
        _E$useState8 = _slicedToArray(_E$useState7, 2),
        x = _E$useState8[0],
        A = _E$useState8[1],
        q = u && (!N || x),
        z = E.useRef(!0);

    return E.useEffect(function () {
      z.current ? z.current = !1 : (k(!1), A(!1));
    }, [n]), l.createElement("div", kr({
      "data-mantine-image": !0,
      className: P(I.wrapper, t),
      style: kr({
        width: s,
        height: c
      }, f),
      ref: b
    }, S), q && l.createElement("div", {
      "data-mantine-image-placeholder": !0,
      className: I.placeholderIcon,
      title: a
    }, g || l.createElement(Sv, {
      style: {
        width: 40,
        height: 40
      }
    })), l.createElement("img", kr({
      className: P(I.image, p == null ? void 0 : p.className),
      src: n,
      alt: a,
      style: Mv(kr({}, p == null ? void 0 : p.style), {
        objectFit: i
      }),
      ref: y,
      onLoad: function onLoad(R) {
        k(!0), typeof (p == null ? void 0 : p.onLoad) == "function" && p.onLoad(R);
      },
      onError: function onError(R) {
        A(!0), typeof (p == null ? void 0 : p.onError) == "function" && p.onError(R);
      }
    }, p)));
  }

  ii.displayName = "@mantine/core/Image";

  var Lv = Object.defineProperty,
      Hv = Object.defineProperties,
      Vv = Object.getOwnPropertyDescriptors,
      li = Object.getOwnPropertySymbols,
      Bv = Object.prototype.hasOwnProperty,
      Fv = Object.prototype.propertyIsEnumerable,
      si = function si(e, r, t) {
    return r in e ? Lv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Wv = function Wv(e, r) {
    for (var t in r || (r = {})) {
      Bv.call(r, t) && si(e, t, r[t]);
    }

    if (li) {
      var _iterator73 = _createForOfIteratorHelper(li(r)),
          _step73;

      try {
        for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
          var t = _step73.value;
          Fv.call(r, t) && si(e, t, r[t]);
        }
      } catch (err) {
        _iterator73.e(err);
      } finally {
        _iterator73.f();
      }
    }

    return e;
  },
      Zv = function Zv(e, r) {
    return Hv(e, Vv(r));
  },
      Yv = L({
    withIcon: {},
    inputWrapper: function inputWrapper(_ref58) {
      var e = _ref58.radius,
          r = _ref58.theme;
      return {
        position: "relative",
        borderRadius: _({
          size: e,
          sizes: r.radius
        }),
        "&, & *": {
          boxSizing: "border-box"
        }
      };
    },
    defaultVariant: function defaultVariant(_ref59) {
      var e = _ref59.theme,
          r = _ref59.radius;
      return {
        "& $input": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
          minHeight: 36,
          paddingLeft: e.spacing.md,
          paddingRight: e.spacing.md,
          borderRadius: _({
            size: r,
            sizes: e.radius
          }),
          border: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]),
          transition: "border-color 100ms ease, box-shadow 100ms ease",
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
          "&:focus": {
            outline: "none",
            borderColor: e.colors[e.primaryColor][e.colorScheme === "dark" ? 8 : 6]
          }
        },
        "&$invalid $input": {
          borderColor: e.colors.red[e.colorScheme === "dark" ? 4 : 6]
        },
        "& $withIcon": {
          paddingLeft: 35
        },
        "& $icon": {
          width: 36
        }
      };
    },
    filledVariant: function filledVariant(_ref60) {
      var e = _ref60.theme,
          r = _ref60.radius;
      return {
        "& $input": {
          minHeight: 36,
          paddingLeft: e.spacing.md,
          paddingRight: e.spacing.md,
          borderRadius: _({
            size: r,
            sizes: e.radius
          }),
          border: "1px solid transparent",
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[1],
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
          "&:focus": {
            outline: "none",
            borderColor: "".concat(e.colors[e.primaryColor][e.colorScheme === "dark" ? 8 : 6], " !important")
          },
          "&::placeholder": {
            color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6]
          }
        },
        "& $input:disabled": {
          "&::placeholder": {
            color: e.colors.gray[5]
          }
        },
        "&$invalid $input": {
          borderColor: e.colorScheme === "dark" ? e.colors.red[4] : "transparent",
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.red[0]
        },
        "& $withIcon": {
          paddingLeft: 35
        },
        "& $icon": {
          width: 36,
          color: e.colors.gray[6]
        }
      };
    },
    unstyledVariant: function unstyledVariant(_ref61) {
      var e = _ref61.theme;
      return {
        "& $input": {
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
          backgroundColor: "transparent",
          height: 28,
          border: 0,
          outline: 0,
          "&:disabled": {
            backgroundColor: "transparent"
          }
        },
        "& $icon": {
          width: 28
        },
        "& $withIcon": {
          paddingLeft: 34
        }
      };
    },
    input: function input(_ref62) {
      var e = _ref62.theme;
      return Zv(Wv({}, Q(e)), {
        WebkitTapHighlightColor: "transparent",
        lineHeight: e.lineHeight,
        appearance: "none",
        resize: "none",
        boxSizing: "border-box",
        fontSize: e.fontSizes.sm,
        width: "100%",
        color: e.black,
        display: "block",
        textAlign: "left",
        "&:disabled": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[1],
          opacity: .6,
          cursor: "not-allowed"
        },
        "&::placeholder": {
          opacity: 1,
          color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[5]
        },
        "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button, &::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
          appearance: "none"
        },
        "&[type=number]": {
          MozAppearance: "textfield"
        }
      });
    },
    icon: function icon(_ref63) {
      var e = _ref63.theme;
      return {
        pointerEvents: "none",
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[5],
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
    },
    invalid: function invalid(_ref64) {
      var e = _ref64.theme;
      return {
        "& $input": {
          color: e.colors.red[e.colorScheme === "dark" ? 4 : 6],
          borderColor: e.colors.red[e.colorScheme === "dark" ? 4 : 6],
          "&::placeholder": {
            color: e.colors.red[e.colorScheme === "dark" ? 4 : 6]
          }
        },
        "& $icon": {
          color: e.colors.red[e.colorScheme === "dark" ? 4 : 6]
        }
      };
    },
    rightSection: {
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }),
      qv = Object.defineProperty,
      Uv = Object.defineProperties,
      Gv = Object.getOwnPropertyDescriptors,
      jr = Object.getOwnPropertySymbols,
      ci = Object.prototype.hasOwnProperty,
      di = Object.prototype.propertyIsEnumerable,
      fi = function fi(e, r, t) {
    return r in e ? qv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Re = function Re(e, r) {
    for (var t in r || (r = {})) {
      ci.call(r, t) && fi(e, t, r[t]);
    }

    if (jr) {
      var _iterator74 = _createForOfIteratorHelper(jr(r)),
          _step74;

      try {
        for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
          var t = _step74.value;
          di.call(r, t) && fi(e, t, r[t]);
        }
      } catch (err) {
        _iterator74.e(err);
      } finally {
        _iterator74.f();
      }
    }

    return e;
  },
      At = function At(e, r) {
    return Uv(e, Gv(r));
  },
      Kv = function Kv(e, r) {
    var t = {};

    for (var o in e) {
      ci.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && jr) {
      var _iterator75 = _createForOfIteratorHelper(jr(e)),
          _step75;

      try {
        for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
          var o = _step75.value;
          r.indexOf(o) < 0 && di.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator75.e(err);
      } finally {
        _iterator75.f();
      }
    }

    return t;
  };

  function $e(e) {
    var r = e,
        _r$component8 = r.component,
        t = _r$component8 === void 0 ? "input" : _r$component8,
        o = r.className,
        _r$invalid = r.invalid,
        a = _r$invalid === void 0 ? !1 : _r$invalid,
        _r$required = r.required,
        n = _r$required === void 0 ? !1 : _r$required,
        _r$variant6 = r.variant,
        i = _r$variant6 === void 0 ? "default" : _r$variant6,
        s = r.icon,
        c = r.style,
        _r$rightSectionWidth = r.rightSectionWidth,
        d = _r$rightSectionWidth === void 0 ? 36 : _r$rightSectionWidth,
        f = r.rightSection,
        _r$rightSectionProps = r.rightSectionProps,
        p = _r$rightSectionProps === void 0 ? {} : _r$rightSectionProps,
        _r$radius9 = r.radius,
        u = _r$radius9 === void 0 ? "sm" : _r$radius9,
        g = r.inputClassName,
        y = r.inputStyle,
        b = r.themeOverride,
        S = r.wrapperProps,
        I = r.elementRef,
        N = Kv(r, ["component", "className", "invalid", "required", "variant", "icon", "style", "rightSectionWidth", "rightSection", "rightSectionProps", "radius", "inputClassName", "inputStyle", "themeOverride", "wrapperProps", "elementRef"]);
    var k = j(b),
        x = Yv({
      radius: u,
      theme: k
    });
    return l.createElement("div", Re({
      className: P(x.inputWrapper, _defineProperty({}, x.invalid, a), x["".concat(i, "Variant")], o),
      style: c
    }, S), s && l.createElement("div", {
      "data-mantine-icon": !0,
      className: x.icon
    }, s), l.createElement(t, At(Re({}, N), {
      "data-mantine-input": !0,
      ref: I,
      "aria-required": n,
      "aria-invalid": a,
      className: P(_defineProperty({}, x.withIcon, s), x.input, g),
      style: Re({
        paddingRight: f ? d : k.spacing.md
      }, y)
    })), f && l.createElement("div", At(Re({}, p), {
      "data-mantine-input-section": !0,
      style: At(Re({}, p.style), {
        width: d
      }),
      className: P(x.rightSection, p.className)
    }), f));
  }

  $e.displayName = "@mantine/core/Input";

  var Xv = Object.defineProperty,
      Jv = Object.defineProperties,
      Qv = Object.getOwnPropertyDescriptors,
      pi = Object.getOwnPropertySymbols,
      em = Object.prototype.hasOwnProperty,
      rm = Object.prototype.propertyIsEnumerable,
      ui = function ui(e, r, t) {
    return r in e ? Xv(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      tm = function tm(e, r) {
    for (var t in r || (r = {})) {
      em.call(r, t) && ui(e, t, r[t]);
    }

    if (pi) {
      var _iterator76 = _createForOfIteratorHelper(pi(r)),
          _step76;

      try {
        for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
          var t = _step76.value;
          rm.call(r, t) && ui(e, t, r[t]);
        }
      } catch (err) {
        _iterator76.e(err);
      } finally {
        _iterator76.f();
      }
    }

    return e;
  },
      om = function om(e, r) {
    return Jv(e, Qv(r));
  },
      am = L({
    inputWrapper: function inputWrapper(_ref65) {
      var e = _ref65.theme;
      return om(tm({}, Q(e)), {
        lineHeight: e.lineHeight
      });
    },
    label: function label(_ref66) {
      var e = _ref66.theme;
      return {
        display: "block",
        marginBottom: 5,
        fontSize: 14,
        fontWeight: 500,
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[9],
        wordBreak: "break-word"
      };
    },
    error: function error(_ref67) {
      var e = _ref67.theme;
      return {
        marginTop: e.spacing.xs / 2,
        wordBreak: "break-word"
      };
    },
    description: function description(_ref68) {
      var e = _ref68.theme;
      return {
        marginTop: e.spacing.xs / 2,
        marginBottom: e.spacing.xs / 2,
        wordBreak: "break-word"
      };
    },
    required: function required(_ref69) {
      var e = _ref69.theme;
      return {
        color: e.colorScheme === "dark" ? e.colors.red[5] : e.colors.red[7]
      };
    }
  }),
      nm = Object.defineProperty,
      im = Object.defineProperties,
      lm = Object.getOwnPropertyDescriptors,
      Rr = Object.getOwnPropertySymbols,
      vi = Object.prototype.hasOwnProperty,
      mi = Object.prototype.propertyIsEnumerable,
      gi = function gi(e, r, t) {
    return r in e ? nm(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Te = function Te(e, r) {
    for (var t in r || (r = {})) {
      vi.call(r, t) && gi(e, t, r[t]);
    }

    if (Rr) {
      var _iterator77 = _createForOfIteratorHelper(Rr(r)),
          _step77;

      try {
        for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
          var t = _step77.value;
          mi.call(r, t) && gi(e, t, r[t]);
        }
      } catch (err) {
        _iterator77.e(err);
      } finally {
        _iterator77.f();
      }
    }

    return e;
  },
      Lt = function Lt(e, r) {
    return im(e, lm(r));
  },
      sm = function sm(e, r) {
    var t = {};

    for (var o in e) {
      vi.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Rr) {
      var _iterator78 = _createForOfIteratorHelper(Rr(e)),
          _step78;

      try {
        for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
          var o = _step78.value;
          r.indexOf(o) < 0 && mi.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator78.e(err);
      } finally {
        _iterator78.f();
      }
    }

    return t;
  };

  function Se(e) {
    var r = e,
        t = r.className,
        o = r.label,
        a = r.children,
        n = r.required,
        i = r.id,
        s = r.error,
        c = r.description,
        d = r.themeOverride,
        _r$labelElement = r.labelElement,
        f = _r$labelElement === void 0 ? "label" : _r$labelElement,
        p = r.labelProps,
        u = r.descriptionProps,
        g = r.errorProps,
        y = sm(r, ["className", "label", "children", "required", "id", "error", "description", "themeOverride", "labelElement", "labelProps", "descriptionProps", "errorProps"]);
    var b = am({
      theme: j(d)
    }),
        S = f === "label" ? {
      htmlFor: i
    } : {},
        I = E.createElement(f, Lt(Te(Te({}, S), p), {
      "data-mantine-label": !0,
      className: P(b.label, p == null ? void 0 : p.className)
    }), l.createElement(l.Fragment, null, o, n && l.createElement("span", {
      "data-mantine-required": !0,
      className: b.required
    }, " ", "*")));
    return l.createElement("div", Te({
      className: P(b.inputWrapper, t)
    }, y), o && I, c && l.createElement(ne, Lt(Te({
      themeOverride: d,
      "data-mantine-description": !0,
      color: "gray",
      size: "xs"
    }, u), {
      className: P(b.description, u == null ? void 0 : u.className)
    }), c), a, typeof s != "boolean" && s && l.createElement(ne, Lt(Te({
      themeOverride: d,
      "data-mantine-error": !0,
      color: "red",
      size: "sm"
    }, g), {
      className: P(b.error, g == null ? void 0 : g.className)
    }), s));
  }

  Se.displayName = "@mantine/core/InputWrapper";

  var cm = L({
    kbd: function kbd(_ref70) {
      var e = _ref70.theme;
      return {
        lineHeight: e.lineHeight,
        fontFamily: e.fontFamilyMonospace,
        fontSize: e.fontSizes.xs,
        fontWeight: 700,
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[0],
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[7],
        padding: [3, e.spacing.xs / 2],
        borderRadius: e.radius.sm,
        border: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[9] : e.colors.gray[3]),
        borderBottom: "3px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[9] : e.colors.gray[3])
      };
    }
  }),
      dm = Object.defineProperty,
      Tr = Object.getOwnPropertySymbols,
      _i = Object.prototype.hasOwnProperty,
      yi = Object.prototype.propertyIsEnumerable,
      bi = function bi(e, r, t) {
    return r in e ? dm(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      fm = function fm(e, r) {
    for (var t in r || (r = {})) {
      _i.call(r, t) && bi(e, t, r[t]);
    }

    if (Tr) {
      var _iterator79 = _createForOfIteratorHelper(Tr(r)),
          _step79;

      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var t = _step79.value;
          yi.call(r, t) && bi(e, t, r[t]);
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
    }

    return e;
  },
      pm = function pm(e, r) {
    var t = {};

    for (var o in e) {
      _i.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Tr) {
      var _iterator80 = _createForOfIteratorHelper(Tr(e)),
          _step80;

      try {
        for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
          var o = _step80.value;
          r.indexOf(o) < 0 && yi.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator80.e(err);
      } finally {
        _iterator80.f();
      }
    }

    return t;
  };

  function Oi(e) {
    var r = e,
        t = r.className,
        o = r.children,
        a = r.themeOverride,
        n = pm(r, ["className", "children", "themeOverride"]);
    var i = cm({
      theme: j(a)
    });
    return l.createElement("kbd", fm({
      className: P(i.kbd, t)
    }, n), o);
  }

  Oi.displayName = "@mantine/core/Kbd";

  var um = Object.defineProperty,
      zr = Object.getOwnPropertySymbols,
      hi = Object.prototype.hasOwnProperty,
      wi = Object.prototype.propertyIsEnumerable,
      Pi = function Pi(e, r, t) {
    return r in e ? um(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      vm = function vm(e, r) {
    for (var t in r || (r = {})) {
      hi.call(r, t) && Pi(e, t, r[t]);
    }

    if (zr) {
      var _iterator81 = _createForOfIteratorHelper(zr(r)),
          _step81;

      try {
        for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
          var t = _step81.value;
          wi.call(r, t) && Pi(e, t, r[t]);
        }
      } catch (err) {
        _iterator81.e(err);
      } finally {
        _iterator81.f();
      }
    }

    return e;
  },
      mm = function mm(e, r) {
    var t = {};

    for (var o in e) {
      hi.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && zr) {
      var _iterator82 = _createForOfIteratorHelper(zr(e)),
          _step82;

      try {
        for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
          var o = _step82.value;
          r.indexOf(o) < 0 && wi.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator82.e(err);
      } finally {
        _iterator82.f();
      }
    }

    return t;
  };

  var $i = {
    xs: 18,
    sm: 22,
    md: 36,
    lg: 44,
    xl: 58
  };

  function Dr(e) {
    var r = e,
        _r$size10 = r.size,
        t = _r$size10 === void 0 ? "md" : _r$size10,
        o = r.color,
        a = r.themeOverride,
        n = mm(r, ["size", "color", "themeOverride"]);
    var i = j(a);
    return l.createElement("svg", vm({
      width: "".concat(_({
        size: t,
        sizes: $i
      }), "px"),
      fill: w({
        theme: i,
        color: o,
        shade: i.colorScheme === "dark" ? 4 : 6
      }),
      viewBox: "0 0 135 140",
      xmlns: "http://www.w3.org/2000/svg",
      role: "presentation"
    }, n), l.createElement("rect", {
      y: "10",
      width: "15",
      height: "120",
      rx: "6"
    }, l.createElement("animate", {
      attributeName: "height",
      begin: "0.5s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), l.createElement("animate", {
      attributeName: "y",
      begin: "0.5s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), l.createElement("rect", {
      x: "30",
      y: "10",
      width: "15",
      height: "120",
      rx: "6"
    }, l.createElement("animate", {
      attributeName: "height",
      begin: "0.25s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), l.createElement("animate", {
      attributeName: "y",
      begin: "0.25s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), l.createElement("rect", {
      x: "60",
      width: "15",
      height: "140",
      rx: "6"
    }, l.createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), l.createElement("animate", {
      attributeName: "y",
      begin: "0s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), l.createElement("rect", {
      x: "90",
      y: "10",
      width: "15",
      height: "120",
      rx: "6"
    }, l.createElement("animate", {
      attributeName: "height",
      begin: "0.25s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), l.createElement("animate", {
      attributeName: "y",
      begin: "0.25s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), l.createElement("rect", {
      x: "120",
      y: "10",
      width: "15",
      height: "120",
      rx: "6"
    }, l.createElement("animate", {
      attributeName: "height",
      begin: "0.5s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), l.createElement("animate", {
      attributeName: "y",
      begin: "0.5s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })));
  }

  Dr.displayName = "@mantine/core/Loader";

  var gm = Le.createUseStyles({
    loadingOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden"
    }
  }),
      _m = Object.defineProperty,
      ym = Object.defineProperties,
      bm = Object.getOwnPropertyDescriptors,
      Mr = Object.getOwnPropertySymbols,
      Si = Object.prototype.hasOwnProperty,
      Ei = Object.prototype.propertyIsEnumerable,
      xi = function xi(e, r, t) {
    return r in e ? _m(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Ar = function Ar(e, r) {
    for (var t in r || (r = {})) {
      Si.call(r, t) && xi(e, t, r[t]);
    }

    if (Mr) {
      var _iterator83 = _createForOfIteratorHelper(Mr(r)),
          _step83;

      try {
        for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
          var t = _step83.value;
          Ei.call(r, t) && xi(e, t, r[t]);
        }
      } catch (err) {
        _iterator83.e(err);
      } finally {
        _iterator83.f();
      }
    }

    return e;
  },
      Om = function Om(e, r) {
    return ym(e, bm(r));
  },
      hm = function hm(e, r) {
    var t = {};

    for (var o in e) {
      Si.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Mr) {
      var _iterator84 = _createForOfIteratorHelper(Mr(e)),
          _step84;

      try {
        for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
          var o = _step84.value;
          r.indexOf(o) < 0 && Ei.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator84.e(err);
      } finally {
        _iterator84.f();
      }
    }

    return t;
  };

  function Ci(e) {
    var r = e,
        t = r.className,
        o = r.visible,
        _r$loaderProps = r.loaderProps,
        a = _r$loaderProps === void 0 ? {} : _r$loaderProps,
        _r$overlayOpacity = r.overlayOpacity,
        n = _r$overlayOpacity === void 0 ? .75 : _r$overlayOpacity,
        i = r.overlayColor,
        s = r.themeOverride,
        _r$transitionDuration2 = r.transitionDuration,
        c = _r$transitionDuration2 === void 0 ? 200 : _r$transitionDuration2,
        _r$zIndex3 = r.zIndex,
        d = _r$zIndex3 === void 0 ? 1e3 : _r$zIndex3,
        f = r.style,
        p = r.loader,
        u = hm(r, ["className", "visible", "loaderProps", "overlayOpacity", "overlayColor", "themeOverride", "transitionDuration", "zIndex", "style", "loader"]);
    var g = j(s),
        y = gm(),
        S = V.useReducedMotion() ? 1 : c;
    return l.createElement(we, {
      duration: S,
      mounted: o,
      transition: "fade",
      themeOverride: s
    }, function (I) {
      return l.createElement("div", Ar({
        className: P(y.loadingOverlay, t),
        style: Om(Ar(Ar({}, I), f), {
          zIndex: d
        })
      }, u), p ? l.createElement("div", {
        style: {
          zIndex: d + 1
        }
      }, p) : l.createElement(Dr, Ar({
        themeOverride: s,
        style: {
          zIndex: d + 1
        }
      }, a)), l.createElement(Ie, {
        opacity: n,
        zIndex: d,
        color: i || (g.colorScheme === "dark" ? g.colors.dark[5] : g.white)
      }));
    });
  }

  Ci.displayName = "@mantine/core/LoadingOverlay";

  var wm = Object.defineProperty,
      Ii = Object.getOwnPropertySymbols,
      Pm = Object.prototype.hasOwnProperty,
      $m = Object.prototype.propertyIsEnumerable,
      Ni = function Ni(e, r, t) {
    return r in e ? wm(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Sm = function Sm(e, r) {
    for (var t in r || (r = {})) {
      Pm.call(r, t) && Ni(e, t, r[t]);
    }

    if (Ii) {
      var _iterator85 = _createForOfIteratorHelper(Ii(r)),
          _step85;

      try {
        for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
          var t = _step85.value;
          $m.call(r, t) && Ni(e, t, r[t]);
        }
      } catch (err) {
        _iterator85.e(err);
      } finally {
        _iterator85.f();
      }
    }

    return e;
  };

  function Em(e) {
    return l.createElement("svg", Sm({
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), l.createElement("path", {
      d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }));
  }

  function me(e) {
    return null;
  }

  me.displayName = "@mantine/core/MenuItem";

  var xm = Object.defineProperty,
      Cm = Object.defineProperties,
      Im = Object.getOwnPropertyDescriptors,
      ki = Object.getOwnPropertySymbols,
      Nm = Object.prototype.hasOwnProperty,
      km = Object.prototype.propertyIsEnumerable,
      ji = function ji(e, r, t) {
    return r in e ? xm(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      jm = function jm(e, r) {
    for (var t in r || (r = {})) {
      Nm.call(r, t) && ji(e, t, r[t]);
    }

    if (ki) {
      var _iterator86 = _createForOfIteratorHelper(ki(r)),
          _step86;

      try {
        for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
          var t = _step86.value;
          km.call(r, t) && ji(e, t, r[t]);
        }
      } catch (err) {
        _iterator86.e(err);
      } finally {
        _iterator86.f();
      }
    }

    return e;
  },
      Rm = function Rm(e, r) {
    return Cm(e, Im(r));
  },
      Tm = L({
    hovered: {},
    item: function item(_ref71) {
      var e = _ref71.theme,
          r = _ref71.color;
      return Rm(jm({}, Q(e)), {
        WebkitTapHighlightColor: "transparent",
        fontSize: e.fontSizes.sm,
        border: 0,
        backgroundColor: "transparent",
        outline: 0,
        width: "100%",
        textAlign: "left",
        display: "inline-block",
        textDecoration: "none",
        height: 32,
        boxSizing: "border-box",
        padding: [0, e.spacing.sm],
        cursor: "pointer",
        color: r ? w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 4 : 6
        }) : e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[9],
        "&:disabled": {
          color: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[5],
          cursor: "not-allowed"
        },
        "&$hovered:not(:disabled), &:not(:disabled):hover": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[1],
          "&:not(:disabled):active": {
            backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[2]
          }
        }
      });
    },
    inner: {
      display: "flex",
      alignItems: "center",
      height: "100%"
    },
    body: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1
    },
    icon: function icon(_ref72) {
      var e = _ref72.theme;
      return {
        marginRight: e.spacing.xs,
        "& *": {
          display: "block"
        }
      };
    },
    label: {
      lineHeight: 1
    }
  }),
      zm = Object.defineProperty,
      Lr = Object.getOwnPropertySymbols,
      Ri = Object.prototype.hasOwnProperty,
      Ti = Object.prototype.propertyIsEnumerable,
      zi = function zi(e, r, t) {
    return r in e ? zm(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Dm = function Dm(e, r) {
    for (var t in r || (r = {})) {
      Ri.call(r, t) && zi(e, t, r[t]);
    }

    if (Lr) {
      var _iterator87 = _createForOfIteratorHelper(Lr(r)),
          _step87;

      try {
        for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
          var t = _step87.value;
          Ti.call(r, t) && zi(e, t, r[t]);
        }
      } catch (err) {
        _iterator87.e(err);
      } finally {
        _iterator87.f();
      }
    }

    return e;
  },
      Mm = function Mm(e, r) {
    var t = {};

    for (var o in e) {
      Ri.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Lr) {
      var _iterator88 = _createForOfIteratorHelper(Lr(e)),
          _step88;

      try {
        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
          var o = _step88.value;
          r.indexOf(o) < 0 && Ti.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator88.e(err);
      } finally {
        _iterator88.f();
      }
    }

    return t;
  };

  function Di(e) {
    var r = e,
        t = r.children,
        o = r.onHover,
        a = r.hovered,
        n = r.themeOverride,
        i = r.elementRef,
        s = r.icon,
        c = r.color,
        d = r.disabled,
        f = r.rightSection,
        p = r.className,
        _r$component9 = r.component,
        u = _r$component9 === void 0 ? "button" : _r$component9,
        g = Mm(r, ["children", "onHover", "hovered", "themeOverride", "elementRef", "icon", "color", "disabled", "rightSection", "className", "component"]);
    var y = Tm({
      color: c,
      theme: j(n)
    });
    return l.createElement(u, Dm({
      type: "button",
      role: "menuitem",
      className: P(y.item, _defineProperty({}, y.hovered, a), p),
      onMouseEnter: function onMouseEnter() {
        return !d && o();
      },
      ref: i,
      disabled: d
    }, g), l.createElement("div", {
      className: y.inner
    }, s && l.createElement("div", {
      "data-mantine-icon": !0,
      className: y.icon
    }, s), l.createElement("div", {
      className: y.body
    }, l.createElement("div", {
      className: y.label
    }, t), f)));
  }

  Di.displayName = "@mantine/core/MenuButton";
  var Mi = {
    xs: 120,
    sm: 160,
    md: 200,
    lg: 240,
    xl: 300
  };

  var Am = L({
    menu: function menu(_ref73) {
      var e = _ref73.theme,
          r = _ref73.size;
      return {
        position: "absolute",
        width: _({
          size: r,
          sizes: Mi
        }),
        overflow: "hidden",
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
        border: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[2]),
        paddingTop: e.spacing.xs / 2,
        paddingBottom: e.spacing.xs / 2
      };
    },
    hr: function hr(_ref74) {
      var e = _ref74.theme;
      return {
        borderTopColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[2],
        marginTop: e.spacing.xs / 2,
        marginBottom: e.spacing.xs / 2
      };
    }
  }),
      Lm = Object.defineProperty,
      Hm = Object.defineProperties,
      Vm = Object.getOwnPropertyDescriptors,
      Hr = Object.getOwnPropertySymbols,
      Ai = Object.prototype.hasOwnProperty,
      Li = Object.prototype.propertyIsEnumerable,
      Hi = function Hi(e, r, t) {
    return r in e ? Lm(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Vr = function Vr(e, r) {
    for (var t in r || (r = {})) {
      Ai.call(r, t) && Hi(e, t, r[t]);
    }

    if (Hr) {
      var _iterator89 = _createForOfIteratorHelper(Hr(r)),
          _step89;

      try {
        for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
          var t = _step89.value;
          Li.call(r, t) && Hi(e, t, r[t]);
        }
      } catch (err) {
        _iterator89.e(err);
      } finally {
        _iterator89.f();
      }
    }

    return e;
  },
      Vi = function Vi(e, r) {
    return Hm(e, Vm(r));
  },
      Bm = function Bm(e, r) {
    var t = {};

    for (var o in e) {
      Ai.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Hr) {
      var _iterator90 = _createForOfIteratorHelper(Hr(e)),
          _step90;

      try {
        for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
          var o = _step90.value;
          r.indexOf(o) < 0 && Li.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator90.e(err);
      } finally {
        _iterator90.f();
      }
    }

    return t;
  };

  function Fm(e, r) {
    for (var t = e - 1; t >= 0; t -= 1) {
      if (!r[t].props.disabled && r[t].type === me) return t;
    }

    return e;
  }

  function Wm(e, r) {
    for (var t = e + 1; t < r.length; t += 1) {
      if (!r[t].props.disabled && r[t].type === me) return t;
    }

    return e;
  }

  function Bi(e) {
    for (var r = 0; r < e.length; r += 1) {
      if (!e[r].props.disabled && e[r].type === me) return r;
    }

    return -1;
  }

  function Ht(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = r.opened,
        n = r.onClose,
        _r$transition = r.transition,
        i = _r$transition === void 0 ? "skew-up" : _r$transition,
        _r$transitionDuration3 = r.transitionDuration,
        s = _r$transitionDuration3 === void 0 ? 250 : _r$transitionDuration3,
        c = r.transitionTimingFunction,
        d = r.style,
        f = r.children,
        _r$size11 = r.size,
        p = _r$size11 === void 0 ? "md" : _r$size11,
        _r$shadow3 = r.shadow,
        u = _r$shadow3 === void 0 ? "md" : _r$shadow3,
        _r$closeOnClickOutsid = r.closeOnClickOutside,
        g = _r$closeOnClickOutsid === void 0 ? !0 : _r$closeOnClickOutsid,
        _r$closeOnItemClick = r.closeOnItemClick,
        y = _r$closeOnItemClick === void 0 ? !0 : _r$closeOnItemClick,
        _r$zIndex4 = r.zIndex,
        b = _r$zIndex4 === void 0 ? 1e3 : _r$zIndex4,
        S = Bm(r, ["className", "themeOverride", "opened", "onClose", "transition", "transitionDuration", "transitionTimingFunction", "style", "children", "size", "shadow", "closeOnClickOutside", "closeOnItemClick", "zIndex"]);

    var I = l.Children.toArray(f).filter(function (h) {
      return h.type === me || h.type === Pe;
    }),
        N = E.useRef(),
        k = E.useRef({}),
        x = j(o),
        A = Am({
      size: p,
      theme: x
    }),
        z = V.useReducedMotion() ? 0 : s,
        _E$useState9 = E.useState(Bi(I)),
        _E$useState10 = _slicedToArray(_E$useState9, 2),
        R = _E$useState10[0],
        B = _E$useState10[1],
        F = V.useFocusTrap();

    E.useEffect(function () {
      a ? window.clearTimeout(N.current) : N.current = window.setTimeout(function () {
        B(Bi(I));
      }, z);
    }, [a]);

    var J = V.useClickOutside(function () {
      return g && n();
    }),
        v = function v(h) {
      var C = h.nativeEvent.code;

      if (C === "Escape" && n(), C === "Tab" && h.preventDefault(), C === "ArrowUp") {
        h.preventDefault();
        var $ = Fm(R, I);
        B($), k.current[$].focus();
      }

      if (C === "ArrowDown") {
        h.preventDefault();

        var _$ = Wm(R, I);

        B(_$), k.current[_$].focus();
      }
    };

    if (I.length === 0) return null;
    var O = I.map(function (h, C) {
      return h.type === me ? l.createElement(Di, Vi(Vr({}, h.props), {
        key: C,
        hovered: R === C,
        onHover: function onHover() {
          return B(-1);
        },
        onClick: function onClick($) {
          y && n(), typeof h.props.onClick == "function" && h.props.onClick($);
        },
        elementRef: function elementRef($) {
          k.current[C] = $;
        }
      })) : h.type === Pe ? l.createElement(Pe, {
        key: C,
        variant: "solid",
        className: A.hr
      }) : null;
    });
    return l.createElement(we, {
      mounted: a,
      duration: z,
      transition: i,
      timingFunction: c,
      themeOverride: o
    }, function (h) {
      return l.createElement(ce, Vr({
        shadow: u,
        className: P(A.menu, t),
        style: Vi(Vr(Vr({}, d), h), {
          zIndex: b
        }),
        onKeyDownCapture: v,
        elementRef: J,
        role: "menu",
        "aria-orientation": "vertical"
      }, S), l.createElement("div", {
        ref: F
      }, O));
    });
  }

  Ht.displayName = "@mantine/core/MenuBody";

  var Zm = Object.defineProperty,
      Ym = Object.defineProperties,
      qm = Object.getOwnPropertyDescriptors,
      Br = Object.getOwnPropertySymbols,
      Fi = Object.prototype.hasOwnProperty,
      Wi = Object.prototype.propertyIsEnumerable,
      Zi = function Zi(e, r, t) {
    return r in e ? Zm(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      ze = function ze(e, r) {
    for (var t in r || (r = {})) {
      Fi.call(r, t) && Zi(e, t, r[t]);
    }

    if (Br) {
      var _iterator91 = _createForOfIteratorHelper(Br(r)),
          _step91;

      try {
        for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
          var t = _step91.value;
          Wi.call(r, t) && Zi(e, t, r[t]);
        }
      } catch (err) {
        _iterator91.e(err);
      } finally {
        _iterator91.f();
      }
    }

    return e;
  },
      Um = function Um(e, r) {
    return Ym(e, qm(r));
  },
      Gm = function Gm(e, r) {
    var t = {};

    for (var o in e) {
      Fi.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Br) {
      var _iterator92 = _createForOfIteratorHelper(Br(e)),
          _step92;

      try {
        for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
          var o = _step92.value;
          r.indexOf(o) < 0 && Wi.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator92.e(err);
      } finally {
        _iterator92.f();
      }
    }

    return t;
  };

  var Km = Mi,
      Xm = l.createElement(pe, null, l.createElement(Em, null));

  function Yi(e) {
    var r = e,
        _r$control = r.control,
        t = _r$control === void 0 ? Xm : _r$control,
        o = r.children,
        a = r.onClose,
        n = r.onOpen,
        i = r.opened,
        s = r.themeOverride,
        _r$menuPosition = r.menuPosition,
        c = _r$menuPosition === void 0 ? {
      top: 0,
      left: 0
    } : _r$menuPosition,
        d = r.style,
        f = r.menuId,
        _r$menuBodyProps = r.menuBodyProps,
        p = _r$menuBodyProps === void 0 ? {} : _r$menuBodyProps,
        _r$closeOnItemClick2 = r.closeOnItemClick,
        u = _r$closeOnItemClick2 === void 0 ? !0 : _r$closeOnItemClick2,
        _r$transitionDuration4 = r.transitionDuration,
        g = _r$transitionDuration4 === void 0 ? 250 : _r$transitionDuration4,
        _r$size12 = r.size,
        y = _r$size12 === void 0 ? "md" : _r$size12,
        _r$shadow4 = r.shadow,
        b = _r$shadow4 === void 0 ? "md" : _r$shadow4,
        _r$transition2 = r.transition,
        S = _r$transition2 === void 0 ? "skew-up" : _r$transition2,
        I = r.transitionTimingFunction,
        N = r.menuButtonLabel,
        _r$controlRefProp = r.controlRefProp,
        k = _r$controlRefProp === void 0 ? "elementRef" : _r$controlRefProp,
        _r$zIndex5 = r.zIndex,
        x = _r$zIndex5 === void 0 ? 1e3 : _r$zIndex5,
        A = r.elementRef,
        q = Gm(r, ["control", "children", "onClose", "onOpen", "opened", "themeOverride", "menuPosition", "style", "menuId", "menuBodyProps", "closeOnItemClick", "transitionDuration", "size", "shadow", "transition", "transitionTimingFunction", "menuButtonLabel", "controlRefProp", "zIndex", "elementRef"]);

    var z = E.useRef(),
        R = E.useRef(null),
        B = V.useId(f),
        F = typeof i == "boolean",
        _E$useState11 = E.useState(!1),
        _E$useState12 = _slicedToArray(_E$useState11, 2),
        J = _E$useState12[0],
        v = _E$useState12[1],
        O = F ? i : J,
        h = function h() {
      v(!1), typeof a == "function" && a(), z.current = window.setTimeout(function () {
        var D;
        typeof ((D = R.current) == null ? void 0 : D.focus) == "function" && R.current.focus();
      }, g + 10);
    },
        C = function C() {
      v(!0), window.clearTimeout(z.current), typeof n == "function" && n();
    },
        $ = V.useClickOutside(function () {
      return O && h();
    }),
        H = function H() {
      return i || J ? h() : C();
    },
        M = E.cloneElement(t, _defineProperty({
      onClick: H,
      role: "button",
      "aria-haspopup": "menu",
      "aria-expanded": O,
      "aria-controls": B,
      "aria-label": N,
      "data-mantine-menu": !0,
      title: N
    }, k, V.useMergedRef(R, A)));

    return l.createElement("div", ze({
      ref: $,
      style: ze({
        display: "inline-block",
        position: "relative"
      }, d)
    }, q), M, l.createElement(Ht, Um(ze({}, p), {
      opened: O,
      onClose: h,
      id: B,
      themeOverride: s,
      closeOnClickOutside: !1,
      closeOnItemClick: u,
      style: ze(ze({}, p.style), c),
      transitionDuration: g,
      transition: S,
      transitionTimingFunction: I,
      size: y,
      shadow: b,
      zIndex: x
    }), o));
  }

  Yi.displayName = "@mantine/core/Menu";

  var Jm = Object.defineProperty,
      qi = Object.getOwnPropertySymbols,
      Qm = Object.prototype.hasOwnProperty,
      eg = Object.prototype.propertyIsEnumerable,
      Ui = function Ui(e, r, t) {
    return r in e ? Jm(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      rg = function rg(e, r) {
    for (var t in r || (r = {})) {
      Qm.call(r, t) && Ui(e, t, r[t]);
    }

    if (qi) {
      var _iterator93 = _createForOfIteratorHelper(qi(r)),
          _step93;

      try {
        for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
          var t = _step93.value;
          eg.call(r, t) && Ui(e, t, r[t]);
        }
      } catch (err) {
        _iterator93.e(err);
      } finally {
        _iterator93.f();
      }
    }

    return e;
  };

  function Vt(e) {
    return l.createElement("svg", rg({
      width: "20",
      height: "20",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), l.createElement("path", {
      d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }));
  }

  var Gi = {
    xs: 320,
    sm: 380,
    md: 440,
    lg: 620,
    xl: 780,
    full: "100%"
  };

  var tg = L({
    wrapper: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    inner: function inner(_ref75) {
      var e = _ref75.theme;
      return {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: "auto",
        padding: [e.spacing.xl * 2, e.spacing.md],
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start"
      };
    },
    title: function title(_ref76) {
      var e = _ref76.theme;
      return {
        marginRight: e.spacing.md,
        textOverflow: "ellipsis",
        display: "block",
        wordBreak: "break-word"
      };
    },
    modal: function modal(_ref77) {
      var e = _ref77.theme,
          r = _ref77.size;
      return {
        width: _({
          sizes: Gi,
          size: r
        }),
        padding: e.spacing.lg,
        outline: 0,
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white
      };
    },
    header: function header(_ref78) {
      var e = _ref78.theme;
      return {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: e.spacing.md
      };
    },
    body: function body(_ref79) {
      var e = _ref79.overflow;
      return {
        maxHeight: e === "inside" && "calc(100vh - 185px)",
        overflowY: e === "inside" && "auto",
        wordBreak: "break-word"
      };
    }
  }),
      og = Object.defineProperty,
      Fr = Object.getOwnPropertySymbols,
      Ki = Object.prototype.hasOwnProperty,
      Xi = Object.prototype.propertyIsEnumerable,
      Ji = function Ji(e, r, t) {
    return r in e ? og(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Qi = function Qi(e, r) {
    for (var t in r || (r = {})) {
      Ki.call(r, t) && Ji(e, t, r[t]);
    }

    if (Fr) {
      var _iterator94 = _createForOfIteratorHelper(Fr(r)),
          _step94;

      try {
        for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
          var t = _step94.value;
          Xi.call(r, t) && Ji(e, t, r[t]);
        }
      } catch (err) {
        _iterator94.e(err);
      } finally {
        _iterator94.f();
      }
    }

    return e;
  },
      ag = function ag(e, r) {
    var t = {};

    for (var o in e) {
      Ki.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Fr) {
      var _iterator95 = _createForOfIteratorHelper(Fr(e)),
          _step95;

      try {
        for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
          var o = _step95.value;
          r.indexOf(o) < 0 && Xi.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator95.e(err);
      } finally {
        _iterator95.f();
      }
    }

    return t;
  };

  var ng = Gi;

  function ig(e) {
    var r = e,
        t = r.className,
        o = r.opened,
        a = r.themeOverride,
        n = r.title,
        i = r.onClose,
        s = r.children,
        _r$hideCloseButton = r.hideCloseButton,
        c = _r$hideCloseButton === void 0 ? !1 : _r$hideCloseButton,
        d = r.overlayOpacity,
        _r$size13 = r.size,
        f = _r$size13 === void 0 ? "md" : _r$size13,
        _r$transitionDuration5 = r.transitionDuration,
        p = _r$transitionDuration5 === void 0 ? 300 : _r$transitionDuration5,
        u = r.closeButtonLabel,
        g = r.overlayColor,
        _r$zIndex6 = r.zIndex,
        y = _r$zIndex6 === void 0 ? 1e3 : _r$zIndex6,
        _r$overflow = r.overflow,
        b = _r$overflow === void 0 ? "outside" : _r$overflow,
        _r$transition3 = r.transition,
        S = _r$transition3 === void 0 ? "slide-down" : _r$transition3,
        I = r.id,
        N = ag(r, ["className", "opened", "themeOverride", "title", "onClose", "children", "hideCloseButton", "overlayOpacity", "size", "transitionDuration", "closeButtonLabel", "overlayColor", "zIndex", "overflow", "transition", "id"]);
    var k = V.useId(I),
        x = "".concat(k, "-title"),
        A = "".concat(k, "-body"),
        q = V.useReducedMotion(),
        z = j(a),
        R = tg({
      size: f,
      overflow: b,
      theme: z
    }),
        B = V.useClickOutside(i),
        F = V.useFocusTrap(),
        J = q ? 1 : p,
        v = typeof d == "number" ? d : z.colorScheme === "dark" ? .85 : .75;
    return V.useScrollLock(o), l.createElement(wr, {
      mounted: o,
      transitions: {
        modal: {
          duration: J,
          transition: S
        },
        overlay: {
          duration: J / 2,
          transition: "fade",
          timingFunction: "ease"
        }
      }
    }, function (O) {
      return l.createElement("div", Qi({
        className: P(R.wrapper, t)
      }, N), l.createElement("div", {
        "data-mantine-modal-inner": !0,
        className: R.inner,
        onKeyDownCapture: function onKeyDownCapture(h) {
          return h.nativeEvent.code === "Escape" && i();
        },
        style: {
          zIndex: y + 1
        },
        ref: F
      }, l.createElement(ce, {
        className: R.modal,
        shadow: "lg",
        role: "dialog",
        "aria-labelledby": x,
        "aria-describedby": A,
        "aria-modal": !0,
        style: O.modal,
        elementRef: B,
        tabIndex: -1
      }, (n || !c) && l.createElement("div", {
        "data-mantine-modal-header": !0,
        className: R.header
      }, l.createElement(ne, {
        id: x,
        "data-mantine-modal-title": !0,
        className: R.title
      }, n), !c && l.createElement(pe, {
        onClick: i,
        "aria-label": u
      }, l.createElement(Vt, null))), l.createElement("div", {
        id: A,
        className: R.body
      }, s))), l.createElement("div", {
        style: O.overlay
      }, l.createElement(Ie, {
        color: g || (z.colorScheme === "dark" ? z.colors.dark[9] : z.black),
        opacity: v,
        zIndex: y
      })));
    });
  }

  function el(e) {
    return l.createElement(cr, {
      zIndex: e.zIndex || 1e3
    }, l.createElement(ig, Qi({}, e)));
  }

  el.displayName = "@mantine/core/Modal";

  var lg = L({
    withIcon: {
      paddingLeft: "10px !important",
      "&::before": {
        display: "none !important"
      }
    },
    notification: function notification(_ref80) {
      var e = _ref80.color,
          r = _ref80.theme;
      return {
        boxSizing: "border-box",
        position: "relative",
        display: "flex",
        alignItems: "center",
        paddingLeft: 22,
        paddingRight: 5,
        paddingTop: 10,
        paddingBottom: 10,
        borderRadius: 4,
        backgroundColor: r.colorScheme === "dark" ? r.colors.dark[6] : r.white,
        border: "1px solid ".concat(r.colorScheme === "dark" ? r.colors.dark[6] : r.colors.gray[2]),
        "&::before": {
          content: "''",
          display: "block",
          position: "absolute",
          width: 6,
          top: 4,
          bottom: 4,
          left: 4,
          borderRadius: 4,
          backgroundColor: w({
            theme: r,
            color: e,
            shade: r.colorScheme === "dark" ? 7 : 6
          })
        },
        "& $icon": {
          backgroundColor: re(w({
            theme: r,
            color: e,
            shade: r.colorScheme === "dark" ? 7 : 6
          }), r.colorScheme === "dark" ? .7 : 1),
          color: r.white
        }
      };
    },
    body: function body(_ref81) {
      var e = _ref81.disallowClose;
      return {
        flex: 1,
        maxWidth: e ? "100%" : "calc(100% - 40px)",
        marginRight: 10
      };
    },
    loader: function loader(_ref82) {
      var e = _ref82.theme;
      return {
        marginRight: e.spacing.md
      };
    },
    icon: function icon(_ref83) {
      var e = _ref83.theme;
      return {
        boxSizing: "border-box",
        marginRight: e.spacing.md,
        width: 28,
        height: 28,
        borderRadius: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: e.white
      };
    },
    title: function title(_ref84) {
      var e = _ref84.theme;
      return {
        lineHeight: 1.4,
        marginBottom: 2,
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: e.colorScheme === "dark" ? e.white : e.colors.gray[9]
      };
    },
    description: function description(_ref85) {
      var e = _ref85.theme;
      return {
        color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6],
        lineHeight: 1.4,
        overflow: "hidden",
        textOverflow: "ellipsis",
        "&:only-child": {
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black
        }
      };
    }
  }),
      sg = Object.defineProperty,
      cg = Object.defineProperties,
      dg = Object.getOwnPropertyDescriptors,
      Wr = Object.getOwnPropertySymbols,
      rl = Object.prototype.hasOwnProperty,
      tl = Object.prototype.propertyIsEnumerable,
      ol = function ol(e, r, t) {
    return r in e ? sg(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      al = function al(e, r) {
    for (var t in r || (r = {})) {
      rl.call(r, t) && ol(e, t, r[t]);
    }

    if (Wr) {
      var _iterator96 = _createForOfIteratorHelper(Wr(r)),
          _step96;

      try {
        for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
          var t = _step96.value;
          tl.call(r, t) && ol(e, t, r[t]);
        }
      } catch (err) {
        _iterator96.e(err);
      } finally {
        _iterator96.f();
      }
    }

    return e;
  },
      fg = function fg(e, r) {
    return cg(e, dg(r));
  },
      pg = function pg(e, r) {
    var t = {};

    for (var o in e) {
      rl.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Wr) {
      var _iterator97 = _createForOfIteratorHelper(Wr(e)),
          _step97;

      try {
        for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
          var o = _step97.value;
          r.indexOf(o) < 0 && tl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator97.e(err);
      } finally {
        _iterator97.f();
      }
    }

    return t;
  };

  function nl(e) {
    var r = e,
        t = r.className,
        _r$color5 = r.color,
        o = _r$color5 === void 0 ? "blue" : _r$color5,
        _r$loading = r.loading,
        a = _r$loading === void 0 ? !1 : _r$loading,
        _r$disallowClose = r.disallowClose,
        n = _r$disallowClose === void 0 ? !1 : _r$disallowClose,
        i = r.title,
        s = r.icon,
        c = r.children,
        d = r.onClose,
        f = r.closeButtonProps,
        p = r.themeOverride,
        u = pg(r, ["className", "color", "loading", "disallowClose", "title", "icon", "children", "onClose", "closeButtonProps", "themeOverride"]);
    var g = lg({
      color: o,
      disallowClose: n,
      theme: j(p)
    });
    return l.createElement(ce, al({
      shadow: "lg",
      padding: "sm",
      className: P(g.notification, _defineProperty({}, g.withIcon, s || a), t),
      role: "alert",
      themeOverride: p
    }, u), s && !a && l.createElement("div", {
      "data-mantine-icon": !0,
      className: g.icon
    }, s), a && l.createElement(Dr, {
      size: 28,
      color: o,
      className: g.loader
    }), l.createElement("div", {
      className: g.body
    }, i && l.createElement(ne, {
      "data-mantine-title": !0,
      className: g.title,
      size: "sm",
      weight: 500,
      themeOverride: p
    }, i), l.createElement(ne, {
      "data-mantine-body": !0,
      className: g.description,
      size: "sm",
      themeOverride: p
    }, c)), !n && l.createElement(pe, fg(al({}, f), {
      color: "gray",
      onClick: d,
      themeOverride: p
    }), l.createElement(Vt, null)));
  }

  nl.displayName = "@mantine/core/Notification";

  var ug = Object.defineProperty,
      vg = Object.defineProperties,
      mg = Object.getOwnPropertyDescriptors,
      Zr = Object.getOwnPropertySymbols,
      il = Object.prototype.hasOwnProperty,
      ll = Object.prototype.propertyIsEnumerable,
      sl = function sl(e, r, t) {
    return r in e ? ug(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      cl = function cl(e, r) {
    for (var t in r || (r = {})) {
      il.call(r, t) && sl(e, t, r[t]);
    }

    if (Zr) {
      var _iterator98 = _createForOfIteratorHelper(Zr(r)),
          _step98;

      try {
        for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
          var t = _step98.value;
          ll.call(r, t) && sl(e, t, r[t]);
        }
      } catch (err) {
        _iterator98.e(err);
      } finally {
        _iterator98.f();
      }
    }

    return e;
  },
      gg = function gg(e, r) {
    return vg(e, mg(r));
  },
      _g = function _g(e, r) {
    var t = {};

    for (var o in e) {
      il.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Zr) {
      var _iterator99 = _createForOfIteratorHelper(Zr(e)),
          _step99;

      try {
        for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
          var o = _step99.value;
          r.indexOf(o) < 0 && ll.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator99.e(err);
      } finally {
        _iterator99.f();
      }
    }

    return t;
  };

  function Yr(e) {
    var r = e,
        t = r.className,
        o = r.id,
        a = r.label,
        n = r.error,
        i = r.required,
        _r$type2 = r.type,
        s = _r$type2 === void 0 ? "text" : _r$type2,
        c = r.style,
        d = r.icon,
        f = r.description,
        p = r.themeOverride,
        u = r.wrapperProps,
        g = r.elementRef,
        y = _g(r, ["className", "id", "label", "error", "required", "type", "style", "icon", "description", "themeOverride", "wrapperProps", "elementRef"]);

    var b = V.useId(o);
    return l.createElement(Se, cl({
      required: i,
      id: b,
      label: a,
      error: n,
      description: f,
      className: t,
      style: c,
      themeOverride: p
    }, u), l.createElement($e, gg(cl({}, y), {
      required: i,
      elementRef: g,
      id: b,
      type: s,
      invalid: !!n,
      icon: d,
      themeOverride: p
    })));
  }

  Yr.displayName = "@mantine/core/TextInput";
  var dl = 24;

  var yg = L({
    rightSection: {
      display: "flex",
      flexDirection: "column",
      height: "calc(100% - 2px)",
      margin: 1,
      marginRight: 1
    },
    control: function control(_ref86) {
      var e = _ref86.theme;
      return {
        position: "relative",
        flex: "0 0 50%",
        boxSizing: "border-box",
        width: dl,
        borderBottom: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]),
        borderLeft: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]),
        borderTop: 0,
        borderRight: 0,
        backgroundColor: "transparent",
        marginRight: 1,
        "&:not(:disabled):hover": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0]
        },
        "&::after": {
          position: "absolute",
          top: "calc(50% - 2.5px)",
          left: "calc(50% - 4.5px)",
          content: '""',
          display: "block",
          width: 0,
          height: 0,
          borderStyle: "solid"
        }
      };
    },
    controlUp: function controlUp(_ref87) {
      var e = _ref87.theme,
          r = _ref87.radius;
      return {
        borderTopRightRadius: _({
          size: r,
          sizes: e.radius
        }) - 1,
        "&::after": {
          borderWidth: [0, 5, 5, 5],
          borderColor: ["transparent", "transparent", e.colorScheme === "dark" ? e.colors.dark[0] : e.black, "transparent"]
        },
        "&:disabled::after": {
          borderBottomColor: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[5]
        }
      };
    },
    controlDown: function controlDown(_ref88) {
      var e = _ref88.theme,
          r = _ref88.radius;
      return {
        borderBottomRightRadius: _({
          size: r,
          sizes: e.radius
        }) - 1,
        borderBottom: 0,
        "&::after": {
          borderWidth: [5, 5, 0, 5],
          borderColor: [e.colorScheme === "dark" ? e.colors.dark[0] : e.black, "transparent", "transparent", "transparent"]
        },
        "&:disabled::after": {
          borderTopColor: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[5]
        }
      };
    }
  }),
      bg = Object.defineProperty,
      Og = Object.defineProperties,
      hg = Object.getOwnPropertyDescriptors,
      qr = Object.getOwnPropertySymbols,
      fl = Object.prototype.hasOwnProperty,
      pl = Object.prototype.propertyIsEnumerable,
      ul = function ul(e, r, t) {
    return r in e ? bg(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      wg = function wg(e, r) {
    for (var t in r || (r = {})) {
      fl.call(r, t) && ul(e, t, r[t]);
    }

    if (qr) {
      var _iterator100 = _createForOfIteratorHelper(qr(r)),
          _step100;

      try {
        for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
          var t = _step100.value;
          pl.call(r, t) && ul(e, t, r[t]);
        }
      } catch (err) {
        _iterator100.e(err);
      } finally {
        _iterator100.f();
      }
    }

    return e;
  },
      Pg = function Pg(e, r) {
    return Og(e, hg(r));
  },
      $g = function $g(e, r) {
    var t = {};

    for (var o in e) {
      fl.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && qr) {
      var _iterator101 = _createForOfIteratorHelper(qr(e)),
          _step101;

      try {
        for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
          var o = _step101.value;
          r.indexOf(o) < 0 && pl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator101.e(err);
      } finally {
        _iterator101.f();
      }
    }

    return t;
  };

  function vl(e) {
    var r = e,
        t = r.disabled,
        o = r.themeOverride,
        a = r.elementRef,
        n = r.value,
        i = r.onChange,
        s = r.min,
        c = r.max,
        _r$step = r.step,
        d = _r$step === void 0 ? 1 : _r$step,
        f = r.onBlur,
        p = r.onFocus,
        _r$hideControls = r.hideControls,
        u = _r$hideControls === void 0 ? !1 : _r$hideControls,
        _r$radius10 = r.radius,
        g = _r$radius10 === void 0 ? "sm" : _r$radius10,
        y = r.variant,
        _r$precision = r.precision,
        b = _r$precision === void 0 ? 0 : _r$precision,
        S = r.defaultValue,
        _r$noClampOnBlur = r.noClampOnBlur,
        I = _r$noClampOnBlur === void 0 ? !1 : _r$noClampOnBlur,
        N = r.handlersRef,
        k = $g(r, ["disabled", "themeOverride", "elementRef", "value", "onChange", "min", "max", "step", "onBlur", "onFocus", "hideControls", "radius", "variant", "precision", "defaultValue", "noClampOnBlur", "handlersRef"]);

    var x = j(o),
        A = yg({
      theme: x,
      radius: g
    }),
        _E$useState13 = E.useState(!1),
        _E$useState14 = _slicedToArray(_E$useState13, 2),
        q = _E$useState14[0],
        z = _E$useState14[1],
        _E$useState15 = E.useState(typeof n == "number" ? n : typeof S == "number" ? S : 0),
        _E$useState16 = _slicedToArray(_E$useState15, 2),
        R = _E$useState16[0],
        B = _E$useState16[1],
        F = typeof n == "number" ? n : R,
        _E$useState17 = E.useState(typeof F == "number" ? F.toFixed(b) : ""),
        _E$useState18 = _slicedToArray(_E$useState17, 2),
        J = _E$useState18[0],
        v = _E$useState18[1],
        O = E.useRef(),
        h = function h(Z) {
      typeof i == "function" && i(Z), B(Z);
    },
        C = typeof s == "number" ? s : -Infinity,
        $ = typeof c == "number" ? c : Infinity,
        H = function H(Z) {
      var ee = typeof Z == "number" ? Z : parseFloat(Z);
      return Math.min(Math.max(ee, C), $);
    },
        M = function M() {
      var Z = H(F + d).toFixed(b);
      h(parseFloat(Z)), v(Z);
    },
        D = function D() {
      var Z = H(F - d).toFixed(b);
      h(parseFloat(Z)), v(Z);
    };

    typeof N == "function" ? N({
      increment: M,
      decrement: D
    }) : _typeof(N) == "object" && N !== null && "current" in N && (N.current = {
      increment: M,
      decrement: D
    }), E.useEffect(function () {
      typeof n == "number" && !q && (B(n), v(n.toFixed(b)));
    }, [n]);

    var Y = l.createElement("div", {
      className: A.rightSection
    }, l.createElement("button", {
      type: "button",
      tabIndex: -1,
      "aria-hidden": !0,
      "data-mantine-increment": !0,
      disabled: F >= c,
      className: P(A.control, A.controlUp),
      onMouseDown: function onMouseDown(Z) {
        Z.preventDefault(), M(), O.current.focus();
      }
    }), l.createElement("button", {
      type: "button",
      tabIndex: -1,
      "aria-hidden": !0,
      "data-mantine-decrement": !0,
      disabled: F <= s,
      className: P(A.control, A.controlDown),
      onMouseDown: function onMouseDown(Z) {
        Z.preventDefault(), D(), O.current.focus();
      }
    })),
        U = function U(Z) {
      var ee = Z.currentTarget.value;
      v(ee);
      var bt = Number(ee);
      ee.trim() !== "" && !Number.isNaN(bt) && h(bt);
    },
        G = function G(Z) {
      var ee = H(Z.currentTarget.value);
      Number.isNaN(ee) ? v(F.toFixed(b)) : I || (v(ee.toFixed(b)), h(ee)), z(!1), typeof f == "function" && f(Z);
    },
        oe = function oe(Z) {
      z(!0), typeof p == "function" && f(Z);
    };

    return l.createElement(Yr, Pg(wg({}, k), {
      variant: y,
      value: J,
      disabled: t,
      themeOverride: o,
      elementRef: V.useMergedRef(O, a),
      type: "number",
      onChange: U,
      onBlur: G,
      onFocus: oe,
      rightSection: t || u || y === "unstyled" ? null : Y,
      rightSectionWidth: dl + 1,
      radius: g,
      max: c,
      min: s,
      step: d
    }));
  }

  vl.displayName = "@mantine/core/NumberInput";

  var Sg = Object.defineProperty,
      Ur = Object.getOwnPropertySymbols,
      ml = Object.prototype.hasOwnProperty,
      gl = Object.prototype.propertyIsEnumerable,
      _l = function _l(e, r, t) {
    return r in e ? Sg(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Eg = function Eg(e, r) {
    for (var t in r || (r = {})) {
      ml.call(r, t) && _l(e, t, r[t]);
    }

    if (Ur) {
      var _iterator102 = _createForOfIteratorHelper(Ur(r)),
          _step102;

      try {
        for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
          var t = _step102.value;
          gl.call(r, t) && _l(e, t, r[t]);
        }
      } catch (err) {
        _iterator102.e(err);
      } finally {
        _iterator102.f();
      }
    }

    return e;
  },
      xg = function xg(e, r) {
    var t = {};

    for (var o in e) {
      ml.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Ur) {
      var _iterator103 = _createForOfIteratorHelper(Ur(e)),
          _step103;

      try {
        for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
          var o = _step103.value;
          r.indexOf(o) < 0 && gl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator103.e(err);
      } finally {
        _iterator103.f();
      }
    }

    return t;
  };

  function Cg(e) {
    var r = e,
        t = r.reveal,
        o = xg(r, ["reveal"]);
    return l.createElement("svg", Eg({
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, o), l.createElement("path", {
      d: t ? "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" : "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }));
  }

  var Ig = Object.defineProperty,
      Ng = Object.defineProperties,
      kg = Object.getOwnPropertyDescriptors,
      Gr = Object.getOwnPropertySymbols,
      yl = Object.prototype.hasOwnProperty,
      bl = Object.prototype.propertyIsEnumerable,
      Ol = function Ol(e, r, t) {
    return r in e ? Ig(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      jg = function jg(e, r) {
    for (var t in r || (r = {})) {
      yl.call(r, t) && Ol(e, t, r[t]);
    }

    if (Gr) {
      var _iterator104 = _createForOfIteratorHelper(Gr(r)),
          _step104;

      try {
        for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
          var t = _step104.value;
          bl.call(r, t) && Ol(e, t, r[t]);
        }
      } catch (err) {
        _iterator104.e(err);
      } finally {
        _iterator104.f();
      }
    }

    return e;
  },
      Rg = function Rg(e, r) {
    return Ng(e, kg(r));
  },
      Tg = function Tg(e, r) {
    var t = {};

    for (var o in e) {
      yl.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Gr) {
      var _iterator105 = _createForOfIteratorHelper(Gr(e)),
          _step105;

      try {
        for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
          var o = _step105.value;
          r.indexOf(o) < 0 && bl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator105.e(err);
      } finally {
        _iterator105.f();
      }
    }

    return t;
  };

  function hl(e) {
    var r = e,
        t = r.radius,
        o = r.disabled,
        a = r.hidePasswordLabel,
        n = r.showPasswordLabel,
        i = r.themeOverride,
        _r$focusInputOnToggle = r.focusInputOnToggle,
        s = _r$focusInputOnToggle === void 0 ? !1 : _r$focusInputOnToggle,
        c = r.elementRef,
        d = Tg(r, ["radius", "disabled", "hidePasswordLabel", "showPasswordLabel", "themeOverride", "focusInputOnToggle", "elementRef"]);

    var f = E.useRef(),
        _E$useState19 = E.useState(!1),
        _E$useState20 = _slicedToArray(_E$useState19, 2),
        p = _E$useState20[0],
        u = _E$useState20[1],
        g = function g() {
      u(function (b) {
        return !b;
      }), s && f.current.focus();
    },
        y = l.createElement(pe, {
      onClick: g,
      themeOverride: i,
      title: p ? a : n,
      "aria-label": p ? a : n,
      radius: t
    }, l.createElement(Cg, {
      reveal: p
    }));

    return l.createElement(Yr, Rg(jg({}, d), {
      disabled: o,
      themeOverride: i,
      elementRef: V.useMergedRef(f, c),
      type: p ? "text" : "password",
      rightSection: o ? null : y,
      radius: t
    }));
  }

  hl.displayName = "@mantine/core/PasswordInput";

  var zg = Object.defineProperty,
      Dg = Object.defineProperties,
      Mg = Object.getOwnPropertyDescriptors,
      wl = Object.getOwnPropertySymbols,
      Ag = Object.prototype.hasOwnProperty,
      Lg = Object.prototype.propertyIsEnumerable,
      Pl = function Pl(e, r, t) {
    return r in e ? zg(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Kr = function Kr(e, r) {
    for (var t in r || (r = {})) {
      Ag.call(r, t) && Pl(e, t, r[t]);
    }

    if (wl) {
      var _iterator106 = _createForOfIteratorHelper(wl(r)),
          _step106;

      try {
        for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
          var t = _step106.value;
          Lg.call(r, t) && Pl(e, t, r[t]);
        }
      } catch (err) {
        _iterator106.e(err);
      } finally {
        _iterator106.f();
      }
    }

    return e;
  },
      Xr = function Xr(e, r) {
    return Dg(e, Mg(r));
  };

  var $l = function $l(e) {
    return {
      "&$center": {
        top: "50%",
        transform: "translateY(-50%)",
        "& $arrow": {
          top: "calc(50% - ".concat(e, "px)")
        }
      },
      "&$end": {
        bottom: 0,
        "& $arrow": {
          bottom: e * 2
        }
      },
      "&$start": {
        top: 0,
        "& $arrow": {
          top: e * 2
        }
      }
    };
  },
      Sl = function Sl(e) {
    return {
      "&$center": {
        left: "50%",
        transform: "translateX(-50%)",
        "& $arrow": {
          left: "calc(50% - ".concat(e, "px)")
        }
      },
      "&$end": {
        right: 0,
        "& $arrow": {
          right: e * 2
        }
      },
      "&$start": {
        left: 0,
        "& $arrow": {
          left: e * 2
        }
      }
    };
  };

  var Hg = L({
    center: {},
    start: {},
    end: {},
    wrapper: {
      position: "relative",
      display: "inline-block"
    },
    popoverWrapper: {
      background: "transparent",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      pointerEvents: "none"
    },
    popover: function popover(_ref89) {
      var e = _ref89.theme,
          r = _ref89.radius;
      return {
        position: "absolute",
        background: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
        pointerEvents: "all",
        borderRadius: _({
          size: r,
          sizes: e.radius
        })
      };
    },
    arrow: function arrow(_ref90) {
      var e = _ref90.theme,
          r = _ref90.arrowSize;
      return {
        width: r * 2,
        height: r * 2,
        position: "absolute",
        transform: "rotate(45deg)",
        border: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[2]),
        background: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
        zIndex: 1
      };
    },
    body: function body(_ref91) {
      var e = _ref91.theme,
          r = _ref91.radius,
          t = _ref91.shadow;
      return {
        border: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[2]),
        boxShadow: t in e.shadows ? e.shadows[t] : t,
        borderRadius: _({
          size: r,
          sizes: e.radius
        })
      };
    },
    inner: function inner(_ref92) {
      var e = _ref92.theme,
          r = _ref92.spacing;
      return {
        padding: _({
          size: r,
          sizes: e.spacing
        })
      };
    },
    header: function header(_ref93) {
      var e = _ref93.theme,
          r = _ref93.spacing;
      return {
        borderBottom: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[7] : e.colors.gray[2]),
        padding: [e.spacing.xs / 1.5, _({
          size: r,
          sizes: e.spacing
        })],
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      };
    },
    target: {
      zIndex: 1
    },
    closeButton: {
      position: "absolute",
      top: 7,
      zIndex: 2,
      right: 10
    },
    left: function left(_ref94) {
      var e = _ref94.gutter,
          r = _ref94.arrowSize;
      return Xr(Kr({}, $l(r)), {
        right: "calc(100% + ".concat(e, "px)"),
        "& $arrow": {
          right: -r,
          borderLeft: 0,
          borderBottom: 0
        }
      });
    },
    right: function right(_ref95) {
      var e = _ref95.gutter,
          r = _ref95.arrowSize;
      return Xr(Kr({}, $l(r)), {
        left: "calc(100% + ".concat(e, "px)"),
        "& $arrow": {
          left: -r,
          borderRight: 0,
          borderTop: 0
        }
      });
    },
    top: function top(_ref96) {
      var e = _ref96.gutter,
          r = _ref96.arrowSize;
      return Xr(Kr({}, Sl(r)), {
        bottom: "calc(100% + ".concat(e, "px)"),
        "& $arrow": {
          bottom: -r,
          borderLeft: 0,
          borderTop: 0
        }
      });
    },
    bottom: function bottom(_ref97) {
      var e = _ref97.gutter,
          r = _ref97.arrowSize;
      return Xr(Kr({}, Sl(r)), {
        top: "calc(100% + ".concat(e, "px)"),
        "& $arrow": {
          top: -r,
          borderRight: 0,
          borderBottom: 0
        }
      });
    }
  }),
      Vg = Object.defineProperty,
      Jr = Object.getOwnPropertySymbols,
      El = Object.prototype.hasOwnProperty,
      xl = Object.prototype.propertyIsEnumerable,
      Cl = function Cl(e, r, t) {
    return r in e ? Vg(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Il = function Il(e, r) {
    for (var t in r || (r = {})) {
      El.call(r, t) && Cl(e, t, r[t]);
    }

    if (Jr) {
      var _iterator107 = _createForOfIteratorHelper(Jr(r)),
          _step107;

      try {
        for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
          var t = _step107.value;
          xl.call(r, t) && Cl(e, t, r[t]);
        }
      } catch (err) {
        _iterator107.e(err);
      } finally {
        _iterator107.f();
      }
    }

    return e;
  },
      Bg = function Bg(e, r) {
    var t = {};

    for (var o in e) {
      El.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Jr) {
      var _iterator108 = _createForOfIteratorHelper(Jr(e)),
          _step108;

      try {
        for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
          var o = _step108.value;
          r.indexOf(o) < 0 && xl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator108.e(err);
      } finally {
        _iterator108.f();
      }
    }

    return t;
  };

  function Nl(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = r.children,
        n = r.target,
        i = r.title,
        s = r.onClose,
        c = r.opened,
        _r$zIndex7 = r.zIndex,
        d = _r$zIndex7 === void 0 ? 1e3 : _r$zIndex7,
        _r$arrowSize = r.arrowSize,
        f = _r$arrowSize === void 0 ? 4 : _r$arrowSize,
        _r$withArrow = r.withArrow,
        p = _r$withArrow === void 0 ? !1 : _r$withArrow,
        _r$transition4 = r.transition,
        u = _r$transition4 === void 0 ? "fade" : _r$transition4,
        _r$transitionDuration6 = r.transitionDuration,
        g = _r$transitionDuration6 === void 0 ? 200 : _r$transitionDuration6,
        y = r.transitionTimingFunction,
        _r$gutter3 = r.gutter,
        b = _r$gutter3 === void 0 ? 10 : _r$gutter3,
        _r$position3 = r.position,
        S = _r$position3 === void 0 ? "left" : _r$position3,
        _r$placement = r.placement,
        I = _r$placement === void 0 ? "center" : _r$placement,
        _r$disabled2 = r.disabled,
        N = _r$disabled2 === void 0 ? !1 : _r$disabled2,
        _r$noClickOutside = r.noClickOutside,
        k = _r$noClickOutside === void 0 ? !1 : _r$noClickOutside,
        _r$noFocusTrap2 = r.noFocusTrap,
        x = _r$noFocusTrap2 === void 0 ? !1 : _r$noFocusTrap2,
        _r$noEscape = r.noEscape,
        A = _r$noEscape === void 0 ? !1 : _r$noEscape,
        _r$withCloseButton = r.withCloseButton,
        q = _r$withCloseButton === void 0 ? !1 : _r$withCloseButton,
        _r$radius11 = r.radius,
        z = _r$radius11 === void 0 ? "sm" : _r$radius11,
        _r$spacing2 = r.spacing,
        R = _r$spacing2 === void 0 ? "md" : _r$spacing2,
        _r$shadow5 = r.shadow,
        B = _r$shadow5 === void 0 ? "sm" : _r$shadow5,
        F = r.bodyStyle,
        J = r.bodyClassName,
        v = r.closeButtonLabel,
        O = r.id,
        h = Bg(r, ["className", "themeOverride", "children", "target", "title", "onClose", "opened", "zIndex", "arrowSize", "withArrow", "transition", "transitionDuration", "transitionTimingFunction", "gutter", "position", "placement", "disabled", "noClickOutside", "noFocusTrap", "noEscape", "withCloseButton", "radius", "spacing", "shadow", "bodyStyle", "bodyClassName", "closeButtonLabel", "id"]);

    var C = j(o),
        $ = Hg({
      theme: C,
      gutter: b,
      arrowSize: f,
      radius: z,
      spacing: R,
      shadow: B
    }),
        H = function H() {
      return typeof s == "function" && s();
    },
        M = V.useClickOutside(function () {
      return !k && H();
    }),
        D = V.useFocusTrap(!x),
        Y = V.useReducedMotion(),
        U = function U(ee) {
      !A && ee.nativeEvent.code === "Escape" && H();
    },
        G = V.useId(O),
        oe = "".concat(G, "-title"),
        Z = "".concat(G, "-body");

    return l.createElement("div", Il({
      className: P($.wrapper, t),
      ref: M,
      id: O
    }, h), l.createElement(we, {
      mounted: c && !N,
      transition: u,
      duration: Y ? 0 : g,
      timingFunction: y || C.transitionTimingFunction
    }, function (ee) {
      return l.createElement("div", {
        style: ee,
        role: "dialog",
        tabIndex: -1,
        "data-mantine-popover": !0,
        "aria-labelledby": oe,
        "aria-describedby": Z,
        className: $.popoverWrapper,
        ref: D,
        onKeyDownCapture: U
      }, l.createElement("div", {
        className: P($.popover, $[S], $[I], J),
        style: Il({
          zIndex: d
        }, F)
      }, p && l.createElement("div", {
        "data-mantine-popover-arrow": !0,
        className: $.arrow
      }), l.createElement("div", {
        className: $.body
      }, !!i && l.createElement("div", {
        className: $.header,
        "data-mantine-popover-header": !0
      }, l.createElement(ne, {
        size: "sm",
        id: oe,
        "data-mantine-popover-title": !0
      }, i)), q && l.createElement(pe, {
        size: "sm",
        "data-mantine-popover-close": !0,
        onClick: H,
        "aria-label": v,
        className: P($.closeButton)
      }, l.createElement(Vt, {
        style: {
          width: 14,
          height: 14
        }
      })), l.createElement("div", {
        className: $.inner,
        id: Z,
        "data-mantine-popover-body": !0
      }, a))));
    }), l.createElement("div", {
      "data-mantine-popover-target": !0,
      className: $.target
    }, n));
  }

  Nl.displayName = "@mantine/core/Popover";
  var kl = {
    xs: 3,
    sm: 5,
    md: 8,
    lg: 12,
    xl: 16
  };

  var Fg = L({
    progress: function progress(_ref98) {
      var e = _ref98.radius,
          r = _ref98.size,
          t = _ref98.theme;
      return {
        height: _({
          size: r,
          sizes: kl
        }),
        backgroundColor: t.colorScheme === "dark" ? t.colors.dark[4] : t.colors.gray[2],
        borderRadius: _({
          size: e,
          sizes: t.radius
        }),
        overflow: "hidden"
      };
    },
    bar: function bar(_ref99) {
      var e = _ref99.theme,
          r = _ref99.color,
          t = _ref99.radius,
          o = _ref99.reduceMotion,
          a = _ref99.striped;
      return {
        height: "100%",
        backgroundColor: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 4 : 6
        }),
        borderRadius: _({
          size: t,
          sizes: e.radius
        }),
        transition: o ? "none" : "width 200ms ".concat(e.transitionTimingFunction),
        backgroundSize: [e.spacing.md, e.spacing.md],
        backgroundImage: a ? "linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)" : "none"
      };
    }
  }),
      Wg = Object.defineProperty,
      Qr = Object.getOwnPropertySymbols,
      jl = Object.prototype.hasOwnProperty,
      Rl = Object.prototype.propertyIsEnumerable,
      Tl = function Tl(e, r, t) {
    return r in e ? Wg(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Zg = function Zg(e, r) {
    for (var t in r || (r = {})) {
      jl.call(r, t) && Tl(e, t, r[t]);
    }

    if (Qr) {
      var _iterator109 = _createForOfIteratorHelper(Qr(r)),
          _step109;

      try {
        for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
          var t = _step109.value;
          Rl.call(r, t) && Tl(e, t, r[t]);
        }
      } catch (err) {
        _iterator109.e(err);
      } finally {
        _iterator109.f();
      }
    }

    return e;
  },
      Yg = function Yg(e, r) {
    var t = {};

    for (var o in e) {
      jl.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && Qr) {
      var _iterator110 = _createForOfIteratorHelper(Qr(e)),
          _step110;

      try {
        for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
          var o = _step110.value;
          r.indexOf(o) < 0 && Rl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator110.e(err);
      } finally {
        _iterator110.f();
      }
    }

    return t;
  };

  var qg = kl;

  function zl(e) {
    var r = e,
        t = r.className,
        o = r.value,
        a = r.color,
        _r$size14 = r.size,
        n = _r$size14 === void 0 ? "md" : _r$size14,
        _r$radius12 = r.radius,
        i = _r$radius12 === void 0 ? "sm" : _r$radius12,
        _r$striped = r.striped,
        s = _r$striped === void 0 ? !1 : _r$striped,
        c = r.themeOverride,
        d = r["aria-label"],
        f = Yg(r, ["className", "value", "color", "size", "radius", "striped", "themeOverride", "aria-label"]);
    var p = Fg({
      color: a,
      size: n,
      radius: i,
      striped: s,
      reduceMotion: V.useReducedMotion(),
      theme: j(c)
    });
    return l.createElement("div", Zg({
      className: P(p.progress, t)
    }, f), l.createElement("div", {
      role: "progressbar",
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuenow": o,
      "aria-label": d,
      className: p.bar,
      style: {
        width: "".concat(o, "%")
      }
    }));
  }

  zl.displayName = "@mantine/core/Progress";

  var Ug = Object.defineProperty,
      Gg = Object.defineProperties,
      Kg = Object.getOwnPropertyDescriptors,
      Dl = Object.getOwnPropertySymbols,
      Xg = Object.prototype.hasOwnProperty,
      Jg = Object.prototype.propertyIsEnumerable,
      Ml = function Ml(e, r, t) {
    return r in e ? Ug(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Al = function Al(e, r) {
    for (var t in r || (r = {})) {
      Xg.call(r, t) && Ml(e, t, r[t]);
    }

    if (Dl) {
      var _iterator111 = _createForOfIteratorHelper(Dl(r)),
          _step111;

      try {
        for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
          var t = _step111.value;
          Jg.call(r, t) && Ml(e, t, r[t]);
        }
      } catch (err) {
        _iterator111.e(err);
      } finally {
        _iterator111.f();
      }
    }

    return e;
  },
      Ll = function Ll(e, r) {
    return Gg(e, Kg(r));
  };

  var de = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 26,
    xl: 36
  };

  var Qg = L({
    labelDisabled: {},
    wrapper: {
      display: "flex",
      alignItems: "center",
      WebkitTapHighlightColor: "transparent"
    },
    radio: function radio(_ref100) {
      var e = _ref100.theme,
          r = _ref100.size,
          t = _ref100.color;
      return Ll(Al({}, ae(e)), {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[0],
        border: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]),
        position: "relative",
        appearance: "none",
        width: _({
          sizes: de,
          size: r
        }),
        height: _({
          sizes: de,
          size: r
        }),
        borderRadius: _({
          sizes: de,
          size: r
        }),
        margin: 0,
        marginRight: e.spacing.sm,
        background: "red",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:checked": {
          background: w({
            theme: e,
            color: t,
            shade: e.colorScheme === "dark" ? 4 : 6
          }),
          borderColor: w({
            theme: e,
            color: t,
            shade: e.colorScheme === "dark" ? 4 : 6
          }),
          "&::before": {
            content: '""',
            display: "block",
            backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
            width: _({
              sizes: de,
              size: r
            }) / 2,
            height: _({
              sizes: de,
              size: r
            }) / 2,
            borderRadius: _({
              sizes: de,
              size: r
            }) / 2
          }
        },
        "&:disabled": {
          borderColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[4],
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[1],
          "&::before": {
            backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[4]
          }
        }
      });
    },
    label: function label(_ref101) {
      var e = _ref101.theme,
          r = _ref101.size;
      return Ll(Al({}, Q(e)), {
        display: "flex",
        alignItems: "center",
        fontSize: e.fontSizes[r] || e.fontSizes.md,
        lineHeight: "".concat(_({
          sizes: de,
          size: r
        }), "px"),
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        "&$labelDisabled": {
          color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5]
        }
      });
    }
  }),
      e_ = Object.defineProperty,
      et = Object.getOwnPropertySymbols,
      Hl = Object.prototype.hasOwnProperty,
      Vl = Object.prototype.propertyIsEnumerable,
      Bl = function Bl(e, r, t) {
    return r in e ? e_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      r_ = function r_(e, r) {
    for (var t in r || (r = {})) {
      Hl.call(r, t) && Bl(e, t, r[t]);
    }

    if (et) {
      var _iterator112 = _createForOfIteratorHelper(et(r)),
          _step112;

      try {
        for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
          var t = _step112.value;
          Vl.call(r, t) && Bl(e, t, r[t]);
        }
      } catch (err) {
        _iterator112.e(err);
      } finally {
        _iterator112.f();
      }
    }

    return e;
  },
      t_ = function t_(e, r) {
    var t = {};

    for (var o in e) {
      Hl.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && et) {
      var _iterator113 = _createForOfIteratorHelper(et(e)),
          _step113;

      try {
        for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
          var o = _step113.value;
          r.indexOf(o) < 0 && Vl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator113.e(err);
      } finally {
        _iterator113.f();
      }
    }

    return t;
  };

  function Bt(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = r.id,
        n = r.children,
        i = r.style,
        s = r.size,
        c = r.elementRef,
        d = r.title,
        f = r.disabled,
        p = r.color,
        u = t_(r, ["className", "themeOverride", "id", "children", "style", "size", "elementRef", "title", "disabled", "color"]);
    var g = Qg({
      color: p,
      size: s,
      theme: j(o)
    }),
        y = V.useId(a);
    return l.createElement("div", {
      "data-mantine-radio": !0,
      className: P(g.wrapper, t),
      style: i,
      title: d
    }, l.createElement("label", {
      className: P(g.label, _defineProperty({}, g.labelDisabled, f)),
      htmlFor: y
    }, l.createElement("input", r_({
      ref: c,
      className: g.radio,
      type: "radio",
      id: y,
      disabled: f
    }, u)), l.createElement("span", null, n)));
  }

  Bt.displayName = "@mantine/core/Radio";

  var o_ = L({
    wrapper: function wrapper(_ref102) {
      var e = _ref102.theme,
          r = _ref102.spacing,
          t = _ref102.variant;
      return {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: t === "vertical" ? "column" : "row",
        margin: _({
          sizes: e.spacing,
          size: r
        }) / 2 * -1,
        marginTop: _({
          sizes: e.spacing,
          size: r
        }) / 4 * (t === "vertical" ? 1 : -1),
        "& [data-mantine-radio]": {
          margin: _({
            sizes: e.spacing,
            size: r
          }) / 2,
          marginTop: t === "vertical" && _({
            sizes: e.spacing,
            size: r
          }) / 4,
          marginBottom: t === "vertical" && _({
            sizes: e.spacing,
            size: r
          }) / 4
        }
      };
    }
  }),
      a_ = Object.defineProperty,
      rt = Object.getOwnPropertySymbols,
      Fl = Object.prototype.hasOwnProperty,
      Wl = Object.prototype.propertyIsEnumerable,
      Zl = function Zl(e, r, t) {
    return r in e ? a_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      n_ = function n_(e, r) {
    for (var t in r || (r = {})) {
      Fl.call(r, t) && Zl(e, t, r[t]);
    }

    if (rt) {
      var _iterator114 = _createForOfIteratorHelper(rt(r)),
          _step114;

      try {
        for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
          var t = _step114.value;
          Wl.call(r, t) && Zl(e, t, r[t]);
        }
      } catch (err) {
        _iterator114.e(err);
      } finally {
        _iterator114.f();
      }
    }

    return e;
  },
      i_ = function i_(e, r) {
    var t = {};

    for (var o in e) {
      Fl.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && rt) {
      var _iterator115 = _createForOfIteratorHelper(rt(e)),
          _step115;

      try {
        for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
          var o = _step115.value;
          r.indexOf(o) < 0 && Wl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator115.e(err);
      } finally {
        _iterator115.f();
      }
    }

    return t;
  };

  var l_ = de;

  function Yl(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = r.name,
        n = r.children,
        i = r.value,
        s = r.defaultValue,
        c = r.onChange,
        _r$variant7 = r.variant,
        d = _r$variant7 === void 0 ? "horizontal" : _r$variant7,
        _r$spacing3 = r.spacing,
        f = _r$spacing3 === void 0 ? "md" : _r$spacing3,
        p = r.color,
        u = r.size,
        g = i_(r, ["className", "themeOverride", "name", "children", "value", "defaultValue", "onChange", "variant", "spacing", "color", "size"]);

    var _E$useState21 = E.useState(i || s || ""),
        _E$useState22 = _slicedToArray(_E$useState21, 2),
        y = _E$useState22[0],
        b = _E$useState22[1],
        S = typeof i == "string" ? i : y,
        I = o_({
      spacing: f,
      variant: d,
      theme: j(o)
    }),
        N = V.useId(a),
        k = function k(A) {
      b(A), typeof c == "function" && c(A);
    },
        x = E.Children.toArray(n).filter(function (A) {
      return A.type === Bt;
    }).map(function (A, q) {
      return E.cloneElement(A, {
        key: q,
        checked: S === A.props.value,
        name: N,
        color: p,
        size: u,
        onChange: function onChange(z) {
          return k(z.currentTarget.value);
        }
      });
    });

    return l.createElement(Se, n_({
      labelElement: "div"
    }, g), l.createElement("div", {
      role: "radiogroup",
      className: I.wrapper
    }, x));
  }

  Yl.displayName = "@mantine/core/RadioGroup";

  function s_(_ref103) {
    var e = _ref103.size,
        r = _ref103.thickness,
        t = _ref103.sum,
        o = _ref103.value,
        a = _ref103.root,
        n = _ref103.offset;
    var i = (e * .9 - r * 2) / 2,
        s = Math.PI * i * 2 / 100,
        c = a ? "".concat((100 - t) * s, ", ").concat(t * s) : "".concat(o * s, ", ").concat((100 - o) * s);
    return {
      strokeWidth: r,
      cx: e / 2,
      cy: e / 2,
      r: i,
      transform: a ? "scale(1, -1) translate(0, -".concat(e, ")") : null,
      strokeDasharray: c,
      strokeDashoffset: a ? 0 : n
    };
  }

  var c_ = Object.defineProperty,
      ql = Object.getOwnPropertySymbols,
      d_ = Object.prototype.hasOwnProperty,
      f_ = Object.prototype.propertyIsEnumerable,
      Ul = function Ul(e, r, t) {
    return r in e ? c_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      p_ = function p_(e, r) {
    for (var t in r || (r = {})) {
      d_.call(r, t) && Ul(e, t, r[t]);
    }

    if (ql) {
      var _iterator116 = _createForOfIteratorHelper(ql(r)),
          _step116;

      try {
        for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
          var t = _step116.value;
          f_.call(r, t) && Ul(e, t, r[t]);
        }
      } catch (err) {
        _iterator116.e(err);
      } finally {
        _iterator116.f();
      }
    }

    return e;
  };

  function Gl(_ref104) {
    var e = _ref104.size,
        r = _ref104.value,
        t = _ref104.offset,
        o = _ref104.sum,
        a = _ref104.thickness,
        n = _ref104.root,
        i = _ref104.color,
        s = _ref104.themeOverride;
    var c = j(s);
    return l.createElement("circle", p_({
      fill: "none",
      stroke: w({
        theme: c,
        color: i || (c.colorScheme === "dark" ? "dark" : "gray"),
        shade: i ? c.colorScheme === "dark" ? 7 : 5 : c.colorScheme === "dark" ? 4 : 2
      })
    }, s_({
      sum: o,
      size: e,
      thickness: a,
      value: r,
      offset: t,
      root: n
    })));
  }

  Gl.displayName = "@mantine/core/Curve";

  function u_(_ref105) {
    var e = _ref105.size,
        r = _ref105.thickness,
        t = _ref105.sections;
    var o = t.reduce(function (s, c) {
      return s + c.value;
    }, 0),
        a = Math.PI * ((e * .9 - r * 2) / 2) * 2;
    var n = a;
    var i = [];

    for (var s = 0; s < t.length; s += 1) {
      i.push({
        sum: o,
        offset: n,
        data: t[s],
        root: !1
      }), n -= t[s].value / 100 * a;
    }

    return i.push({
      sum: o,
      offset: n,
      data: null,
      root: !0
    }), i;
  }

  var v_ = Le.createUseStyles({
    wrapper: {
      position: "relative"
    },
    label: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }),
      m_ = Object.defineProperty,
      tt = Object.getOwnPropertySymbols,
      Kl = Object.prototype.hasOwnProperty,
      Xl = Object.prototype.propertyIsEnumerable,
      Jl = function Jl(e, r, t) {
    return r in e ? m_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Ql = function Ql(e, r) {
    for (var t in r || (r = {})) {
      Kl.call(r, t) && Jl(e, t, r[t]);
    }

    if (tt) {
      var _iterator117 = _createForOfIteratorHelper(tt(r)),
          _step117;

      try {
        for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
          var t = _step117.value;
          Xl.call(r, t) && Jl(e, t, r[t]);
        }
      } catch (err) {
        _iterator117.e(err);
      } finally {
        _iterator117.f();
      }
    }

    return e;
  },
      g_ = function g_(e, r) {
    var t = {};

    for (var o in e) {
      Kl.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && tt) {
      var _iterator118 = _createForOfIteratorHelper(tt(e)),
          _step118;

      try {
        for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
          var o = _step118.value;
          r.indexOf(o) < 0 && Xl.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator118.e(err);
      } finally {
        _iterator118.f();
      }
    }

    return t;
  };

  function es(e) {
    var r = e,
        t = r.label,
        o = r.sections,
        _r$size15 = r.size,
        a = _r$size15 === void 0 ? 120 : _r$size15,
        _r$thickness = r.thickness,
        n = _r$thickness === void 0 ? a / 10 : _r$thickness,
        i = r.themeOverride,
        s = r.className,
        c = r.style,
        d = g_(r, ["label", "sections", "size", "thickness", "themeOverride", "className", "style"]);
    var f = v_(),
        p = u_({
      size: a,
      thickness: n,
      sections: o
    }).map(function (u, g) {
      var y, b;
      return l.createElement(Gl, {
        key: g,
        value: (y = u.data) == null ? void 0 : y.value,
        size: a,
        thickness: n,
        sum: u.sum,
        offset: u.offset,
        color: (b = u.data) == null ? void 0 : b.color,
        root: u.root,
        themeOverride: i
      });
    });
    return l.createElement("div", Ql({
      style: Ql({
        width: a,
        height: a
      }, c),
      className: P(f.wrapper, s)
    }, d), l.createElement("svg", {
      width: a,
      height: a,
      style: {
        transform: "rotate(-90deg)"
      }
    }, p), t && l.createElement("div", {
      className: f.label,
      style: {
        right: n * 2,
        left: n * 2
      }
    }, t));
  }

  es.displayName = "@mantine/core/RingProgress";

  var __ = Object.defineProperty,
      y_ = Object.defineProperties,
      b_ = Object.getOwnPropertyDescriptors,
      rs = Object.getOwnPropertySymbols,
      O_ = Object.prototype.hasOwnProperty,
      h_ = Object.prototype.propertyIsEnumerable,
      ts = function ts(e, r, t) {
    return r in e ? __(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      os = function os(e, r) {
    for (var t in r || (r = {})) {
      O_.call(r, t) && ts(e, t, r[t]);
    }

    if (rs) {
      var _iterator119 = _createForOfIteratorHelper(rs(r)),
          _step119;

      try {
        for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
          var t = _step119.value;
          h_.call(r, t) && ts(e, t, r[t]);
        }
      } catch (err) {
        _iterator119.e(err);
      } finally {
        _iterator119.f();
      }
    }

    return e;
  },
      w_ = function w_(e, r) {
    return y_(e, b_(r));
  };

  var as = 4,
      ns = {
    xs: [3, 6],
    sm: [5, 10],
    md: [7, 14],
    lg: [9, 16],
    xl: [12, 20]
  };

  var P_ = L({
    input: function input(_ref106) {
      var e = _ref106.theme;
      return {
        height: 0,
        width: 0,
        position: "absolute",
        overflow: "hidden",
        whiteSpace: "nowrap",
        opacity: 0,
        "&:focus": {
          outline: "none",
          "& + $label": {
            outline: "none",
            boxShadow: "0 0 0 2px ".concat(e.colorScheme === "dark" ? e.colors.dark[9] : e.white, ", 0 0 0 4px ").concat(e.colors[e.primaryColor][5])
          },
          "&:focus:not(:focus-visible)": {
            "& + $label": {
              boxShadow: "none"
            }
          }
        }
      };
    },
    wrapper: function wrapper(_ref107) {
      var e = _ref107.theme,
          r = _ref107.fullWidth,
          t = _ref107.radius;
      return {
        position: "relative",
        display: r ? "flex" : "inline-flex",
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[8] : e.colors.gray[1],
        borderRadius: _({
          size: t,
          sizes: e.radius
        }),
        overflow: "hidden",
        padding: as
      };
    },
    controlActive: {
      borderLeftColor: "transparent !important",
      "& + $control": {
        borderLeftColor: "transparent !important"
      }
    },
    control: function control(_ref108) {
      var e = _ref108.theme,
          r = _ref108.reduceMotion,
          t = _ref108.transitionDuration,
          o = _ref108.transitionTimingFunction;
      return {
        position: "relative",
        boxSizing: "border-box",
        flex: 1,
        zIndex: 2,
        transition: "border-left-color ".concat(r ? 0 : t, "ms ").concat(o || e.transitionTimingFunction),
        "&:not(:first-of-type)": {
          borderLeft: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3])
        }
      };
    },
    label: function label(_ref109) {
      var e = _ref109.theme,
          r = _ref109.radius,
          t = _ref109.reduceMotion,
          o = _ref109.transitionDuration,
          a = _ref109.transitionTimingFunction,
          n = _ref109.size;
      return w_(os(os({}, ae(e)), Q(e)), {
        WebkitTapHighlightColor: "transparent",
        borderRadius: _({
          size: r,
          sizes: e.radius
        }),
        fontWeight: 500,
        fontSize: n in e.fontSizes ? e.fontSizes[n] : e.fontSizes.sm,
        cursor: "pointer",
        display: "block",
        textAlign: "center",
        padding: ns[n in ns ? n : "sm"],
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: e.colorScheme === "dark" ? e.colors.dark[1] : e.colors.gray[7],
        transition: "color ".concat(t ? 0 : o, "ms ").concat(a || e.transitionTimingFunction),
        "&:hover": {
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black
        }
      });
    },
    labelActive: function labelActive(_ref110) {
      var e = _ref110.theme,
          r = _ref110.color;
      return {
        "&, &:hover": {
          color: r in e.colors || e.colorScheme === "dark" ? e.white : e.black
        }
      };
    },
    active: function active(_ref111) {
      var e = _ref111.theme,
          r = _ref111.color,
          t = _ref111.radius,
          o = _ref111.reduceMotion,
          a = _ref111.transitionDuration,
          n = _ref111.transitionTimingFunction;
      return {
        boxSizing: "border-box",
        borderRadius: _({
          size: t,
          sizes: e.radius
        }),
        position: "absolute",
        top: 4,
        bottom: 4,
        zIndex: 1,
        boxShadow: r || e.colorScheme === "dark" ? "none" : e.shadows.xs,
        transition: "transform ".concat(o ? 0 : a, "ms ").concat(e.transitionTimingFunction, ", width ").concat(o ? 0 : a / 2, "ms ").concat(n || e.transitionTimingFunction),
        backgroundColor: r in e.colors ? re(w({
          theme: e,
          color: r,
          shade: 6
        }), e.colorScheme === "dark" ? .55 : 1) : e.colorScheme === "dark" ? e.colors.dark[5] : e.white
      };
    }
  }),
      $_ = Object.defineProperty,
      ot = Object.getOwnPropertySymbols,
      is = Object.prototype.hasOwnProperty,
      ls = Object.prototype.propertyIsEnumerable,
      ss = function ss(e, r, t) {
    return r in e ? $_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      S_ = function S_(e, r) {
    for (var t in r || (r = {})) {
      is.call(r, t) && ss(e, t, r[t]);
    }

    if (ot) {
      var _iterator120 = _createForOfIteratorHelper(ot(r)),
          _step120;

      try {
        for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
          var t = _step120.value;
          ls.call(r, t) && ss(e, t, r[t]);
        }
      } catch (err) {
        _iterator120.e(err);
      } finally {
        _iterator120.f();
      }
    }

    return e;
  },
      E_ = function E_(e, r) {
    var t = {};

    for (var o in e) {
      is.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && ot) {
      var _iterator121 = _createForOfIteratorHelper(ot(e)),
          _step121;

      try {
        for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
          var o = _step121.value;
          r.indexOf(o) < 0 && ls.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator121.e(err);
      } finally {
        _iterator121.f();
      }
    }

    return t;
  };

  function cs(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = r.data,
        n = r.name,
        i = r.value,
        s = r.onChange,
        c = r.color,
        d = r.fullWidth,
        _r$radius13 = r.radius,
        f = _r$radius13 === void 0 ? "sm" : _r$radius13,
        _r$size16 = r.size,
        p = _r$size16 === void 0 ? "sm" : _r$size16,
        _r$transitionDuration7 = r.transitionDuration,
        u = _r$transitionDuration7 === void 0 ? 200 : _r$transitionDuration7,
        g = r.transitionTimingFunction,
        y = E_(r, ["className", "themeOverride", "data", "name", "value", "onChange", "color", "fullWidth", "radius", "size", "transitionDuration", "transitionTimingFunction"]);

    var b = V.useReducedMotion(),
        S = j(o),
        _E$useState23 = E.useState(!1),
        _E$useState24 = _slicedToArray(_E$useState23, 2),
        I = _E$useState24[0],
        N = _E$useState24[1],
        k = P_({
      theme: S,
      size: p,
      fullWidth: d,
      color: c,
      radius: f,
      reduceMotion: b || !I,
      transitionDuration: u,
      transitionTimingFunction: g
    }),
        _E$useState25 = E.useState({
      width: 0,
      translate: 0
    }),
        _E$useState26 = _slicedToArray(_E$useState25, 2),
        x = _E$useState26[0],
        A = _E$useState26[1],
        q = V.useId(n),
        z = E.useRef({}),
        R = E.useRef(null);

    E.useEffect(function () {
      var F = new ResizeObserver(function () {
        if (i in z.current && R.current) {
          var v = z.current[i].getBoundingClientRect();
          A({
            width: v.width,
            translate: v.x - R.current.getBoundingClientRect().x - as
          }), I || setTimeout(function () {
            N(!0);
          }, 4);
        }
      });
      return F.observe(R.current), function () {
        return F.disconnect();
      };
    }, [i]);
    var B = a.map(function (F) {
      return l.createElement("div", {
        className: P(k.control, _defineProperty({}, k.controlActive, i === F.value)),
        key: F.value
      }, l.createElement("input", {
        "data-mantine-radio": !0,
        className: k.input,
        type: "radio",
        name: q,
        value: F.value,
        id: "".concat(q, "-").concat(F.value),
        checked: i === F.value,
        onChange: function onChange() {
          return s(F.value);
        }
      }), l.createElement("label", {
        "data-mantine-label": !0,
        className: P(k.label, _defineProperty({}, k.labelActive, i === F.value)),
        htmlFor: "".concat(q, "-").concat(F.value),
        ref: function ref(J) {
          z.current[F.value] = J;
        }
      }, F.label));
    });
    return l.createElement("div", S_({
      className: P(k.wrapper, t),
      ref: R
    }, y), !!i && l.createElement("span", {
      "data-mantine-active": !0,
      className: k.active,
      style: {
        width: x.width,
        transform: "translateX(".concat(x.translate, "px)")
      }
    }), B);
  }

  cs.displayName = "@mantine/core/SegmentedControl";

  var x_ = Object.defineProperty,
      ds = Object.getOwnPropertySymbols,
      C_ = Object.prototype.hasOwnProperty,
      I_ = Object.prototype.propertyIsEnumerable,
      fs = function fs(e, r, t) {
    return r in e ? x_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      N_ = function N_(e, r) {
    for (var t in r || (r = {})) {
      C_.call(r, t) && fs(e, t, r[t]);
    }

    if (ds) {
      var _iterator122 = _createForOfIteratorHelper(ds(r)),
          _step122;

      try {
        for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
          var t = _step122.value;
          I_.call(r, t) && fs(e, t, r[t]);
        }
      } catch (err) {
        _iterator122.e(err);
      } finally {
        _iterator122.f();
      }
    }

    return e;
  };

  function k_(e) {
    return l.createElement("svg", N_({
      width: "20",
      height: "20",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), l.createElement("path", {
      d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }));
  }

  var j_ = Object.defineProperty,
      R_ = Object.defineProperties,
      T_ = Object.getOwnPropertyDescriptors,
      at = Object.getOwnPropertySymbols,
      ps = Object.prototype.hasOwnProperty,
      us = Object.prototype.propertyIsEnumerable,
      vs = function vs(e, r, t) {
    return r in e ? j_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      ms = function ms(e, r) {
    for (var t in r || (r = {})) {
      ps.call(r, t) && vs(e, t, r[t]);
    }

    if (at) {
      var _iterator123 = _createForOfIteratorHelper(at(r)),
          _step123;

      try {
        for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
          var t = _step123.value;
          us.call(r, t) && vs(e, t, r[t]);
        }
      } catch (err) {
        _iterator123.e(err);
      } finally {
        _iterator123.f();
      }
    }

    return e;
  },
      gs = function gs(e, r) {
    return R_(e, T_(r));
  },
      z_ = function z_(e, r) {
    var t = {};

    for (var o in e) {
      ps.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && at) {
      var _iterator124 = _createForOfIteratorHelper(at(e)),
          _step124;

      try {
        for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
          var o = _step124.value;
          r.indexOf(o) < 0 && us.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator124.e(err);
      } finally {
        _iterator124.f();
      }
    }

    return t;
  };

  function _s(e) {
    var r = e,
        t = r.id,
        o = r.className,
        a = r.required,
        n = r.label,
        i = r.error,
        s = r.style,
        c = r.data,
        d = r.placeholder,
        f = r.themeOverride,
        p = r.wrapperProps,
        u = r.inputStyle,
        g = r.description,
        y = r.elementRef,
        b = r.defaultValue,
        S = r.onChange,
        I = r.value,
        N = z_(r, ["id", "className", "required", "label", "error", "style", "data", "placeholder", "themeOverride", "wrapperProps", "inputStyle", "description", "elementRef", "defaultValue", "onChange", "value"]);
    var k = j(f),
        x = V.useId(t),
        A = c.map(function (z) {
      return l.createElement("option", {
        key: z.value,
        value: z.value,
        disabled: z.disabled
      }, z.label);
    });
    d && A.unshift(l.createElement("option", {
      key: "placeholder",
      value: "",
      disabled: !0,
      hidden: !0
    }, d));
    var q = l.createElement(k_, {
      style: {
        color: i ? k.colors.red[6] : k.colors.gray[6]
      }
    });
    return l.createElement(Se, gs(ms({}, p), {
      required: a,
      id: x,
      label: n,
      error: i,
      className: o,
      style: s,
      themeOverride: f,
      description: g
    }), l.createElement($e, gs(ms({}, N), {
      onChange: S,
      component: "select",
      invalid: !!i,
      style: u,
      "aria-required": a,
      elementRef: y,
      id: x,
      inputStyle: u,
      rightSection: q,
      rightSectionProps: {
        style: {
          pointerEvents: "none"
        }
      },
      required: a,
      themeOverride: f,
      value: I === null ? "" : I
    }), A));
  }

  _s.displayName = "@mantine/core/Select";

  var D_ = L({
    spoiler: {
      position: "relative"
    },
    content: function content(_ref112) {
      var e = _ref112.transitionDuration;
      return {
        overflow: "hidden",
        transitionProperty: "max-height",
        transitionTimingFunction: "ease",
        transitionDuration: e || 0
      };
    }
  }),
      M_ = Object.defineProperty,
      nt = Object.getOwnPropertySymbols,
      ys = Object.prototype.hasOwnProperty,
      bs = Object.prototype.propertyIsEnumerable,
      Os = function Os(e, r, t) {
    return r in e ? M_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      A_ = function A_(e, r) {
    for (var t in r || (r = {})) {
      ys.call(r, t) && Os(e, t, r[t]);
    }

    if (nt) {
      var _iterator125 = _createForOfIteratorHelper(nt(r)),
          _step125;

      try {
        for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
          var t = _step125.value;
          bs.call(r, t) && Os(e, t, r[t]);
        }
      } catch (err) {
        _iterator125.e(err);
      } finally {
        _iterator125.f();
      }
    }

    return e;
  },
      L_ = function L_(e, r) {
    var t = {};

    for (var o in e) {
      ys.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && nt) {
      var _iterator126 = _createForOfIteratorHelper(nt(e)),
          _step126;

      try {
        for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
          var o = _step126.value;
          r.indexOf(o) < 0 && bs.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator126.e(err);
      } finally {
        _iterator126.f();
      }
    }

    return t;
  };

  function hs(e) {
    var r = e,
        t = r.className,
        o = r.children,
        _r$maxHeight = r.maxHeight,
        a = _r$maxHeight === void 0 ? 100 : _r$maxHeight,
        n = r.hideLabel,
        i = r.showLabel,
        s = r.themeOverride,
        _r$transitionDuration8 = r.transitionDuration,
        c = _r$transitionDuration8 === void 0 ? 200 : _r$transitionDuration8,
        d = r.controlRef,
        f = L_(r, ["className", "children", "maxHeight", "hideLabel", "showLabel", "themeOverride", "transitionDuration", "controlRef"]);

    var p = D_({
      transitionDuration: !V.useReducedMotion() && c,
      theme: j(s)
    }),
        _E$useState27 = E.useState(!1),
        _E$useState28 = _slicedToArray(_E$useState27, 2),
        u = _E$useState28[0],
        g = _E$useState28[1],
        _E$useState29 = E.useState(!1),
        _E$useState30 = _slicedToArray(_E$useState29, 2),
        y = _E$useState30[0],
        b = _E$useState30[1],
        S = E.useRef(null),
        I = u ? n : i;

    return E.useEffect(function () {
      b(a < S.current.clientHeight);
    }, [a, o]), l.createElement("div", A_({
      className: P(p.spoiler, t)
    }, f), l.createElement("div", {
      className: p.content,
      style: {
        maxHeight: u ? S.current && S.current.clientHeight : a
      }
    }, l.createElement("div", {
      ref: S
    }, o)), y && l.createElement(St, {
      variant: "link",
      elementRef: d,
      onClick: function onClick() {
        return g(function (N) {
          return !N;
        });
      },
      themeOverride: s
    }, I));
  }

  hs.displayName = "@mantine/core/Spoiler";

  var H_ = Object.defineProperty,
      V_ = Object.defineProperties,
      B_ = Object.getOwnPropertyDescriptors,
      ws = Object.getOwnPropertySymbols,
      F_ = Object.prototype.hasOwnProperty,
      W_ = Object.prototype.propertyIsEnumerable,
      Ps = function Ps(e, r, t) {
    return r in e ? H_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      $s = function $s(e, r) {
    for (var t in r || (r = {})) {
      F_.call(r, t) && Ps(e, t, r[t]);
    }

    if (ws) {
      var _iterator127 = _createForOfIteratorHelper(ws(r)),
          _step127;

      try {
        for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
          var t = _step127.value;
          W_.call(r, t) && Ps(e, t, r[t]);
        }
      } catch (err) {
        _iterator127.e(err);
      } finally {
        _iterator127.f();
      }
    }

    return e;
  },
      Ss = function Ss(e, r) {
    return V_(e, B_(r));
  };

  var Ft = {
    xs: 14,
    sm: 18,
    md: 22,
    lg: 28,
    xl: 34
  },
      it = {
    xs: 28,
    sm: 36,
    md: 42,
    lg: 54,
    xl: 66
  },
      Es = {
    xs: 10,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 26
  },
      Z_ = Object.keys(Ft).reduce(function (e, r) {
    return e[r] = {
      width: it[r],
      height: Ft[r]
    }, e;
  }, {});

  var Y_ = L({
    wrapper: {
      display: "flex",
      alignItems: "center"
    },
    switch: function _switch(_ref113) {
      var e = _ref113.size,
          r = _ref113.radius,
          t = _ref113.theme,
          o = _ref113.reduceMotion,
          a = _ref113.color;

      var n = _({
        size: e,
        sizes: Es
      }),
          i = _({
        size: r,
        sizes: t.radius
      });

      return Ss($s({}, ae(t)), {
        WebkitTapHighlightColor: "transparent",
        position: "relative",
        borderRadius: i,
        backgroundColor: t.colorScheme === "dark" ? t.colors.dark[4] : t.colors.gray[2],
        border: "1px solid ".concat(t.colorScheme === "dark" ? t.colors.dark[4] : t.colors.gray[3]),
        height: _({
          size: e,
          sizes: Ft
        }),
        width: _({
          size: e,
          sizes: it
        }),
        minWidth: _({
          size: e,
          sizes: it
        }),
        padding: [0, 2],
        margin: 0,
        transitionProperty: "background-color, border-color",
        transitionTimingFunction: t.transitionTimingFunction,
        transitionDuration: o ? "1ms" : "150ms",
        boxSizing: "border-box",
        appearance: "none",
        display: "flex",
        alignItems: "center",
        "&::before": {
          borderRadius: i,
          boxSizing: "border-box",
          content: "''",
          display: "block",
          backgroundColor: t.white,
          height: n,
          width: n,
          border: "1px solid ".concat(t.colorScheme === "dark" ? t.white : t.colors.gray[3]),
          transition: o ? "none" : "transform 150ms ".concat(t.transitionTimingFunction)
        },
        "&:checked": {
          backgroundColor: w({
            theme: t,
            color: a,
            shade: 6
          }),
          borderColor: w({
            theme: t,
            color: a,
            shade: 6
          }),
          "&::before": {
            transform: "translateX(".concat(_({
              size: e,
              sizes: it
            }) - _({
              size: e,
              sizes: Es
            }) - 6, "px)"),
            borderColor: t.white
          }
        },
        "&:disabled": {
          backgroundColor: t.colorScheme === "dark" ? t.colors.dark[4] : t.colors.gray[2],
          borderColor: t.colorScheme === "dark" ? t.colors.dark[4] : t.colors.gray[2],
          cursor: "not-allowed",
          "&::before": {
            borderColor: t.colorScheme === "dark" ? t.colors.dark[4] : t.colors.gray[2],
            backgroundColor: t.colorScheme === "dark" ? t.colors.dark[3] : t.colors.gray[0]
          }
        }
      });
    },
    label: function label(_ref114) {
      var e = _ref114.theme,
          r = _ref114.size;
      return Ss($s({}, Q(e)), {
        WebkitTapHighlightColor: "transparent",
        fontSize: _({
          size: r,
          sizes: e.fontSizes
        }),
        fontFamily: e.fontFamily,
        paddingLeft: e.spacing.sm,
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black
      });
    }
  }),
      q_ = Object.defineProperty,
      U_ = Object.defineProperties,
      G_ = Object.getOwnPropertyDescriptors,
      lt = Object.getOwnPropertySymbols,
      xs = Object.prototype.hasOwnProperty,
      Cs = Object.prototype.propertyIsEnumerable,
      Is = function Is(e, r, t) {
    return r in e ? q_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Ns = function Ns(e, r) {
    for (var t in r || (r = {})) {
      xs.call(r, t) && Is(e, t, r[t]);
    }

    if (lt) {
      var _iterator128 = _createForOfIteratorHelper(lt(r)),
          _step128;

      try {
        for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
          var t = _step128.value;
          Cs.call(r, t) && Is(e, t, r[t]);
        }
      } catch (err) {
        _iterator128.e(err);
      } finally {
        _iterator128.f();
      }
    }

    return e;
  },
      K_ = function K_(e, r) {
    return U_(e, G_(r));
  },
      X_ = function X_(e, r) {
    var t = {};

    for (var o in e) {
      xs.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && lt) {
      var _iterator129 = _createForOfIteratorHelper(lt(e)),
          _step129;

      try {
        for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
          var o = _step129.value;
          r.indexOf(o) < 0 && Cs.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator129.e(err);
      } finally {
        _iterator129.f();
      }
    }

    return t;
  };

  var J_ = Z_;

  function ks(e) {
    var r = e,
        t = r.className,
        o = r.color,
        a = r.label,
        n = r.id,
        i = r.style,
        _r$size17 = r.size,
        s = _r$size17 === void 0 ? "md" : _r$size17,
        _r$radius14 = r.radius,
        c = _r$radius14 === void 0 ? "xl" : _r$radius14,
        d = r.themeOverride,
        f = r.wrapperProps,
        p = r.inputStyle,
        u = r.inputClassName,
        g = r.elementRef,
        y = r.children,
        b = X_(r, ["className", "color", "label", "id", "style", "size", "radius", "themeOverride", "wrapperProps", "inputStyle", "inputClassName", "elementRef", "children"]);
    var S = Y_({
      size: s,
      color: o,
      radius: c,
      reduceMotion: V.useReducedMotion(),
      theme: j(d)
    }),
        I = V.useId(n);
    return l.createElement("div", Ns({
      className: P(S.wrapper, t),
      style: i
    }, f), l.createElement("input", K_(Ns({}, b), {
      id: I,
      ref: g,
      type: "checkbox",
      className: P(S.switch, u),
      style: p
    })), a && l.createElement("label", {
      className: S.label,
      htmlFor: I
    }, a));
  }

  ks.displayName = "@mantine/core/Switch";

  var Q_ = Object.defineProperty,
      ey = Object.defineProperties,
      ry = Object.getOwnPropertyDescriptors,
      js = Object.getOwnPropertySymbols,
      ty = Object.prototype.hasOwnProperty,
      oy = Object.prototype.propertyIsEnumerable,
      Rs = function Rs(e, r, t) {
    return r in e ? Q_(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      ay = function ay(e, r) {
    for (var t in r || (r = {})) {
      ty.call(r, t) && Rs(e, t, r[t]);
    }

    if (js) {
      var _iterator130 = _createForOfIteratorHelper(js(r)),
          _step130;

      try {
        for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
          var t = _step130.value;
          oy.call(r, t) && Rs(e, t, r[t]);
        }
      } catch (err) {
        _iterator130.e(err);
      } finally {
        _iterator130.f();
      }
    }

    return e;
  },
      ny = function ny(e, r) {
    return ey(e, ry(r));
  },
      iy = L({
    striped: {},
    hover: {},
    table: function table(_ref115) {
      var e = _ref115.theme,
          r = _ref115.captionSide;
      return ny(ay({}, Q(e)), {
        width: "100%",
        borderCollapse: "collapse",
        captionSide: r,
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        lineHeight: e.lineHeight,
        "& caption": {
          marginTop: r === "top" ? 0 : e.spacing.xs,
          marginBottom: r === "bottom" ? 0 : e.spacing.xs,
          fontSize: e.fontSizes.sm,
          color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6]
        },
        "& thead tr th, & tfoot tr th": {
          textAlign: "left",
          fontWeight: "bold",
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[7],
          fontSize: 14,
          padding: [7, 10]
        },
        "& thead tr th": {
          borderBottom: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3])
        },
        "& tfoot tr th": {
          borderTop: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3])
        },
        "& tbody tr td": {
          padding: [7, 10],
          borderBottom: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3]),
          fontSize: 14
        },
        "& tbody tr:last-of-type td": {
          borderBottom: "none"
        },
        "&$striped tbody tr:nth-of-type(odd)": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0]
        },
        "&$hover tbody tr:hover": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[1]
        }
      });
    }
  }),
      ly = Object.defineProperty,
      sy = Object.defineProperties,
      cy = Object.getOwnPropertyDescriptors,
      st = Object.getOwnPropertySymbols,
      Ts = Object.prototype.hasOwnProperty,
      zs = Object.prototype.propertyIsEnumerable,
      Ds = function Ds(e, r, t) {
    return r in e ? ly(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      dy = function dy(e, r) {
    for (var t in r || (r = {})) {
      Ts.call(r, t) && Ds(e, t, r[t]);
    }

    if (st) {
      var _iterator131 = _createForOfIteratorHelper(st(r)),
          _step131;

      try {
        for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
          var t = _step131.value;
          zs.call(r, t) && Ds(e, t, r[t]);
        }
      } catch (err) {
        _iterator131.e(err);
      } finally {
        _iterator131.f();
      }
    }

    return e;
  },
      fy = function fy(e, r) {
    return sy(e, cy(r));
  },
      py = function py(e, r) {
    var t = {};

    for (var o in e) {
      Ts.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && st) {
      var _iterator132 = _createForOfIteratorHelper(st(e)),
          _step132;

      try {
        for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
          var o = _step132.value;
          r.indexOf(o) < 0 && zs.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator132.e(err);
      } finally {
        _iterator132.f();
      }
    }

    return t;
  };

  function Ms(e) {
    var _P11;

    var r = e,
        t = r.className,
        o = r.children,
        _r$striped2 = r.striped,
        a = _r$striped2 === void 0 ? !1 : _r$striped2,
        _r$highlightOnHover = r.highlightOnHover,
        n = _r$highlightOnHover === void 0 ? !1 : _r$highlightOnHover,
        i = r.themeOverride,
        _r$captionSide = r.captionSide,
        s = _r$captionSide === void 0 ? "top" : _r$captionSide,
        c = py(r, ["className", "children", "striped", "highlightOnHover", "themeOverride", "captionSide"]);
    var d = iy({
      captionSide: s,
      theme: j(i)
    });
    return l.createElement("table", fy(dy({}, c), {
      className: P(d.table, (_P11 = {}, _defineProperty(_P11, d.striped, a), _defineProperty(_P11, d.hover, n), _P11), t)
    }), o);
  }

  Ms.displayName = "@mantine/core/Table";

  function Wt(e) {
    return null;
  }

  Wt.displayName = "@mantine/core/Tab";

  var uy = Object.defineProperty,
      vy = Object.defineProperties,
      my = Object.getOwnPropertyDescriptors,
      As = Object.getOwnPropertySymbols,
      gy = Object.prototype.hasOwnProperty,
      _y = Object.prototype.propertyIsEnumerable,
      Ls = function Ls(e, r, t) {
    return r in e ? uy(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Hs = function Hs(e, r) {
    for (var t in r || (r = {})) {
      gy.call(r, t) && Ls(e, t, r[t]);
    }

    if (As) {
      var _iterator133 = _createForOfIteratorHelper(As(r)),
          _step133;

      try {
        for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
          var t = _step133.value;
          _y.call(r, t) && Ls(e, t, r[t]);
        }
      } catch (err) {
        _iterator133.e(err);
      } finally {
        _iterator133.f();
      }
    }

    return e;
  },
      yy = function yy(e, r) {
    return vy(e, my(r));
  },
      by = L({
    tabActive: {},
    tab: function tab(_ref116) {
      var e = _ref116.theme;
      return yy(Hs(Hs({}, Q(e)), ae(e)), {
        WebkitTapHighlightColor: "transparent",
        boxSizing: "border-box",
        display: "block",
        height: 40,
        backgroundColor: "transparent",
        border: 0,
        padding: [0, e.spacing.md],
        fontSize: e.fontSizes.sm,
        cursor: "pointer",
        "&:disabled": {
          cursor: "not-allowed",
          color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5]
        }
      });
    },
    defaultVariant: function defaultVariant(_ref117) {
      var e = _ref117.theme,
          r = _ref117.reduceMotion,
          t = _ref117.color;
      return {
        transition: r ? "none" : "border-color 150ms ease, color 150ms ease",
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        borderBottom: "2px solid transparent",
        "&$tabActive": {
          color: w({
            theme: e,
            color: t,
            shade: e.colorScheme === "dark" ? 4 : 6
          }),
          borderBottomColor: w({
            theme: e,
            color: t,
            shade: e.colorScheme === "dark" ? 4 : 6
          })
        }
      };
    },
    outlineVariant: function outlineVariant(_ref118) {
      var e = _ref118.theme;
      return {
        borderTopRightRadius: e.radius.sm,
        borderTopLeftRadius: e.radius.sm,
        border: "1px solid transparent",
        borderBottom: 0,
        color: e.colorScheme === "dark" ? e.colors.dark[1] : e.colors.gray[7],
        "&$tabActive": {
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
          borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
          background: e.colorScheme === "dark" ? e.colors.dark[7] : e.white
        }
      };
    },
    tabInner: {
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      lineHeight: 1,
      height: 40
    },
    tabIcon: function tabIcon(_ref119) {
      var e = _ref119.theme;
      return {
        "&:not(:only-child)": {
          marginRight: e.spacing.xs
        },
        "& *": {
          display: "block"
        }
      };
    }
  }),
      Oy = Object.defineProperty,
      hy = Object.defineProperties,
      wy = Object.getOwnPropertyDescriptors,
      ct = Object.getOwnPropertySymbols,
      Vs = Object.prototype.hasOwnProperty,
      Bs = Object.prototype.propertyIsEnumerable,
      Fs = function Fs(e, r, t) {
    return r in e ? Oy(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Ws = function Ws(e, r) {
    for (var t in r || (r = {})) {
      Vs.call(r, t) && Fs(e, t, r[t]);
    }

    if (ct) {
      var _iterator134 = _createForOfIteratorHelper(ct(r)),
          _step134;

      try {
        for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
          var t = _step134.value;
          Bs.call(r, t) && Fs(e, t, r[t]);
        }
      } catch (err) {
        _iterator134.e(err);
      } finally {
        _iterator134.f();
      }
    }

    return e;
  },
      Py = function Py(e, r) {
    return hy(e, wy(r));
  },
      Zs = function Zs(e, r) {
    var t = {};

    for (var o in e) {
      Vs.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && ct) {
      var _iterator135 = _createForOfIteratorHelper(ct(e)),
          _step135;

      try {
        for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
          var o = _step135.value;
          r.indexOf(o) < 0 && Bs.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator135.e(err);
      } finally {
        _iterator135.f();
      }
    }

    return t;
  };

  function Ys(e) {
    var r = e,
        t = r.themeOverride,
        o = r.active,
        a = r.elementRef,
        n = r.tabProps,
        i = r.color,
        s = r.className,
        _r$variant8 = r.variant,
        c = _r$variant8 === void 0 ? "default" : _r$variant8,
        d = Zs(r, ["themeOverride", "active", "elementRef", "tabProps", "color", "className", "variant"]);
    var f = n,
        p = f.label,
        u = f.icon,
        g = f.color,
        y = f.elementRef,
        b = Zs(f, ["label", "icon", "color", "elementRef"]),
        S = by({
      reduceMotion: V.useReducedMotion(),
      color: g || i,
      theme: j(t)
    });
    return l.createElement("button", Py(Ws(Ws({}, d), b), {
      "data-mantine-tab": !0,
      tabIndex: o ? 0 : -1,
      className: P(S.tab, S["".concat(c, "Variant")], _defineProperty({}, S.tabActive, o), s),
      type: "button",
      role: "tab",
      "aria-selected": o,
      ref: V.useMergedRef(a, n.elementRef)
    }), l.createElement("div", {
      className: S.tabInner
    }, u && l.createElement("div", {
      "data-mantine-icon": !0,
      className: S.tabIcon
    }, u), p && l.createElement("div", {
      "data-mantine-label": !0
    }, p)));
  }

  Ys.displayName = "@mantine/core/TabControl";

  var $y = L({
    tabsInner: {},
    default: function _default(_ref120) {
      var e = _ref120.theme;
      return {
        borderBottom: "2px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2]),
        "& $tabsInner": {
          marginBottom: -2
        }
      };
    },
    outline: function outline(_ref121) {
      var e = _ref121.theme;
      return {
        borderBottom: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2]),
        "& $tabsInner": {
          marginBottom: -1
        }
      };
    },
    body: function body(_ref122) {
      var e = _ref122.theme;
      return {
        paddingTop: e.spacing.sm
      };
    }
  }),
      Sy = Object.defineProperty,
      Ey = Object.defineProperties,
      xy = Object.getOwnPropertyDescriptors,
      dt = Object.getOwnPropertySymbols,
      qs = Object.prototype.hasOwnProperty,
      Us = Object.prototype.propertyIsEnumerable,
      Gs = function Gs(e, r, t) {
    return r in e ? Sy(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      ft = function ft(e, r) {
    for (var t in r || (r = {})) {
      qs.call(r, t) && Gs(e, t, r[t]);
    }

    if (dt) {
      var _iterator136 = _createForOfIteratorHelper(dt(r)),
          _step136;

      try {
        for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
          var t = _step136.value;
          Us.call(r, t) && Gs(e, t, r[t]);
        }
      } catch (err) {
        _iterator136.e(err);
      } finally {
        _iterator136.f();
      }
    }

    return e;
  },
      Zt = function Zt(e, r) {
    return Ey(e, xy(r));
  },
      Cy = function Cy(e, r) {
    var t = {};

    for (var o in e) {
      qs.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && dt) {
      var _iterator137 = _createForOfIteratorHelper(dt(e)),
          _step137;

      try {
        for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
          var o = _step137.value;
          r.indexOf(o) < 0 && Us.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator137.e(err);
      } finally {
        _iterator137.f();
      }
    }

    return t;
  };

  function Iy(e, r, t) {
    return Math.min(Math.max(e, r), t);
  }

  function Ny(e, r) {
    for (var t = e - 1; t >= 0; t -= 1) {
      if (!r[t].props.disabled) return t;
    }

    return e;
  }

  function ky(e, r) {
    for (var t = e + 1; t < r.length; t += 1) {
      if (!r[t].props.disabled) return t;
    }

    return e;
  }

  function jy(e) {
    for (var r = 0; r < e.length; r += 1) {
      if (!e[r].props.disabled) return r;
    }

    return -1;
  }

  function Ks(e) {
    var r = e,
        t = r.children,
        o = r.initialTab,
        a = r.themeOverride,
        n = r.active,
        _r$position4 = r.position,
        i = _r$position4 === void 0 ? "left" : _r$position4,
        _r$grow4 = r.grow,
        s = _r$grow4 === void 0 ? !1 : _r$grow4,
        c = r.onTabChange,
        d = r.color,
        _r$variant9 = r.variant,
        f = _r$variant9 === void 0 ? "default" : _r$variant9,
        p = r.groupProps,
        u = r.tabsListProps,
        g = Cy(r, ["children", "initialTab", "themeOverride", "active", "position", "grow", "onTabChange", "color", "variant", "groupProps", "tabsListProps"]);

    var y = $y({
      theme: j(a)
    }),
        b = E.useRef({}),
        S = l.Children.toArray(t).filter(function (R) {
      return R.type === Wt;
    }),
        _E$useState31 = E.useState(typeof o == "number" ? o : jy(S)),
        _E$useState32 = _slicedToArray(_E$useState31, 2),
        I = _E$useState32[0],
        N = _E$useState32[1],
        k = Iy(typeof n == "number" ? n : I, 0, S.length - 1),
        x = function x(R) {
      N(R), typeof c == "function" && c(R);
    },
        A = function A(R) {
      if (R.nativeEvent.code === "ArrowRight") {
        var B = ky(k, S);
        x(B), b.current[B].focus();
      }

      if (R.nativeEvent.code === "ArrowLeft") {
        var _B = Ny(k, S);

        x(_B), b.current[_B].focus();
      }
    },
        q = S.map(function (R, B) {
      return l.createElement(Ys, Zt(ft({}, R.props), {
        key: B,
        active: k === B,
        tabProps: R.props,
        onKeyDown: A,
        color: d,
        variant: f,
        elementRef: function elementRef(F) {
          b.current[B] = F;
        },
        onClick: function onClick() {
          return k !== B && x(B);
        }
      }));
    }),
        z = S[k].props.children;

    return l.createElement("div", ft({}, g), l.createElement("div", Zt(ft({}, u), {
      className: P(y[f], u == null ? void 0 : u.className)
    }), l.createElement(Cr, Zt(ft({}, p), {
      className: P(y.tabsInner, p == null ? void 0 : p.className),
      role: "tablist",
      "aria-orientation": "horizontal",
      spacing: 0,
      position: i,
      grow: s
    }), q)), z && l.createElement("div", {
      "data-mantine-tab-content": !0,
      className: y.body,
      role: "tabpanel"
    }, z));
  }

  Ks.displayName = "@mantine/core/Tabs";

  var Ry = typeof document != "undefined" ? E.useLayoutEffect : E.useEffect,
      Ty = function Ty(r) {
    var t = E.useRef(r);
    return Ry(function () {
      t.current = r;
    }), t;
  },
      Xs = function Xs(r, t) {
    if (typeof r == "function") {
      r(t);
      return;
    }

    r.current = t;
  },
      zy = function zy(r, t) {
    var o = E.useRef();
    return E.useCallback(function (a) {
      r.current = a, o.current && Xs(o.current, null), o.current = t, !!t && Xs(t, a);
    }, [t]);
  },
      Js = {
    "min-height": "0",
    "max-height": "none",
    height: "0",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    "z-index": "-1000",
    top: "0",
    right: "0"
  },
      Qs = function Qs(r) {
    Object.keys(Js).forEach(function (t) {
      r.style.setProperty(t, Js[t], "important");
    });
  },
      le = null,
      Dy = function Dy(r, t) {
    var o = r.scrollHeight;
    return t.sizingStyle.boxSizing === "border-box" ? o + t.borderSize : o - t.paddingSize;
  };

  function My(e, r, t, o) {
    t === void 0 && (t = 1), o === void 0 && (o = Infinity), le || (le = document.createElement("textarea"), le.setAttribute("tab-index", "-1"), le.setAttribute("aria-hidden", "true"), Qs(le)), le.parentNode === null && document.body.appendChild(le);
    var a = e.paddingSize,
        n = e.borderSize,
        i = e.sizingStyle,
        s = i.boxSizing;
    Object.keys(i).forEach(function (u) {
      var g = u;
      le.style[g] = i[g];
    }), Qs(le), le.value = r;
    var c = Dy(le, e);
    le.value = "x";
    var d = le.scrollHeight - a,
        f = d * t;
    s === "border-box" && (f = f + a + n), c = Math.max(f, c);
    var p = d * o;
    return s === "border-box" && (p = p + a + n), c = Math.min(p, c), [c, d];
  }

  var ec = function ec() {},
      Ay = function Ay(r, t) {
    return r.reduce(function (o, a) {
      return o[a] = t[a], o;
    }, {});
  },
      Ly = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "tabSize", "textIndent", "textRendering", "textTransform", "width"],
      Hy = typeof document != "undefined" ? !!document.documentElement.currentStyle : !1,
      Vy = function Vy(r) {
    var t = window.getComputedStyle(r);
    if (t === null) return null;
    var o = Ay(Ly, t),
        a = o.boxSizing;
    if (a === "") return null;
    Hy && a === "border-box" && (o.width = parseFloat(o.width) + parseFloat(o.borderRightWidth) + parseFloat(o.borderLeftWidth) + parseFloat(o.paddingRight) + parseFloat(o.paddingLeft) + "px");
    var n = parseFloat(o.paddingBottom) + parseFloat(o.paddingTop),
        i = parseFloat(o.borderBottomWidth) + parseFloat(o.borderTopWidth);
    return {
      sizingStyle: o,
      paddingSize: n,
      borderSize: i
    };
  },
      By = function By(r) {
    var t = Ty(r);
    E.useLayoutEffect(function () {
      var o = function o(n) {
        t.current(n);
      };

      return window.addEventListener("resize", o), function () {
        window.removeEventListener("resize", o);
      };
    }, []);
  },
      Fy = function Fy(r, t) {
    var o = r.cacheMeasurements,
        a = r.maxRows,
        n = r.minRows,
        i = r.onChange,
        s = i === void 0 ? ec : i,
        c = r.onHeightChange,
        d = c === void 0 ? ec : c,
        f = dn(r, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);

    if (process.env.NODE_ENV !== "production" && f.style) {
      if ("maxHeight" in f.style) throw new Error("Using `style.maxHeight` for <TextareaAutosize/> is not supported. Please use `maxRows`.");
      if ("minHeight" in f.style) throw new Error("Using `style.minHeight` for <TextareaAutosize/> is not supported. Please use `minRows`.");
    }

    var p = f.value !== void 0,
        u = E.useRef(null),
        g = zy(u, t),
        y = E.useRef(0),
        b = E.useRef(),
        S = function S() {
      var k = u.current,
          x = o && b.current ? b.current : Vy(k);

      if (!!x) {
        b.current = x;
        var A = My(x, k.value || k.placeholder || "x", n, a),
            q = A[0],
            z = A[1];
        y.current !== q && (y.current = q, k.style.setProperty("height", q + "px", "important"), d(q, {
          rowHeight: z
        }));
      }
    },
        I = function I(k) {
      p || S(), s(k);
    };

    return typeof document != "undefined" && (E.useLayoutEffect(S), By(S)), E.createElement("textarea", Et({}, f, {
      onChange: I,
      ref: g
    }));
  },
      Wy = E.forwardRef(Fy),
      Zy = Object.defineProperty,
      Yy = Object.defineProperties,
      qy = Object.getOwnPropertyDescriptors,
      pt = Object.getOwnPropertySymbols,
      rc = Object.prototype.hasOwnProperty,
      tc = Object.prototype.propertyIsEnumerable,
      oc = function oc(e, r, t) {
    return r in e ? Zy(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      De = function De(e, r) {
    for (var t in r || (r = {})) {
      rc.call(r, t) && oc(e, t, r[t]);
    }

    if (pt) {
      var _iterator138 = _createForOfIteratorHelper(pt(r)),
          _step138;

      try {
        for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
          var t = _step138.value;
          tc.call(r, t) && oc(e, t, r[t]);
        }
      } catch (err) {
        _iterator138.e(err);
      } finally {
        _iterator138.f();
      }
    }

    return e;
  },
      Uy = function Uy(e, r) {
    return Yy(e, qy(r));
  },
      Gy = function Gy(e, r) {
    var t = {};

    for (var o in e) {
      rc.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && pt) {
      var _iterator139 = _createForOfIteratorHelper(pt(e)),
          _step139;

      try {
        for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
          var o = _step139.value;
          r.indexOf(o) < 0 && tc.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator139.e(err);
      } finally {
        _iterator139.f();
      }
    }

    return t;
  };

  function ac(e) {
    var r = e,
        _r$autosize = r.autosize,
        t = _r$autosize === void 0 ? !1 : _r$autosize,
        o = r.maxRows,
        a = r.minRows,
        n = r.label,
        i = r.error,
        s = r.description,
        c = r.id,
        d = r.className,
        f = r.required,
        p = r.themeOverride,
        u = r.style,
        g = r.wrapperProps,
        y = r.inputStyle,
        b = r.elementRef,
        S = Gy(r, ["autosize", "maxRows", "minRows", "label", "error", "description", "id", "className", "required", "themeOverride", "style", "wrapperProps", "inputStyle", "elementRef"]);
    var I = V.useId(c),
        N = j(p);
    return l.createElement(Se, De({
      label: n,
      error: i,
      id: I,
      description: s,
      required: f,
      style: u,
      className: d
    }, g), t ? l.createElement($e, De({
      required: f,
      component: Wy,
      invalid: !!i,
      maxRows: o,
      minRows: a,
      id: I,
      elementRef: b,
      inputStyle: Uy(De({
        paddingTop: N.spacing.xs,
        paddingBottom: N.spacing.xs
      }, y), {
        height: void 0
      })
    }, S)) : l.createElement($e, De({
      component: "textarea",
      required: f,
      id: I,
      invalid: !!i,
      rows: a,
      elementRef: b,
      inputStyle: De({
        paddingTop: N.spacing.xs,
        paddingBottom: N.spacing.xs
      }, y)
    }, S)));
  }

  ac.displayName = "@mantine/core/Textarea";
  var nc = {
    xs: 16,
    sm: 20,
    md: 26,
    lg: 32,
    xl: 40
  };

  var Ky = L({
    light: function light(_ref123) {
      var e = _ref123.theme,
          r = _ref123.color;
      return {
        color: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 3 : 9
        }),
        backgroundColor: re(w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 9 : 1
        }), e.colorScheme === "dark" ? .3 : 1)
      };
    },
    filled: function filled(_ref124) {
      var e = _ref124.theme,
          r = _ref124.color;
      return {
        color: e.colorScheme === "dark" ? w({
          theme: e,
          color: r,
          shade: 0
        }) : e.white,
        backgroundColor: re(w({
          theme: e,
          color: r,
          shade: 7
        }), e.colorScheme === "dark" ? .65 : 1)
      };
    },
    themeIcon: function themeIcon(_ref125) {
      var e = _ref125.theme,
          r = _ref125.size,
          t = _ref125.radius;

      var o = _({
        size: r,
        sizes: nc
      });

      return {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        width: o,
        height: o,
        borderRadius: _({
          size: t,
          sizes: e.radius
        })
      };
    }
  }),
      Xy = Object.defineProperty,
      ut = Object.getOwnPropertySymbols,
      ic = Object.prototype.hasOwnProperty,
      lc = Object.prototype.propertyIsEnumerable,
      sc = function sc(e, r, t) {
    return r in e ? Xy(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Jy = function Jy(e, r) {
    for (var t in r || (r = {})) {
      ic.call(r, t) && sc(e, t, r[t]);
    }

    if (ut) {
      var _iterator140 = _createForOfIteratorHelper(ut(r)),
          _step140;

      try {
        for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
          var t = _step140.value;
          lc.call(r, t) && sc(e, t, r[t]);
        }
      } catch (err) {
        _iterator140.e(err);
      } finally {
        _iterator140.f();
      }
    }

    return e;
  },
      Qy = function Qy(e, r) {
    var t = {};

    for (var o in e) {
      ic.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && ut) {
      var _iterator141 = _createForOfIteratorHelper(ut(e)),
          _step141;

      try {
        for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
          var o = _step141.value;
          r.indexOf(o) < 0 && lc.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator141.e(err);
      } finally {
        _iterator141.f();
      }
    }

    return t;
  };

  var eb = nc;

  function cc(e) {
    var r = e,
        t = r.className,
        _r$size18 = r.size,
        o = _r$size18 === void 0 ? "md" : _r$size18,
        _r$radius15 = r.radius,
        a = _r$radius15 === void 0 ? "sm" : _r$radius15,
        _r$variant10 = r.variant,
        n = _r$variant10 === void 0 ? "filled" : _r$variant10,
        i = r.color,
        s = r.children,
        c = r.themeOverride,
        d = Qy(r, ["className", "size", "radius", "variant", "color", "children", "themeOverride"]);
    var f = Ky({
      theme: j(c),
      radius: a,
      color: i,
      size: o
    });
    return l.createElement("div", Jy({
      className: P(f.themeIcon, f[n], t)
    }, d), s);
  }

  cc.displayName = "@mantine/core/ThemeIcon";

  var rb = Object.defineProperty,
      tb = Object.defineProperties,
      ob = Object.getOwnPropertyDescriptors,
      dc = Object.getOwnPropertySymbols,
      ab = Object.prototype.hasOwnProperty,
      nb = Object.prototype.propertyIsEnumerable,
      fc = function fc(e, r, t) {
    return r in e ? rb(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      ib = function ib(e, r) {
    for (var t in r || (r = {})) {
      ab.call(r, t) && fc(e, t, r[t]);
    }

    if (dc) {
      var _iterator142 = _createForOfIteratorHelper(dc(r)),
          _step142;

      try {
        for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
          var t = _step142.value;
          nb.call(r, t) && fc(e, t, r[t]);
        }
      } catch (err) {
        _iterator142.e(err);
      } finally {
        _iterator142.f();
      }
    }

    return e;
  },
      lb = function lb(e, r) {
    return tb(e, ob(r));
  },
      sb = L({
    title: function title(_ref126) {
      var e = _ref126.theme,
          r = _ref126.element;
      return lb(ib({}, Q(e)), {
        fontFamily: e.headings.fontFamily,
        fontWeight: e.headings.fontWeight,
        fontSize: e.headings.sizes[r].fontSize,
        lineHeight: e.headings.sizes[r].lineHeight,
        margin: 0,
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        "@media (max-width: 755px)": {
          fontSize: typeof e.headings.sizes[r].fontSize == "number" && e.headings.sizes[r].fontSize / 1.3
        }
      });
    }
  }),
      cb = Object.defineProperty,
      vt = Object.getOwnPropertySymbols,
      pc = Object.prototype.hasOwnProperty,
      uc = Object.prototype.propertyIsEnumerable,
      vc = function vc(e, r, t) {
    return r in e ? cb(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      db = function db(e, r) {
    for (var t in r || (r = {})) {
      pc.call(r, t) && vc(e, t, r[t]);
    }

    if (vt) {
      var _iterator143 = _createForOfIteratorHelper(vt(r)),
          _step143;

      try {
        for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
          var t = _step143.value;
          uc.call(r, t) && vc(e, t, r[t]);
        }
      } catch (err) {
        _iterator143.e(err);
      } finally {
        _iterator143.f();
      }
    }

    return e;
  },
      fb = function fb(e, r) {
    var t = {};

    for (var o in e) {
      pc.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && vt) {
      var _iterator144 = _createForOfIteratorHelper(vt(e)),
          _step144;

      try {
        for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
          var o = _step144.value;
          r.indexOf(o) < 0 && uc.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator144.e(err);
      } finally {
        _iterator144.f();
      }
    }

    return t;
  };

  function mc(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        _r$order = r.order,
        a = _r$order === void 0 ? 1 : _r$order,
        n = r.children,
        i = fb(r, ["className", "themeOverride", "order", "children"]);
    if (![1, 2, 3, 4, 5, 6].includes(a)) return null;
    var s = "h".concat(a),
        c = sb({
      theme: j(o),
      element: s
    });
    return l.createElement(s, db({
      className: P(c.title, t)
    }, i), n);
  }

  mc.displayName = "@mantine/core/Title";

  var pb = Object.defineProperty,
      ub = Object.defineProperties,
      vb = Object.getOwnPropertyDescriptors,
      gc = Object.getOwnPropertySymbols,
      mb = Object.prototype.hasOwnProperty,
      gb = Object.prototype.propertyIsEnumerable,
      _c = function _c(e, r, t) {
    return r in e ? pb(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Me = function Me(e, r) {
    for (var t in r || (r = {})) {
      mb.call(r, t) && _c(e, t, r[t]);
    }

    if (gc) {
      var _iterator145 = _createForOfIteratorHelper(gc(r)),
          _step145;

      try {
        for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
          var t = _step145.value;
          gb.call(r, t) && _c(e, t, r[t]);
        }
      } catch (err) {
        _iterator145.e(err);
      } finally {
        _iterator145.f();
      }
    }

    return e;
  },
      Ae = function Ae(e, r) {
    return ub(e, vb(r));
  };

  var yc = {
    "&$center": {
      left: "50%",
      transform: "translateX(-50%)"
    },
    "&$end": {
      right: 0
    },
    "&$start": {
      left: 0
    }
  },
      bc = {
    "&$center": {
      top: "50%",
      transform: "translateY(-50%)"
    },
    "&$end": {
      bottom: 0
    },
    "&$start": {
      top: 0
    }
  };

  var _b = L({
    withArrow: {},
    center: {},
    start: {},
    end: {},
    wrapper: {
      position: "relative",
      display: "inline-block"
    },
    tooltipInner: function tooltipInner(_ref127) {
      var e = _ref127.theme,
          r = _ref127.color;
      return Ae(Me({}, Q(e)), {
        backgroundColor: w({
          theme: e,
          color: r,
          shade: e.colorScheme === "dark" ? 3 : 9
        }),
        lineHeight: e.lineHeight,
        fontSize: e.fontSizes.sm,
        borderRadius: e.radius.sm,
        padding: [e.spacing.xs / 2, e.spacing.xs],
        color: e.colorScheme === "dark" ? e.colors.dark[9] : e.white,
        position: "relative",
        "&$withArrow::before": {
          display: "block",
          position: "absolute",
          content: '""',
          width: 0,
          height: 0,
          borderStyle: "solid"
        }
      });
    },
    tooltip: {
      display: "inline-block",
      position: "absolute"
    },
    top: function top(_ref128) {
      var e = _ref128.gutter,
          r = _ref128.theme,
          t = _ref128.color,
          o = _ref128.arrowSize;
      return Ae(Me({}, yc), {
        bottom: "calc(100% + ".concat(e, "px)"),
        "& $tooltipInner$withArrow::before": {
          top: "100%",
          borderWidth: "".concat(o, "px ").concat(o, "px 0 ").concat(o, "px"),
          borderColor: "".concat(w({
            theme: r,
            color: t,
            shade: r.colorScheme === "dark" ? 3 : 9
          }), " transparent transparent transparent")
        },
        "&$center $tooltipInner$withArrow::before": {
          left: "calc(50% - ".concat(o, "px)")
        },
        "&$start $tooltipInner$withArrow::before": {
          left: o
        },
        "&$end $tooltipInner$withArrow::before": {
          right: o
        }
      });
    },
    bottom: function bottom(_ref129) {
      var e = _ref129.gutter,
          r = _ref129.theme,
          t = _ref129.color,
          o = _ref129.arrowSize;
      return Ae(Me({}, yc), {
        top: "calc(100% + ".concat(e, "px)"),
        "& $tooltipInner$withArrow::before": {
          bottom: "100%",
          borderWidth: "0 ".concat(o, "px ").concat(o, "px ").concat(o, "px"),
          borderColor: "transparent transparent ".concat(w({
            theme: r,
            color: t,
            shade: r.colorScheme === "dark" ? 3 : 9
          }), " transparent")
        },
        "&$center $tooltipInner$withArrow::before": {
          left: "calc(50% - ".concat(o, "px)")
        },
        "&$start $tooltipInner$withArrow::before": {
          left: o
        },
        "&$end $tooltipInner$withArrow::before": {
          right: o
        }
      });
    },
    right: function right(_ref130) {
      var e = _ref130.gutter,
          r = _ref130.theme,
          t = _ref130.color,
          o = _ref130.arrowSize;
      return Ae(Me({}, bc), {
        left: "calc(100% + ".concat(e, "px)"),
        "& $tooltipInner$withArrow::before": {
          right: "100%",
          borderWidth: "".concat(o, "px ").concat(o, "px ").concat(o, "px 0"),
          borderColor: "transparent ".concat(w({
            theme: r,
            color: t,
            shade: r.colorScheme === "dark" ? 3 : 9
          }), " transparent transparent")
        },
        "&$center $tooltipInner$withArrow::before": {
          top: "calc(50% - ".concat(o, "px)")
        },
        "&$start $tooltipInner$withArrow::before": {
          top: o
        },
        "&$end $tooltipInner$withArrow::before": {
          bottom: o
        }
      });
    },
    left: function left(_ref131) {
      var e = _ref131.gutter,
          r = _ref131.theme,
          t = _ref131.color,
          o = _ref131.arrowSize;
      return Ae(Me({}, bc), {
        right: "calc(100% + ".concat(e, "px)"),
        "& $tooltipInner$withArrow::before": {
          left: "100%",
          borderWidth: "".concat(o, "px 0 ").concat(o, "px ").concat(o, "px"),
          borderColor: "transparent transparent transparent ".concat(w({
            theme: r,
            color: t,
            shade: r.colorScheme === "dark" ? 3 : 9
          }))
        },
        "&$center $tooltipInner$withArrow::before": {
          top: "calc(50% - ".concat(o, "px)")
        },
        "&$start $tooltipInner$withArrow::before": {
          top: o
        },
        "&$end $tooltipInner$withArrow::before": {
          bottom: o
        }
      });
    }
  }),
      yb = Object.defineProperty,
      bb = Object.defineProperties,
      Ob = Object.getOwnPropertyDescriptors,
      mt = Object.getOwnPropertySymbols,
      Oc = Object.prototype.hasOwnProperty,
      hc = Object.prototype.propertyIsEnumerable,
      wc = function wc(e, r, t) {
    return r in e ? yb(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Pc = function Pc(e, r) {
    for (var t in r || (r = {})) {
      Oc.call(r, t) && wc(e, t, r[t]);
    }

    if (mt) {
      var _iterator146 = _createForOfIteratorHelper(mt(r)),
          _step146;

      try {
        for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
          var t = _step146.value;
          hc.call(r, t) && wc(e, t, r[t]);
        }
      } catch (err) {
        _iterator146.e(err);
      } finally {
        _iterator146.f();
      }
    }

    return e;
  },
      hb = function hb(e, r) {
    return bb(e, Ob(r));
  },
      wb = function wb(e, r) {
    var t = {};

    for (var o in e) {
      Oc.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && mt) {
      var _iterator147 = _createForOfIteratorHelper(mt(e)),
          _step147;

      try {
        for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
          var o = _step147.value;
          r.indexOf(o) < 0 && hc.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator147.e(err);
      } finally {
        _iterator147.f();
      }
    }

    return t;
  };

  function $c(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = r.label,
        n = r.children,
        i = r.opened,
        _r$delay = r.delay,
        s = _r$delay === void 0 ? 0 : _r$delay,
        _r$gutter4 = r.gutter,
        c = _r$gutter4 === void 0 ? 5 : _r$gutter4,
        _r$color6 = r.color,
        d = _r$color6 === void 0 ? "gray" : _r$color6,
        _r$disabled3 = r.disabled,
        f = _r$disabled3 === void 0 ? !1 : _r$disabled3,
        _r$withArrow2 = r.withArrow,
        p = _r$withArrow2 === void 0 ? !1 : _r$withArrow2,
        _r$arrowSize2 = r.arrowSize,
        u = _r$arrowSize2 === void 0 ? 3 : _r$arrowSize2,
        _r$position5 = r.position,
        g = _r$position5 === void 0 ? "top" : _r$position5,
        _r$placement2 = r.placement,
        y = _r$placement2 === void 0 ? "center" : _r$placement2,
        _r$transition5 = r.transition,
        b = _r$transition5 === void 0 ? "slide-up" : _r$transition5,
        _r$transitionDuration9 = r.transitionDuration,
        S = _r$transitionDuration9 === void 0 ? 100 : _r$transitionDuration9,
        _r$zIndex8 = r.zIndex,
        I = _r$zIndex8 === void 0 ? 1e3 : _r$zIndex8,
        N = r.transitionTimingFunction,
        _r$width2 = r.width,
        k = _r$width2 === void 0 ? "auto" : _r$width2,
        _r$wrapLines = r.wrapLines,
        x = _r$wrapLines === void 0 ? !1 : _r$wrapLines,
        _r$allowPointerEvents = r.allowPointerEvents,
        A = _r$allowPointerEvents === void 0 ? !1 : _r$allowPointerEvents,
        q = r.elementRef,
        z = r.tooltipRef,
        R = r.tooltipId,
        B = wb(r, ["className", "themeOverride", "label", "children", "opened", "delay", "gutter", "color", "disabled", "withArrow", "arrowSize", "position", "placement", "transition", "transitionDuration", "zIndex", "transitionTimingFunction", "width", "wrapLines", "allowPointerEvents", "elementRef", "tooltipRef", "tooltipId"]);

    var F = j(o),
        J = _b({
      theme: F,
      color: d,
      gutter: c,
      arrowSize: u
    }),
        v = E.useRef(),
        _E$useState33 = E.useState(!1),
        _E$useState34 = _slicedToArray(_E$useState33, 2),
        O = _E$useState34[0],
        h = _E$useState34[1],
        C = (typeof i == "boolean" ? i : O) && !f,
        $ = V.useReducedMotion() ? 0 : S,
        H = function H() {
      window.clearTimeout(v.current), h(!0);
    },
        M = function M() {
      s !== 0 ? v.current = window.setTimeout(function () {
        h(!1);
      }, s) : h(!1);
    };

    return l.createElement("div", Pc({
      className: P(J.wrapper, t),
      ref: z
    }, B), l.createElement(we, {
      mounted: C,
      transition: b,
      duration: $,
      timingFunction: N
    }, function (D) {
      return l.createElement("div", {
        id: R,
        role: "tooltip",
        style: {
          zIndex: I,
          width: k,
          pointerEvents: A ? "all" : "none"
        },
        "data-mantine-tooltip": !0,
        className: P(J.tooltip, J[y], J[g]),
        ref: z
      }, l.createElement("div", {
        "data-mantine-tooltip-inner": !0,
        className: P(J.tooltipInner, _defineProperty({}, J.withArrow, p)),
        style: hb(Pc({}, D), {
          whiteSpace: x ? "normal" : "nowrap"
        })
      }, a));
    }), l.createElement("div", {
      onMouseEnter: H,
      onMouseLeave: M
    }, n));
  }

  $c.displayName = "@mantine/core/Tooltip";

  var Pb = Object.defineProperty,
      $b = Object.defineProperties,
      Sb = Object.getOwnPropertyDescriptors,
      Sc = Object.getOwnPropertySymbols,
      Eb = Object.prototype.hasOwnProperty,
      xb = Object.prototype.propertyIsEnumerable,
      Ec = function Ec(e, r, t) {
    return r in e ? Pb(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      gt = function gt(e, r) {
    for (var t in r || (r = {})) {
      Eb.call(r, t) && Ec(e, t, r[t]);
    }

    if (Sc) {
      var _iterator148 = _createForOfIteratorHelper(Sc(r)),
          _step148;

      try {
        for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
          var t = _step148.value;
          xb.call(r, t) && Ec(e, t, r[t]);
        }
      } catch (err) {
        _iterator148.e(err);
      } finally {
        _iterator148.f();
      }
    }

    return e;
  },
      _t = function _t(e, r) {
    return $b(e, Sb(r));
  },
      Cb = L({
    innerHtml: function innerHtml(_ref132) {
      var e = _ref132.theme;
      var r = Object.keys(e.headings.sizes).reduce(function (t, o) {
        return t["& ".concat(o)] = _t(gt({
          fontFamily: e.headings.fontFamily,
          fontWeight: e.headings.fontWeight,
          marginTop: e.spacing.lg * e.headings.sizes[o].lineHeight,
          marginBottom: e.spacing.xs * e.headings.sizes[o].lineHeight
        }, e.headings.sizes[o]), {
          "@media (max-width: 755px)": {
            fontSize: typeof e.headings.sizes[o].fontSize == "number" && e.headings.sizes[o].fontSize / 1.3
          }
        }), t;
      }, {});
      return _t(gt(_t(gt({}, Q(e)), {
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        lineHeight: e.lineHeight,
        fontSize: e.fontSizes.md,
        "@media (max-width: 755px)": {
          fontSize: e.fontSizes.sm
        }
      }), r), {
        "& img": {
          maxWidth: "100%",
          marginBottom: e.spacing.xs
        },
        "& p": {
          marginTop: 0,
          marginBottom: e.spacing.sm
        },
        "& hr": {
          marginTop: e.spacing.md,
          marginBottom: e.spacing.sm,
          borderBottom: 0,
          borderLeft: 0,
          borderRight: 0,
          borderTop: "1px dashed ".concat(e.colors.gray[e.colorScheme === "dark" ? 4 : 6])
        },
        "& a": _t(gt({}, ae(e)), {
          color: e.colors[e.primaryColor][e.colorScheme === "dark" ? 4 : 6],
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline"
          }
        }),
        "& pre": {
          padding: e.spacing.xs,
          lineHeight: e.lineHeight,
          margin: 0,
          marginTop: e.spacing.md,
          marginBottom: e.spacing.md,
          overflowX: "auto",
          fontFamily: e.fontFamilyMonospace,
          fontSize: e.fontSizes.sm,
          borderRadius: e.radius.sm,
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[8] : e.colors.gray[0]
        },
        "& code": {
          lineHeight: e.lineHeight,
          padding: [1, e.spacing.xs / 2],
          borderRadius: e.radius.sm,
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[9] : e.colors.gray[0],
          fontFamily: e.fontFamilyMonospace,
          fontSize: e.fontSizes.xs,
          border: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[9] : e.colors.gray[3])
        },
        "& ul, & ol": {
          marginBottom: e.spacing.md,
          paddingLeft: e.spacing.lg * 2,
          "& li": {
            marginTop: e.spacing.xs
          }
        },
        "& table": {
          width: "100%",
          borderCollapse: "collapse",
          captionSide: "bottom",
          marginBottom: e.spacing.md,
          "& caption": {
            marginTop: e.spacing.xs,
            fontSize: e.fontSizes.sm,
            color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6]
          },
          "& th": {
            textAlign: "left",
            fontWeight: "bold",
            color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[7],
            fontSize: 14,
            padding: [7, 10]
          },
          "& thead th": {
            borderBottom: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3])
          },
          "& tfoot th": {
            borderTop: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3])
          },
          "& td": {
            padding: [7, 10],
            borderBottom: "1px solid ".concat(e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3]),
            fontSize: 14
          },
          "& tr:last-of-type td": {
            borderBottom: "none"
          }
        },
        "& blockquote": {
          fontSize: e.fontSizes.lg,
          lineHeight: e.lineHeight,
          margin: [e.spacing.md, 0],
          borderTopRightRadius: e.radius.sm,
          borderBottomRightRadius: e.radius.sm,
          padding: [e.spacing.md, e.spacing.lg],
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0],
          color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
          borderLeft: "3px solid ".concat(w({
            theme: e,
            color: e.primaryColor,
            shade: e.colorScheme === "dark" ? 4 : 6
          })),
          "& cite": {
            display: "block",
            fontSize: e.fontSizes.sm,
            marginTop: e.spacing.xs,
            color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6],
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        }
      });
    }
  }),
      Ib = Object.defineProperty,
      yt = Object.getOwnPropertySymbols,
      xc = Object.prototype.hasOwnProperty,
      Cc = Object.prototype.propertyIsEnumerable,
      Ic = function Ic(e, r, t) {
    return r in e ? Ib(e, r, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[r] = t;
  },
      Nb = function Nb(e, r) {
    for (var t in r || (r = {})) {
      xc.call(r, t) && Ic(e, t, r[t]);
    }

    if (yt) {
      var _iterator149 = _createForOfIteratorHelper(yt(r)),
          _step149;

      try {
        for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
          var t = _step149.value;
          Cc.call(r, t) && Ic(e, t, r[t]);
        }
      } catch (err) {
        _iterator149.e(err);
      } finally {
        _iterator149.f();
      }
    }

    return e;
  },
      kb = function kb(e, r) {
    var t = {};

    for (var o in e) {
      xc.call(e, o) && r.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (e != null && yt) {
      var _iterator150 = _createForOfIteratorHelper(yt(e)),
          _step150;

      try {
        for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
          var o = _step150.value;
          r.indexOf(o) < 0 && Cc.call(e, o) && (t[o] = e[o]);
        }
      } catch (err) {
        _iterator150.e(err);
      } finally {
        _iterator150.f();
      }
    }

    return t;
  };

  function Nc(e) {
    var r = e,
        t = r.className,
        o = r.themeOverride,
        a = kb(r, ["className", "themeOverride"]);
    var n = Cb({
      theme: j(o)
    });
    return l.createElement("div", Nb({
      className: P(n.innerHtml, t)
    }, a));
  }

  Nc.displayName = "@mantine/core/TypographyStylesProvider", m.ACTION_ICON_SIZES = sd, m.AVAILABLE_TRANSITIONS = Du, m.AVATAR_SIZES = ef, m.ActionIcon = pe, m.Alert = No, m.Anchor = ho, m.Avatar = Ao, m.BADGE_SIZES = _f, m.BURGER_SIZES = Kf, m.BUTTON_SIZES = pp, m.Badge = Zo, m.Blockquote = Qo, m.Breadcrumbs = oa, m.Burger = ca, m.Button = St, m.CHECKBOX_SIZES = zp, m.CONTAINER_SIZES = iu, m.Card = wa, m.CardsGrid = ya, m.Center = xa, m.Checkbox = La, m.Code = Ya, m.Col = Ln, m.ColorSwatch = Qa, m.Container = an, m.DEFAULT_THEME = He, m.DIVIDER_SIZES = Rn, m.DRAWER_SIZES = Xu, m.Divider = Pe, m.Drawer = Cn, m.ElementsGroup = Cr, m.Grid = Wn, m.Group = Cr, m.GroupedTransition = wr, m.HR_SIZES = Rn, m.Highlight = Jn, m.Hr = Pe, m.Image = ii, m.Input = $e, m.InputWrapper = Se, m.Kbd = Oi, m.LOADER_SIZES = $i, m.Loader = Dr, m.LoadingOverlay = Ci, m.MANTINE_COLORS = jc, m.MANTINE_SIZES = Rc, m.MENU_SIZES = Km, m.MODAL_SIZES = ng, m.MantineProvider = to, m.Menu = Yi, m.MenuBody = Ht, m.MenuItem = me, m.Modal = el, m.Notification = nl, m.NumberInput = vl, m.Overlay = Ie, m.PROGRESS_SIZES = qg, m.Paper = ce, m.PasswordInput = hl, m.Popover = Nl, m.Portal = cr, m.Progress = zl, m.RADIO_SIZES = l_, m.Radio = Bt, m.RadioGroup = Yl, m.RingProgress = es, m.SWITCH_SIZES = J_, m.SegmentedControl = cs, m.Select = _s, m.Spoiler = hs, m.Switch = ks, m.THEME_ICON_SIZES = eb, m.Tab = Wt, m.Table = Ms, m.Tabs = Ks, m.Text = ne, m.TextInput = Yr, m.Textarea = ac, m.ThemeIcon = cc, m.Title = mc, m.Tooltip = $c, m.Transition = we, m.TypographyStylesProvider = Nc, m.createMemoStyles = L, m.getFocusStyles = ae, m.getFontStyles = Q, m.getSizeValue = _, m.getThemeColor = w, m.hexToRgba = re, m.theming = Qt, m.useMantineTheme = j, Object.defineProperty(m, "__esModule", {
    value: !0
  });
});